import React, {unstable_Profiler as Profiler} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import {AppBar, Button, Divider, IconButton, Typography} from "@material-ui/core";
import {
  baseStyles,
  BORDER_RADIUS,
  changeNavColor,
  CONTENT_MAX_WIDTH,
  DRAWER_WIDTH,
  FIELD_SPACE,
  FONT_WEIGHT_MEDIUM,
  FORM_OUTER_MAX_WIDTH,
  PREVIEW_HEIGHT,
  PREVIEW_HEIGHT_MD,
  PREVIEW_HEIGHT_XS,
  PREVIEW_WIDTH,
  PREVIEW_WIDTH_MD,
  PREVIEW_WIDTH_XS,
  TOOLBAR_HEIGHT,
  TOOLBAR_HEIGHT_XS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import Space from "../commons/Space";
import {
  deleteActivityPlanRecharge,
  fetchActivity,
  manageActivity,
  resetManageActivityErrMsg
} from "../../actions/activitiesActions";
import ValueHelper from "../../utils/ValueHelper";
import {cloneDeep, get} from "lodash";
import ManageActivityBasicInfo from "./ManageActivityBasicInfo";
import DateTimeHelper from "../../utils/DateTimeHelper";
import constants from "../../constants";
import {
  ColorAccent,
  ColorBackground,
  ColorBackgroundXS,
  ColorCard,
  ColorCardXS,
  ColorClear,
  ColorDividerDark,
  ColorGreen,
  ColorNav,
  ColorNegative,
  ColorOrange,
  ColorPreviewBorder,
  ColorSecondary,
  ColorSeparator,
  ColorStatusDialog,
  ColorSubTitle,
  ColorTableBorder,
  ColorTheme,
  ColorTitle,
  ColorUIChecker2,
  ColorWhite
} from "src/styles/Colors";
import ManageActivityQuestion from "./ManageActivityQuestion";
import ManageActivityRewards from "src/js/components/activity/ManageActivityRewards";
import {getArrayOfIds} from "../../utils/utils";
import HeaderTitleView from "../commons/HeaderTitleView";
import Paper from "@material-ui/core/Paper";
import ManageActivityUsage from "./ManageActivityUsage";
import BackIcon from "@material-ui/icons/ArrowBack";
import NextIcon from "@material-ui/icons/ArrowForward";
import ManageActivityTargeting from "./ManageActivityTargeting";
import zIndex from "@material-ui/core/styles/zIndex";
import ManageActivityCustomization from "./ManageActivityCustomization";
import ManageActivityCharge from "./ManageActivityCharge";
import ManageActivityType from "./ManageActivityType";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ManageActivityVoucher from "./ManageActivityVoucher";
import QRCode from "react-qr-code";
import ManageActivityPreview from "./ManageActivityPreview";
import TextView from "../commons/TextView";
import ManageActivityPlan from "./ManageActivityPlan";
import ManageActivityCTA1 from "./ManageActivityCTA1";
import DialogView from "../commons/DialogView";
import ActivityHelper, {isCurrentPlanEnded, isCurrentPlanNoPlan, isCurrentPlanPaid} from "../../utils/ActivityHelper";
import ManageActivityQuestions from "./ManageActivityQuestions";
import ActivityView from "../activityComponent/ActivityView";
import ActivityPreviewView from "../commons/ActivityPreviewView";
import ManageActivityCTA2 from "./ManageActivityCTA2";
import {APP_URI} from "../../utils/services";
import {
  CTA_TITLES,
  STATE_ENABLED,
  STATE_ORDER_CREATED,
  STATE_ORDER_PAYMENT_CANCELLED,
  STATE_ORDER_PAYMENT_FAILED
} from "../../constants/ApiConstants";
import ManageActivityRecur from "./ManageActivityRecur";
import ManageActivityReferralRewards from "./ManageActivityReferralRewards";
import ManageActivityDefaults from "./ManageActivityDefaults";
import ApiHelper, {isUserImageDummy} from "../../utils/ApiHelper";
import ManageActivityElements from "./ManageActivityElements";
import {
  getPathForActivity,
  getRedirectSearch,
  navBackOrExit,
  navigateToPlay,
  PathCampaignManage,
  PathJoin,
  PathPaymentStart
} from "../routes/NavHelper";
import ManageActivityPrediction from "./ManageActivityPrediction";
import ManageActivityIdentifyLocation from "./ManageActivityIdentifyLocation";
import ManageReelFront from "./ManageReelFront";
import ManageReelSubPosts from "./ManageReelSubPosts";
import AppUtils, {areNavLocationsEqual, getNavLocationFromUrl, isUserPrivileged} from "../../utils/AppUtils";
import {ImageIcon, locString, locStringA, SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";
import {RadiusView} from "src/res/Radius";
import {logInfo} from "src/js/utils/AppLog";
import FieldSpace from "src/js/components/commons/FieldSpace";
import ManageActivityCTA from "src/js/components/activity/ManageActivityCTA";
import {FontWeightMedium} from "src/res/FontWeight";
import device from "current-device";
import ManageActivityPayment from "src/js/components/activity/ManageActivityPayment";
import PaymentBill, {getQRCodeData} from "src/js/payment/PaymentBill";
import {toPng} from "html-to-image";
import ManageActivityOpinion from "src/js/components/activity/ManageActivityOpinion";
import ManageActivityInternalQuestion from "src/js/components/activity/ManageActivityInternalQuestion";
import ScrollView from "src/js/components/commons/ScrollView";
import AppIcon, {IconCrossCircle, IconHide, IconShow} from "src/js/components/commons/AppIcon";
import ProgressLoaderBig from "src/js/components/commons/ProgressLoaderBig";
import {clearObjectUrls} from "src/js/components/commons/SingleFilePicker";
import TouchableOpacity from "src/js/components/commons/TouchableOpacity";
import JoinNow from "src/js/components/JoinNow";
import {updateUserInfo, updateUserWallet} from "src/js/actions/appActions";
import ManageActivityUserInfo from "src/js/components/activity/ManageActivityUserInfo";
import ManageSlides from "src/js/components/activity/ManageSlides";

export const PLAN_TYPE_PAID = 3;
export const BOTTOM_TAB_HEIGHT = 72;
export const BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY = 54;

const useStyles = (theme) => ({
  stepLabel: {
    backgroundColor: ColorAccent,
    padding: 4,
    paddingRight: 12,
    borderRadius: BORDER_RADIUS
  },
  viewTabBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  viewBarTopManage: {
    height: TOOLBAR_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    width: '100%',
    flexDirection: 'row',
    backgroundColor: ColorBackground,
    [theme.breakpoints.down('xs')]: {
      height: TOOLBAR_HEIGHT_XS,
      backgroundColor: ColorBackgroundXS,
    },
  },
  viewBarContainer: {
    paddingLeft: 24,
    paddingRight: 24,
    display: 'flex',
    alignItems: 'center',
    height: 60,
    width: '100%',
    flexDirection: 'row',
    maxWidth: Math.min(window.appWidth, CONTENT_MAX_WIDTH),
    backgroundColor: ColorBackground,
    [theme.breakpoints.down('sm')]: {
      height: 40,
      paddingLeft: 14,
      paddingRight: 14,
    },
    [theme.breakpoints.down('xs')]: {
      backgroundColor: ColorBackgroundXS,
      height: 0,
    },
  },
  viewBarContainerWOBorder: {
    paddingLeft: 24,
    paddingRight: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
    maxWidth: Math.min(window.appWidth, FORM_OUTER_MAX_WIDTH),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  planCard: {
    margin: 16,
    position: 'relative',
    display: 'flex',
    width: '100%',
    maxWidth: 340,
    minWidth: 250,
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    paddingTop: 16,
    paddingBottom: 16,
    backgroundColor: ColorCard,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 400,
      margin: 8,
      marginTop: 12,
      marginBottom: 12,
      backgroundColor: ColorCardXS,
    },
  },
  previewView: {
    display: 'flex',
    flexDirection: 'column',
    width: PREVIEW_WIDTH,
    height: PREVIEW_HEIGHT,
    [theme.breakpoints.down('md')]: {
      width: PREVIEW_WIDTH_MD,
      height: PREVIEW_HEIGHT_MD,
    },
  },
  appBarContainer: {
    background: ColorClear,
    display: 'flex',
    zIndex: zIndex.drawer + 1,
    minHeight: TOOLBAR_HEIGHT + 60,
    pointerEvents: 'none',
    padding: 0,
    paddingTop: TOOLBAR_HEIGHT,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      minHeight: TOOLBAR_HEIGHT + 40,
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
      minHeight: TOOLBAR_HEIGHT_XS + 40,
    },
  },
  appBarPaymentContainer: {
    background: ColorClear,
    display: 'flex',
    zIndex: zIndex.drawer + 1,
    pointerEvents: 'none',
    padding: 0,
    paddingTop: 0,
    minHeight: TOOLBAR_HEIGHT + 40,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
      minHeight: TOOLBAR_HEIGHT_XS + 40,
    },
  },
  appBarText: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  errorManageActivity: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 24,
    marginTop: 68,
    marginBottom: -68,
    [theme.breakpoints.down('sm')]: {
      margin: 16,
      marginTop: 48,
      marginBottom: -48,
    },
    [theme.breakpoints.down('xs')]: {
      margin: 0,
      marginTop: 0,
      marginBottom: 0,
    },
  },
  formManageActivity: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 20,
    paddingBottom: 2,
    backgroundColor: ColorCard,
    margin: 24,
    marginTop: 68,
    [theme.breakpoints.down('sm')]: {
      padding: 16,
      paddingBottom: 2,
      margin: 16,
      marginTop: 48,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 16,
      paddingBottom: 2,
      paddingTop: 16,
      margin: 0,
      marginTop: 2,
      marginBottom: 0,
      backgroundColor: ColorCardXS,
    },
  },
  formManageActivityShowcaseMenuReview: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 20,
    paddingBottom: 2,
    backgroundColor: ColorCard,
    margin: 24,
    marginTop: 68,
    [theme.breakpoints.down('sm')]: {
      padding: 16,
      paddingBottom: 2,
      margin: 16,
      marginTop: 48,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      paddingBottom: 2,
      paddingTop: 8,
      margin: 0,
      marginTop: 2,
      marginBottom: 0,
      backgroundColor: ColorCardXS,
    },
  },
  formManageActivityPayment: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: ColorClear,
    padding: 0,
    paddingTop: 4,
    margin: 24,
    marginTop: 0,
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: 0,
      margin: 12,
      marginTop: 0,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      margin: 0,
      marginTop: 6,
      marginBottom: 0,
    },
  },
  formManageActivityDone: {
    flex: 1,
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 16,
    marginTop: 24,
    backgroundColor: ColorClear,
    [theme.breakpoints.down('sm')]: {
      margin: 8,
      marginTop: 0,
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 2,
      margin: 10,
      marginTop: 0,
    },
  },
  formManageActivityUsage: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 16,
    marginTop: 64,
    backgroundColor: ColorClear,
    [theme.breakpoints.down('sm')]: {
      margin: 8,
      marginTop: 40,
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 8,
      margin: 10,
      marginTop: 0,
    },
  },
  viewManageActivity: {
    // flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: Math.min(window.appWidth, CONTENT_MAX_WIDTH),
  },
  buttonActionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    pointerEvents: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: TOOLBAR_HEIGHT,
      alignSelf: 'flex-start',
    },
    [theme.breakpoints.down('xs')]: {
      height: TOOLBAR_HEIGHT_XS,
      alignSelf: 'flex-start',
    },
  },
});

const TAB_USAGE = 'TAB_USAGE';
const TAB_LIBRARY = 'TAB_LIBRARY';
const TAB_PREVIEW = 'TAB_PREVIEW';
const TAB_DETAIL = 'TAB_DETAIL';
const TAB_VOUCHERS = 'TAB_VOUCHERS';
const TAB_QUESTION = 'TAB_QUESTION';
const TAB_IN_QUESTION = 'TAB_IN_QUESTION';
const TAB_QUESTIONS = 'TAB_QUESTIONS';
const TAB_PREDICTION = 'TAB_PREDICTION';
const TAB_IDENTIFY_LOCATION = 'TAB_IDENTIFY_LOCATION';
const TAB_OPINION = 'TAB_OPINION';
const TAB_CUSTOMISE = 'TAB_CUSTOMISE';
const TAB_REEL_FRONT = 'TAB_REEL_FRONT';
const TAB_REEL_SUB_POSTS = 'TAB_REEL_SUB_POSTS';
const TAB_SLIDES = 'TAB_SLIDES';
const TAB_DEFAULTS = 'TAB_DEFAULTS';
const TAB_GAME_ELEMENTS = 'TAB_GAME_ELEMENTS';
const TAB_REWARD = 'TAB_REWARD';
const TAB_RECUR = 'TAB_RECUR';
const TAB_REFERRAL = 'TAB_REFERRAL';
const TAB_CTA = 'TAB_CTA';
const TAB_CTA1 = 'TAB_CTA1';
const TAB_CTA2 = 'TAB_CTA2';
const TAB_TARGETING = 'TAB_TARGETING';
const TAB_PLAN = 'TAB_PLAN';
const TAB_PRICE = 'TAB_PRICE';
const TAB_REVIEW = 'TAB_REVIEW';
const TAB_PAYMENT = 'TAB_PAYMENT';
const TAB_USER_INFO = 'TAB_USER_INFO';

export const CampaignPreView = React.memo((props) => {
  const {classes, history, isMD, isXS, isDrawerHidden, previewOrientation,
    activityType, previewActivity, refActivityView, isLTR, locale,
    userId, userBId, userRab7Number, userImageUrl, gameInfo,
    showGameInfo = false, showPreviewEff = true,
    showPreviewSubtitle = true, noSpacing = false, isFinal, isFirst, onPreviewOrientationToggle} = props;
  let {previewTitleId = 'activity.previewR'} = props;

  const onClickChangeOrientation = (orientation) => {
    onPreviewOrientationToggle(orientation);
  }

  let previewViewWidth= 0;
  let previewViewHeight = 0;
  let previewHintWidth = 0;

  const horizontal = previewOrientation === 1;
  if (horizontal) {
    let widthAvailable = window.appWidth - 12 - (!isDrawerHidden ? DRAWER_WIDTH : 0);
    if (!isXS) {
      widthAvailable -= 700;
      widthAvailable = Math.max(widthAvailable, PREVIEW_WIDTH);
    }
    let maxWidth = 500;
    if (isMD) {
      maxWidth = 400;
    }
    previewViewWidth = Math.min(widthAvailable, maxWidth);
    previewViewHeight = Math.min(window.appHeight-100, previewViewWidth/16*9);
    previewHintWidth = previewViewWidth + 10;
  } else {
    previewViewWidth= PREVIEW_WIDTH;
    previewViewHeight = PREVIEW_HEIGHT;
    if (isXS) {
      previewViewWidth = PREVIEW_WIDTH_XS;
      previewViewHeight = PREVIEW_HEIGHT_XS;
      let otherFieldsSpace = BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY + 40 + 12;
      if (isFirst) {
        otherFieldsSpace = BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY + 28 + 90;
      } else if (isFinal) {
        otherFieldsSpace = BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY + TOOLBAR_HEIGHT_XS + 40 + (activityType === constants.activity.types.SHOWCASE_MENU ? 24 : 0);
      }
      previewViewHeight = Math.min(previewViewHeight, Math.max(window.appHeight - otherFieldsSpace, 440));
      previewViewWidth = previewViewHeight / 1.875;
      previewHintWidth = window.appWidth - 32;
    } else if (isMD) {
      previewViewWidth = PREVIEW_WIDTH_MD;
      previewViewHeight = PREVIEW_HEIGHT_MD;
    }
    if (activityType === constants.activity.types.SHOWCASE_MENU) {
      previewViewWidth = Math.min(window.appWidth-12, previewViewHeight/16*9);
    }
    if (!isXS) {
      previewHintWidth = previewViewWidth + 10;
    }
  }

  const exStylePreview = {
    opacity: showPreviewEff ? 1 : 0,
  }
  if (!showPreviewEff) {
    exStylePreview.paddingBottom = 0;
    exStylePreview.height = 1;
    exStylePreview.width = 1;
  }
  const styleFlex = !isXS && !noSpacing ? {flex: showPreviewEff ? 1.3 : 0} : {};
  return (
    <div style={styleFlex}>
      <div className={isXS ? classes.viewRowFullWidth : classes.viewRowNoCenter} style={{overflow: 'hidden', justifyContent: noSpacing ? 'flex-start' : 'center', paddingBottom: 16, ...exStylePreview}}>
        {!isXS && !noSpacing ? <div style={{flex: 1}}/> : null}
        <div style={{width: previewHintWidth, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          {showGameInfo ?
            <div className={classes.flexColumnNoCenter} style={{padding: 6, backgroundColor: ColorPreviewBorder, borderRadius: RadiusView, marginBottom: 12}}>
              <TextView variant={'body2'} color={'textPrimary'} align={'left'} className={classes.typoMedium}>
                {gameInfo ? gameInfo.name : <FormattedMessage id={`activity.manage.${activityType}.title`}/>}
              </TextView>
              <TextView variant={'caption'} align={'left'} color={'textSecondary'}>
                {gameInfo ? gameInfo.description : <FormattedHTMLMessage id={`activity.manage.${activityType}.description`}/>}
              </TextView>
            </div>
            : null
          }
          <div className={classes.viewColumn} style={{width: previewViewWidth + 10}}>
            {previewTitleId ?
              <div className={classes.flexRow} style={{justifyContent: isXS ? 'center' : 'flex-start', backgroundColor: ColorPreviewBorder, borderRadius: 16, marginBottom: isXS ? 2 : 4, padding: 16, paddingTop: 6, paddingBottom: 6, overflow: 'hidden'}}>
                <TextView variant={isXS ? 'body2' : 'body1'} color={ColorTitle} align={'left'} fontWeight={FontWeightMedium} >
                  <FormattedMessage id={previewTitleId} />
                </TextView>
                {activityType === constants.activity.types.SHOWCASE_MENU && !isFirst ?
                  <React.Fragment>
                    <div style={{flex: 1}}/>
                    <IconButton onClick={() => onClickChangeOrientation(1)} style={{marginTop: -10, marginBottom: -10, backgroundColor: previewOrientation === 1 ? ColorTheme : ColorClear}}>
                      <ImageIcon src={previewOrientation === 1 ? require('src/images/ic_landscape_w.png') : require('src/images/ic_landscape.png')} width={22} height={22}/>
                    </IconButton>
                    <IconButton onClick={() => onClickChangeOrientation(0)} style={{marginTop: -10, marginBottom: -10, marginRight: isLTR ? -16 : 0, marginLeft: !isLTR ? -16 : 0, backgroundColor: previewOrientation === 0 ? ColorTheme : ColorClear}}>
                      <ImageIcon src={previewOrientation === 0 ? require('src/images/ic_portrait_w.png') : require('src/images/ic_portrait.png')} width={22} height={22}/>
                    </IconButton>
                  </React.Fragment>
                  : null
                }
              </div>
              : null
            }
            <ActivityPreviewView textId={'activity.previewR'}>
              <div className={classes.previewView} style={{width: previewViewWidth, height: previewViewHeight}}>
                {previewActivity && previewActivity.type ?
                  <ActivityView
                    key={previewActivity.type +'-'+ previewActivity.subType}
                    ref={refActivityView}
                    activity={previewActivity}
                    inPreview={true}
                    isLTR={isLTR}
                    locale={locale}
                    isXS={true}
                    windowWidth={window.appWidth}
                    windowHeight={window.appHeight}
                    height={previewViewHeight}
                    width={previewViewWidth}
                    hasUserInteraction={true}
                    history={history}
                    userId={userId}
                    userBId={userBId}
                    userRab7Number={userRab7Number}
                    userImageUrl={userImageUrl}
                    ctaTitles={CTA_TITLES}
                  />
                  : <div className={classes.flexColumn} style={{justifyContent: 'center'}}>
                    <TextView color={ColorSubTitle} fontWeight={FontWeightMedium}>{
                      <FormattedMessage id={'campaign.selectFunToPreview'}/>
                    }</TextView>
                  </div>
                }
              </div>
            </ActivityPreviewView>
          </div>
        </div>
        {!isXS && !noSpacing ? <div style={{flex: 5}}/> : null}
      </div>
    </div>
  );
})

class ManageActivity extends React.Component {

  static isPlanEnded(activityAd) {
    const availableViews = Math.max(0, activityAd.planViewsCount - activityAd.feedDisplayedCount);
    const planEndAt = activityAd.planEndAt;
    const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(planEndAt);

    if (availableViews === 0 || endDateDiff <= 0) {
      return true;
    }
    return false;
  }

  constructor(props) {
    super(props);

    this.isMobile = device.mobile();

    this.errorIndexes = new Set();
    this.dirtyIndexes = new Set();
    this.id = null;
    this.rechargeId = null;
    const location = this.props.history.location;
    this.latestLocation = location;

    let path = decodeURIComponent(location.pathname);
    let hash = decodeURIComponent(location.hash);
    let search = decodeURIComponent(location.search);
    if (search) {
      path = path.replace(search, '');
    }
    path = path.replace('/rewards/manage', '');
    path = path.replace('/campaigns/manage', '');
    path = path.replace('/marketingCampaigns/manage', '');
    path = path.replace('/loyaltyCampaigns/manage', '');
    path = path.replace('/educationCampaigns/manage', '');
    path = path.replace('/trainingCampaigns/manage', '');
    path = path.replace('/socialCampaigns/manage', '');
    path = path.replace('/influencerCampaigns/manage', '');
    path = path.replace('/', '');
    if (path && path.length > 0) {
      this.id = path;
    }

    this.usageType = 0;
    this.manageType = 0;
    this.showPlanNCharge = false;
    this.showSuccess = false;
    this.showCharge = false;
    if (search && search.length > 0) {
      const searchSplits = search.replace('?', '').split('=');
      if (searchSplits.length > 1) {
        const key = searchSplits[0];
        const val = searchSplits[1];
        if (key == 'p') {
          if (val == '1') { // free to paid
            this.manageType = 1;
          } else if (val == '2') { // extend paid
            this.manageType = 2;
            this.showCharge = true;
            this.loadChargeIndexInitially = true;
            this.blockNavToLastIndex = true;
          } else if (val == '3') {
            this.showPlanNCharge = true;
          } else if (val == '4') {
            this.showSuccess = true;
          }
        } else if (key == 'ut') {
          this.usageType = parseInt(val);
        } else if (key == 't') {
          this.type = parseInt(val);
          const searchParams = new URLSearchParams(search);
          this.fromLanding = searchParams.get('fl');
        } else if (key == 'st') {
          this.type = constants.activity.types.EXTERNAL_GAMES;
          this.subType = parseInt(val);
          const searchParams = new URLSearchParams(search);
          this.fromLanding = searchParams.get('fl');
        } else if (key == 'rId') {
          this.rechargeId = parseInt(val);
        }
      }
    }
    if (!this.usageType) {
      this.usageType = constants.activity.usageTypes.MARKETING;
    }

    this.oldActivity = null;
    this.activityData = null;
    this.isInEdit = this.id != null;

    this.state = {
      reload: false,
      subTabs: null,
      selectedDotIndex: 0,
      enableAction: true,
      showDialog: false,
      showPreview: false,
      isBlockedLoading: false,
      loadingProgress: 0,
      loaderMessage: null,
      previewActivity: null,
      previewOrientation: 0,
    };
    this.saveActivityData = this.saveActivityData.bind(this);
  }

  componentDidMount() {
    document.title = 'Rab7 | Manage Campaign';
    const pathname = this.props.history.location.pathname;
    const hash = this.props.history.location.hash;
    if (hash && hash.length > 1) {
      this.props.history.replace(pathname);
    }
    this.initialNavPath = pathname;

    clearObjectUrls();
    // this.startHistoryListeners();

    this.fetchData();
  }

  componentWillUnmount() {
    clearObjectUrls();
    this.stopHistoryListeners();
  }

  startHistoryListeners() {
    if (!this.historyNavBlockListener) {
      // this.historyNavListener = this.props.history.listen(this.historyNavHandler);
      this.historyNavBlockListener = this.props.history.block(this.historyNavBlockHandler);
      window.addEventListener('hashchange', this.historyNavHandler);
    }
  }

  stopHistoryListeners() {
    if (this.historyNavBlockListener) {
      // this.historyNavListener();
      window.removeEventListener('hashchange', this.historyNavHandler);
      this.historyNavBlockListener();
      this.historyNavBlockListener = null;
    }
  }

  historyNavHandler = (event) => {
    this.latestLocation = getNavLocationFromUrl(event.newURL);
    console.log('wh-latestLocation', this.latestLocation);
  }

  historyNavBlockHandler = (location, action) => {
    console.log('wh-historyNavBlockHandler0', location);
    console.log('wh-historyNavBlockHandler1', action);
    const {selectedDotIndex, showDialog, showPreview, isBlockedLoading} = this.state;
    if (this.activityData && !this.activityData.isSuccess) {
      if (action === 'POP' && location.pathname !== this.initialNavPath) {
        const isPaymentDone = this.activityData.planRecharge && (this.activityData.planRecharge.state === STATE_ENABLED
          || this.activityData.planRecharge.state === STATE_ORDER_PAYMENT_FAILED
          || this.activityData.planRecharge.state === STATE_ORDER_PAYMENT_CANCELLED);
        if (isBlockedLoading || showDialog || showPreview || (selectedDotIndex > 0 && !this.blockNavToLastIndex) || isPaymentDone) {
          this.navToCurrentLocation(action, () => {
            if (isBlockedLoading) {
              // do nothing
            }
            else if (showDialog) {
              this.hideDialog();
            }
            else if (showPreview) {
              this.hidePreview();
            }
            else if (isPaymentDone) {
              this.onPaymentDoneClicked();
            }
            else if (!this.isEditing() && selectedDotIndex === 1) {
              this.showLeaveDialog(true);
            }
            else if (selectedDotIndex > 0) {
              this.onClickPrevious();
            }
          });
          return false;
        }
      }

      if (!areNavLocationsEqual(location, this.props.history.location) && location && this.activityData.type) {
        this.navToCurrentLocation(action, () => {
          let isPaymentInProcessing = this.activityData.planRecharge && this.activityData.planRecharge.state === STATE_ORDER_CREATED;
          isPaymentInProcessing = false; // show simple message to quit
          this.lastLocationAction = action;
          this.lastLocation = location;
          this.showLeaveDialog();
        });
        return false;
      }
    }

    return true;
  }

  showLeaveDialog = (reset) => {
    let isPaymentInProcessing = this.activityData.planRecharge && this.activityData.planRecharge.state === STATE_ORDER_CREATED;
    this.showDialog({
      title: locString(isPaymentInProcessing ? 'payment.cancelQ' : 'manage.leaveCampaign'),
      message: <FormattedHTMLMessage id={isPaymentInProcessing ? 'payment.cancelMsg' : 'manage.leaveMessage'}/>,
      neutralText: locString(isPaymentInProcessing ? 'generic.no' : 'cancel'),
      positiveText: locString(isPaymentInProcessing ? 'payment.cancel' : 'manage.leave'),
      onNeutralClicked: this.hideDialog,
      onPositiveClicked: isPaymentInProcessing ? this.onPaymentCancelClicked : reset ? this.resetCreateActivity : this.navToNewLocation,
    });
  }

  navToCurrentLocation(action, onDone) {
    setTimeout(() => {
      if (!areNavLocationsEqual(this.latestLocation, this.props.history.location)) {
        if (action === 'POP') {
          this.props.history.goForward();
          this.lastLocationAction = 'PUSH';
          this.navToCurrentLocation('PUSH', onDone);
        } else {
          this.props.history.goBack();
          if (onDone) {
            onDone();
          }
        }
      } else {
        if (onDone) {
          onDone();
        }
      }
    }, 200);
  }

  navToNewLocation = () => {
    this.hideDialog();
    this.stopHistoryListeners();
    if (this.lastLocationAction === 'POP') {
      this.props.history.goBack();
    } else {
      this.props.history.replace(this.lastLocation);
    }
  }

  resetCreateActivity = () => {
    this.hideDialog();

    if (this.type) {
      if (!this.fromLanding) {
        this.stopHistoryListeners();
        this.onBackClicked();
        return;
      } else {
        this.fromLanding = 0;
        this.type = 0;
        this.subType = 0;
        this.stopHistoryListeners();
        this.props.history.replace({
          pathname: this.props.history.location.pathname,
          hash: this.props.history.location.hash,
        })
      }
    }

    this.proceedWithNoActivity();
    this.setState({enableAction: false, selectedDotIndex: 0, fetchedConfigsForType: 0, fetchedConfigsForSubType: 0, showPreview: false}, () => {
      this.setState({enableAction: true});
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      if (this.moveNextCallback && this.state.subTabs[this.state.selectedDotIndex].id === TAB_LIBRARY) {
        this.moveNextCallback.reset();
      }
    });

    if (this.props.activities.activity.errMsg) {
      this.props.resetManageActivityErrMsg();
    }
  }

  navBackToList = () => {
    this.stopHistoryListeners();
    this.onBackClicked();
  };

  onBackClicked = () => {
    navBackOrExit(this.props.history);
  }

  fetchData = (blockLoading) => {
    const {fetchActivity, fetchActivityConfigs, user} = this.props;
    if (this.id) {
      if (blockLoading) {
        this.setState({isBlockedLoading: true});
      }
      fetchActivity(this.id, true, this.rechargeId, blockLoading).then((response) => {
        this.startHistoryListeners();
        if (blockLoading) {
          this.setState({isBlockedLoading: false});
        }
        this.processActivityData(response.data);
        if (response.data && response.data.userWallet) {
          this.props.updateUserWallet(response.data.userWallet);
        }
      }).catch(() => {
        if (blockLoading) {
          this.setState({isBlockedLoading: false});
        }
      });
    } else {
      fetchActivityConfigs(0).then((response) => {
        this.startHistoryListeners();
        this.newActivityConfigs = response.data;

        this.proceedWithNoActivity();
      });
    }
  }

  proceedWithNoActivity() {
    const {user} = this.props;
    this.oldActivity = {
      type: 0,
      usageType: this.getCampaignUsageType(),
      business: {
        id: user.id,
        name: user.name,
        username: user.username,
        imageUrl: user.imageUrl,
      },
    };
    if (this.oldActivity.business.name !== '#'+ this.oldActivity.business.username) {
      this.oldActivity.userName = user.name;
    }
    if (!isUserImageDummy(this.oldActivity.business.imageUrl)) {
      this.oldActivity.userImageUrl = user.imageUrl;
    }
    if (this.type) {
      this.oldActivity.skipType = this.type;
      if (this.subType) {
        this.oldActivity.skipSubType = this.subType;
      }
    }
    this.resetToNewData();
    this.processTabs();
  }

  processActivityData(activity, onProcessed) {
    this.oldActivity = activity;
    this.activityData = cloneDeep(this.oldActivity);
    ApiHelper.processActivityGameInfoConfigs(this.activityData);
    // this.activityData.business = this.props.user;
    this.activityData.planType = this.activityData.ad ? this.activityData.ad.planType : 0;
    this.activityData.planId = this.activityData.ad ? this.activityData.ad.planId : 0;
    if (this.activityData.planId !== PLAN_TYPE_PAID) {
      this.activityData.planId = this.activityData.adInfo.plans[0].id;
      this.activityData.planType = this.activityData.adInfo.plans[0].type;
    }
    if (this.oldPlan) {
      this.activityData.planType = this.oldPlan.planType;
      this.activityData.planDuration = this.oldPlan.planDuration;
      this.activityData.planViews = this.oldPlan.planViews;
      this.activityData.planDailyViews = this.oldPlan.planDailyViews;
      this.activityData.planPrice = this.oldPlan.planPrice;
      this.activityData.planPayCurrency = this.oldPlan.planPayCurrency;
      this.activityData.planPayCurrencyCode = this.oldPlan.planPayCurrencyCode;
      this.activityData.planPay = this.oldPlan.planPay;
      this.activityData.planPayPoints = 0;
      this.activityData.planPayPointsValue = 0;
      this.activityData.planPaySuccess = this.oldPlan.planPaySuccess;
    }

    this.activityData.inReward = null;
    if (this.activityData.slotValues && this.activityData.slotValues.length > 0 && this.activityData.slotValues[0].offers && this.activityData.slotValues[0].offers.length > 0) {
      this.activityData.inReward = this.activityData.slotValues[0].offers[0];
      this.activityData.rewardState = constants.activity.state.ACTIVE;
      this.activityData.rewardSubState = this.activityData.inReward.type;
    }

    this.activityData.isEditing = true;
    this.activityData.startAt = DateTimeHelper.getDateFromDateString(this.activityData.startAt);
    this.activityData.endAt = DateTimeHelper.getDateFromDateString(this.activityData.endAt);
    this.activityData.endAtA = DateTimeHelper.getDateFromDateString(this.activityData.endAtA);
    this.activityData.noEditStartAt = this.isReward() || !DateTimeHelper.isDateAfter(this.activityData.startAt, new Date());
    if (this.activityData.business.name !== '#'+ this.activityData.business.username) {
      this.activityData.userName = this.activityData.business.name;
    }
    if (!isUserImageDummy(this.activityData.business.imageUrl)) {
      this.activityData.userImageUrl = this.activityData.business.imageUrl;
    }
    this.processDummyValues();

    if (this.manageType === 1 || this.showPlanNCharge) {
      this.activityData['disableNext'+ TAB_PLAN] = true;
      this.processForUpgrade();
    }
    this.createPreviewActivity();
    this.processTabs(onProcessed);
    this.processPreviewActivityShowHideSubView();

    if (this.oldPlan) {
      this.oldPlan = null;
      setTimeout(() => {
        if (this.activityData.planPay > 0) {
          this.onClickNext();
        } else {
          this.saveActivityData();
        }
      });
    }
  }

  processForUpgrade() {
    if (this.activityData.adInfo && this.activityData.adInfo.plans) {
      for (let i = 0; i < this.activityData.adInfo.plans.length; i++) {
        const plan = this.activityData.adInfo.plans[i];
        if (this.activityData.adInfo.plans[i].type === constants.activity.plans.PAID_PLAN) {
          this.activityData.planId = plan.id;
          this.activityData.planType = plan.type;
          this.activityData.isLinkOnly = 0;
          break;
        }
      }
    }
  }

  resetToNewData(data = null) {
    this.activityData = cloneDeep(this.oldActivity);
    if (data) {
      this.assignNewData(data);
    }

    this.createPreviewActivity();
  }

  createPreviewActivity(playBgAudio = false) {
    this.previewActivity = null;
    if (this.activityData && this.activityData.activityConfigs
        && this.activityData.type !== constants.activity.types.OFFER
        && this.activityData.type !== constants.activity.types.VOUCHER
        && this.activityData.type !== constants.activity.types.DISCOUNT) {
      const subPosts = this.activityData.subPosts;
      if (subPosts && subPosts.length > 0) {
        subPosts.forEach((subPost) => {
          if (subPost.imageUrls && subPost.imageUrls.length > 0) {
            subPost.imageUrl = subPost.imageUrls[0];
            subPost.imageUrls;
          }
        });
      }
      this.activityData.subPosts = subPosts;

      this.previewActivity = cloneDeep(this.activityData);

      // process previewData
      this.previewActivity.previewBusiness = {
        name: this.previewActivity.userName || this.activityData.business.name,
        imageUrl: this.previewActivity.userImageUrl || this.activityData.business.imageUrl,
      };
      this.previewActivity.previewBasics = {
        title: this.previewActivity.title,
        imageUrl: this.previewActivity.imageUrl,
        reelInFocus: this.previewActivity.type === constants.activity.types.CHALLENGE && (!this.props.isXS || this.state.showPreview),
        themeColor: this.activityData.themeColor,
      };
      this.previewActivity.previewCta1 = {
        title: this.previewActivity.sName || this.previewActivity.business.name,
        link: this.previewActivity.sLink || this.previewActivity.business.link,
        imageUrl: this.previewActivity.sImageUrl || this.previewActivity.business.imageUrl,
        show: false,
      };
      this.previewActivity.previewCta2 = {
        linkText: this.previewActivity.s2LinkText,
        link: this.previewActivity.s2Link,
        description: this.previewActivity.description,
        imageUrl: this.previewActivity.s2ImageUrl,
        videoUrl: this.previewActivity.videoUrl,
        show: false,
      };
      this.previewActivity.previewGamePlay = {
        tries: this.previewActivity.type === constants.activity.types.GAME_FLIP_CARD ? this.previewActivity.flipsNeeded : this.previewActivity.consumeLimitPerUser,
        plays: this.previewActivity.consumeLimit,
        cardImageUrl: this.previewActivity.imageUrl1,
        cardRevealImageUrl: this.previewActivity.imageUrl2,
        showCards: 0,
        showKeyCards: 0,
      };
      this.previewActivity.previewBgAudio = {
        audioUrl: this.previewActivity.bgAudioUrl,
        play: playBgAudio
      };
      this.previewActivity.previewReferral = {
        offer: this.previewActivity.referralWinFun,
        points: this.previewActivity.referralWinPoints
      };
      this.previewActivity.previewPrediction = {
        name: this.previewActivity.qTitle,
        option1: {
          name: this.previewActivity.value1Placeholder,
          answer: this.previewActivity.rightOptionHint,
          imageUrl: this.previewActivity.imageUrl1,
        },
        option2: this.previewActivity.value2Placeholder || this.previewActivity.imageUrl2 ? {
          name: this.previewActivity.value2Placeholder,
          answer: this.previewActivity.rightOptionHintAr,
          imageUrl: this.previewActivity.imageUrl2,
        } : null
      };
      this.previewActivity.previewLocation = {
        name: this.previewActivity.qTitle,
        imageUrl: this.previewActivity.imageUrl1,
      };
      this.previewActivity.previewOpinion = {
        name: this.previewActivity.qTitle,
        imageUrl: this.previewActivity.imageUrl1,
        ratingMinTitle: this.previewActivity.value1Placeholder,
        ratingMaxTitle: this.previewActivity.value2Placeholder,
        contentTypes: this.previewActivity.contentTypes,
      };
      this.previewActivity.previewQuestion = {
        name: this.previewActivity.qTitle,
        options: this.previewActivity.qOptions,
        imageUrl: this.previewActivity.imageUrl2,
        rightOptionId: this.previewActivity.rightOptionId,
        showAnswers: this.previewActivity.showAnswers,
        correction: this.previewActivity.correction,
      };
      this.previewActivity.previewQuestions = {
        name: this.previewActivity.qTitle,
        imageUrl: this.previewActivity.imageUrl2,
        questions: this.previewActivity.questions,
        gameTime: this.previewActivity.gameTime,
        correction: this.previewActivity.correction,
        minCorrectAnswers: this.previewActivity.winnersBy > 0 ? this.previewActivity.winnersByValue : 0,
      };
      this.previewActivity.previewSubPosts = this.previewActivity.subPosts;
      this.previewActivity.previewInQuestionEnd = this.previewActivity.inQuestion;
      this.processPreviewSlotValues();
    }
  }

  processPreviewSlotValues() {
    const cards = [];
    if (this.activityData.slotValues) {
      this.activityData.slotValues.forEach((slot) => {
        const slotNew = cloneDeep(slot);
        slotNew.points = slot.points;
        slotNew.offers = slot.offers;
        if (slot.imageFiles && slot.imageFiles.length > 0) {
          slotNew.imageUrl = slot.imageFiles[0].url;
        } else if (slot.imageUrl) {
          slotNew.imageUrl = slot.imageUrl;
        } else {
          slotNew.imageUrl = ApiHelper.getSlotDefaultImageUrl(this.activityData, slotNew.number);
        }
        if (slot.offers && slot.offers.length > 0) {
          const offers = [];
          slot.offers.forEach((offer) => {
            const offerNew = cloneDeep(offer);
            if (offerNew.videoFiles && offerNew.videoFiles.length > 0) {
              offerNew.videoUrl = offerNew.videoFiles[0].url;
              offerNew.videoStreamUrl = null;
            }
            if (offerNew.imageFiles && offerNew.imageFiles.length > 0) {
              offerNew.imageUrl = offerNew.imageFiles[0].url;
            }
            offers.push(offerNew);
          });
          slotNew.offers = offers;
        }
        cards.push(slotNew);
      });
    }

    this.previewActivity.previewCards = cards;
    this.previewActivity.slotValues = cards;
  }

  processPreviewActivity() {
    const {isXS} = this.props;
    const {subTabs, selectedDotIndex} = this.state;
    const cDotId = subTabs[selectedDotIndex].id;
    const data = this.activityData;

    if (this.previewActivity) {
      this.previewActivity = Object.assign(this.previewActivity, data);

      this.previewActivity.previewCta1.show = false;
      this.previewActivity.previewCta2.show = false;
      this.previewActivity.previewBgAudio.play = false;
      this.previewActivity.previewBasics.showReward = false;
      this.previewActivity.previewBasics.final = false;
      this.previewActivity.previewBasics.start = false;
      if (this.previewActivity.previewInQuestionEnd) {
        this.previewActivity.previewInQuestionEnd.show = false;
      }

      if (cDotId === TAB_DETAIL) {
        const previewBasics = this.previewActivity.previewBasics;
        previewBasics.title = data.title;
        previewBasics.imageUrl = null;
        if (data.imageFiles && data.imageFiles.length > 0) {
          previewBasics.imageUrl = data.imageFiles[0].url;
        } else if (data.imageUrl) {
          previewBasics.imageUrl = data.imageUrl;
        } else {
          previewBasics.imageUrl = ApiHelper.getActivityDefaultImageUrl(this.previewActivity.type, this.previewActivity.subType, this.previewActivity.gameInfo);
        }
        this.previewActivity.previewBasics = previewBasics;
      }
      else if (cDotId === TAB_CTA || cDotId === TAB_CTA1 || cDotId === TAB_CTA2) {
        if (cDotId === TAB_CTA || cDotId === TAB_CTA1) {
          const cta1 = this.previewActivity.previewCta1;
          cta1.imageUrl = this.oldActivity.business.imageUrl;
          cta1.title = this.oldActivity.business.name;

          if (data.sName) {
            cta1.title = data.sName;
          }
          cta1.link = data.sLink;
          if (data.sImageFiles && data.sImageFiles.length > 0) {
            cta1.imageUrl = data.sImageFiles[0].url;
          } else if (data.sImageUrl) {
            cta1.imageUrl = data.sImageUrl;
          }
          cta1.show = !isXS || this.state.showPreview;
          this.previewActivity.previewCta1 = cta1;
        }
        if (cDotId === TAB_CTA || cDotId === TAB_CTA2) {
          const cta2 = this.previewActivity.previewCta2;
          cta2.videoUrl = null;
          cta2.videoStreamUrl = null;
          cta2.imageUrl = null;

          cta2.linkText = data.s2LinkText;
          cta2.link = data.s2Link;
          if (data.videoFiles && data.videoFiles.length > 0) {
            cta2.videoUrl = data.videoFiles[0].url;
            cta2.videoStreamUrl = null;
          } else if (data.videoUrl) {
            cta2.videoUrl = data.videoUrl;
            cta2.videoStreamUrl = this.oldActivity.videoStreamUrl;
          }
          if (data.s2ImageFiles && data.s2ImageFiles.length > 0) {
            cta2.imageUrl = data.s2ImageFiles[0].url;
          } else if (data.s2ImageUrl) {
            cta2.imageUrl = data.s2ImageUrl;
          }
          cta2.show = !isXS || this.state.showPreview;
          this.previewActivity.previewCta2 = cta2;
        }
      }
      else if (cDotId === TAB_GAME_ELEMENTS) {
        const game = this.previewActivity.previewGamePlay;
        if (this.activityData.type === constants.activity.types.GAME_FLIP_CARD) {
          game.tries = data.flipsNeeded;
        } else {
          game.tries = data.consumeLimitPerUser;
        }
        game.plays = data.consumeLimit;
        this.previewActivity.previewGamePlay = game;

        if (this.activityData.type === constants.activity.types.QUESTIONNAIRE || this.activityData.type === constants.activity.types.SURVEY) {
          const questions = this.previewActivity.previewQuestions;
          questions.correction = data.correction;
          questions.gameTime = data.gameTime;
          questions.minCorrectAnswers = data.winnersBy > 0 ? data.winnersByValue : 0;
          this.previewActivity.previewQuestions = questions;
        }
      }
      else if (cDotId === TAB_PREDICTION) {
        this.previewActivity.previewBasics.start = true;
        const previewPrediction = this.previewActivity.previewPrediction;
        previewPrediction.name = data.qTitle;

        const option1 = {};
        option1.name = data.value1Placeholder;
        option1.answer = data.rightOptionHint;
        option1.imageUrl = null;
        if (data.imageFiles1 && data.imageFiles1.length > 0) {
          option1.imageUrl = data.imageFiles1[0].url;
        } else if (data.imageUrl1) {
          option1.imageUrl = data.imageUrl1;
        }
        previewPrediction.option1 = option1;

        let option2ImageUrl = null;
        if (data.imageFiles2 && data.imageFiles2.length > 0) {
          option2ImageUrl = data.imageFiles2[0].url;
        } else if (data.imageUrl2) {
          option2ImageUrl = data.imageUrl2;
        }
        let option2 = null;
        if (data.value2Placeholder || option2ImageUrl) {
          option2 = {};
          option2.name = data.value2Placeholder;
          option2.imageUrl = option2ImageUrl;
        }
        previewPrediction.option2 = option2;
        this.previewActivity.previewPrediction = previewPrediction;
      }
      else if (cDotId === TAB_IDENTIFY_LOCATION) {
        this.previewActivity.previewBasics.start = true;
        // const bgAudio = cloneDeep(this.previewActivity.previewBgAudio);
        // bgAudio.audioUrl = null;
        // if (data.bgAudioFiles && data.bgAudioFiles.length > 0) {
        //   bgAudio.audioUrl = data.bgAudioFiles[0].url;
        // } else if (data.bgAudioUrl) {
        //   bgAudio.audioUrl = data.bgAudioUrl;
        // }
        // bgAudio.play = true;
        // this.previewActivity.previewBgAudio = bgAudio;

        const previewLocation = this.previewActivity.previewLocation;
        previewLocation.name = data.qTitle;
        if (data.imageFiles1 && data.imageFiles1.length > 0) {
          previewLocation.imageUrl = data.imageFiles1[0].url;
        } else if (data.imageUrl1) {
          previewLocation.imageUrl = data.imageUrl1;
        }
        this.previewActivity.previewLocation = previewLocation;
      }
      else if (cDotId === TAB_OPINION) {
        this.previewActivity.previewBasics.start = true;
        // const bgAudio = cloneDeep(this.previewActivity.previewBgAudio);
        // bgAudio.audioUrl = null;
        // if (data.bgAudioFiles && data.bgAudioFiles.length > 0) {
        //   bgAudio.audioUrl = data.bgAudioFiles[0].url;
        // } else if (data.bgAudioUrl) {
        //   bgAudio.audioUrl = data.bgAudioUrl;
        // }
        // bgAudio.play = true;
        // this.previewActivity.previewBgAudio = bgAudio;

        const previewOpinion = this.previewActivity.previewOpinion;
        previewOpinion.name = data.qTitle;
        previewOpinion.ratingMinTitle = data.value1Placeholder;
        previewOpinion.ratingMaxTitle = data.value2Placeholder;
        previewOpinion.contentTypes = data.contentTypes;
        if (data.imageFiles1 && data.imageFiles1.length > 0) {
          previewOpinion.imageUrl = data.imageFiles1[0].url;
        } else if (data.imageUrl1) {
          previewOpinion.imageUrl = data.imageUrl1;
        }
        this.previewActivity.previewOpinion = previewOpinion;
      }
      else if (cDotId === TAB_QUESTION) {
        this.previewActivity.previewBasics.start = true;
        // if (this.activityData.type === constants.activity.types.GUESS) {
        //   const bgAudio = cloneDeep(this.previewActivity.previewBgAudio);
        //   bgAudio.audioUrl = null;
        //   if (data.bgAudioFiles && data.bgAudioFiles.length > 0) {
        //     bgAudio.audioUrl = data.bgAudioFiles[0].url;
        //   } else if (data.bgAudioUrl) {
        //     bgAudio.audioUrl = data.bgAudioUrl;
        //   }
        //   bgAudio.play = true;
        //   this.previewActivity.previewBgAudio = bgAudio;
        // }

        const question = this.previewActivity.previewQuestion;
        question.name = data.qTitle;
        question.options = data.qOptions;
        question.imageUrl = null;
        if (data.imageFiles2 && data.imageFiles2.length > 0) {
          question.imageUrl = data.imageFiles2[0].url;
        } else if (data.imageUrl2) {
          question.imageUrl = data.imageUrl2;
        }
        question.rightOptionId = null;
        if (question.options && data.rightOption && question.options.length >= data.rightOption) {
          question.rightOptionId = question.options[data.rightOption - 1].id;
        }
        question.correction = data.correction;
        this.previewActivity.previewQuestion = question;
      }
      else if (cDotId === TAB_IN_QUESTION) {
        let question = null;
        const inQuestion = data.inQuestion;
        if (inQuestion && inQuestion.qTitle && inQuestion.qTitle.trim().length > 0) {
          question = {};
          question.id = inQuestion.id;
          question.type = inQuestion.type;
          question.title = inQuestion.title;
          question.qTitle = inQuestion.qTitle;
          question.qOptions = inQuestion.qOptions;
          question.imageUrl2 = null;
          if (inQuestion.imageFiles2 && inQuestion.imageFiles2.length > 0) {
            question.imageUrl2 = inQuestion.imageFiles2[0].url;
          } else if (inQuestion.imageUrl2) {
            question.imageUrl2 = inQuestion.imageUrl2;
          }
        } else {
          question = this.getDummyInternalQuestion();
        }
        question.show = true;
        this.previewActivity.previewInQuestionEnd = question;
      }
      else if (cDotId === TAB_QUESTIONS) {
        this.previewActivity.previewBasics.start = true;
        const questions = this.previewActivity.previewQuestions;
        questions.name = data.qTitle;
        questions.imageUrl = null;
        if (data.imageFiles2 && data.imageFiles2.length > 0) {
          questions.imageUrl = data.imageFiles2[0].url;
        } else if (data.imageUrl2) {
          questions.imageUrl = data.imageUrl2;
        }
        questions.questions = data.questions;
        questions.questionIds = data.questionIds;
        this.previewActivity.previewQuestions = questions;
      }
      else if (cDotId === TAB_CUSTOMISE) {
        const bgAudio = cloneDeep(this.previewActivity.previewBgAudio);
        bgAudio.audioUrl = null;
        if (data.bgAudioFiles && data.bgAudioFiles.length > 0) {
          bgAudio.audioUrl = data.bgAudioFiles[0].url;
        } else if (data.bgAudioUrl) {
          bgAudio.audioUrl = data.bgAudioUrl;
        }
        bgAudio.play = !isXS || this.state.showPreview;
        this.previewActivity.previewBgAudio = bgAudio;

        const game = this.previewActivity.previewGamePlay;
        if (data.imageFiles1 && data.imageFiles1.length > 0) {
          game.cardImageUrl = data.imageFiles1[0].url;
        } else if (data.imageUrl1) {
          game.cardImageUrl = data.imageUrl1;
        } else {
          game.cardImageUrl = ApiHelper.getSlotDefaultCardImageUrl(this.previewActivity.type);
        }
        if (data.imageFiles2 && data.imageFiles2.length > 0) {
          game.cardRevealImageUrl = data.imageFiles2[0].url;
        } else if (data.imageUrl2) {
          game.cardRevealImageUrl = data.imageUrl2;
        } else {
          game.cardRevealImageUrl = ApiHelper.getSlotDefaultCardRevealImageUrl();
        }
        this.previewActivity.previewGamePlay = game;

        if (this.activityData.type === constants.activity.types.QUESTION) {
          const question = this.previewActivity.previewQuestion;
          question.showAnswers = data.showAnswers;
          this.previewActivity.previewQuestion = question;
        }
        if (this.activityData.type === constants.activity.types.QUESTIONNAIRE || this.activityData.type === constants.activity.types.SURVEY) {
          const questions = this.previewActivity.previewQuestions;
          questions.correction = data.correction;
          questions.gameTime = data.gameTime;
          questions.minCorrectAnswers = data.winnersBy > 0 ? data.winnersByValue : 0;
          this.previewActivity.previewQuestions = questions;
        }

        this.previewActivity.previewBasics.themeColor = data.themeColor;
      }
      else if (cDotId === TAB_REEL_FRONT) {
        this.previewActivity.previewBasics.start = true;
        const bgAudio = cloneDeep(this.previewActivity.previewBgAudio);
        bgAudio.audioUrl = null;
        if (data.bgAudioFiles && data.bgAudioFiles.length > 0) {
          bgAudio.audioUrl = data.bgAudioFiles[0].url;
        } else if (data.bgAudioUrl) {
          bgAudio.audioUrl = data.bgAudioUrl;
        }
        bgAudio.play = false;
        this.previewActivity.previewBgAudio = bgAudio;

        const cta2 = this.previewActivity.previewCta2;
        cta2.videoUrl = null;
        cta2.videoStreamUrl = null;
        cta2.imageUrl = null;
        if (data.videoFiles && data.videoFiles.length > 0) {
          cta2.videoUrl = data.videoFiles[0].url;
          cta2.videoStreamUrl = null;
        } else if (data.videoUrl) {
          cta2.videoUrl = data.videoUrl;
          cta2.videoStreamUrl = this.oldActivity.videoStreamUrl;
        }
        if (data.s2ImageFiles && data.s2ImageFiles.length > 0) {
          cta2.imageUrl = data.s2ImageFiles[0].url;
        } else if (data.s2ImageUrl) {
          cta2.imageUrl = data.s2ImageUrl;
        }
        cta2.show = false;
        cta2.description = data.description;
        this.previewActivity.previewCta2 = cta2;
      }
      else if (cDotId === TAB_REEL_SUB_POSTS || cDotId === TAB_SLIDES) {
        this.previewActivity.previewSubPosts = data.subPosts;
        if (this.state.previewOrientation !== data.previewOrientation) {
          this.setState({previewOrientation: data.previewOrientation});
        }
      }
      else if (cDotId === TAB_REFERRAL) {
        this.previewActivity.previewReferral = {
          offer: this.previewActivity.referralWinFun,
          points: this.previewActivity.referralWinPoints
        };
      }
      else if (cDotId === TAB_REWARD) {
        this.previewActivity.previewBasics.showReward = this.state.showPreview;
        this.previewActivity.previewReferral = {
          offer: this.previewActivity.referralWinFun,
          points: this.previewActivity.referralWinPoints
        };
      }
      else if (cDotId === TAB_USER_INFO) {
        this.previewActivity.previewBusiness.name = data.userName || this.activityData.business.name;
        if (data.userImageFiles && data.userImageFiles.length > 0) {
          this.previewActivity.previewBusiness.imageUrl = data.userImageFiles[0].url;
        } else {
          this.previewActivity.previewBusiness.imageUrl = this.activityData.business.imageUrl;
        }
      }
      else if (cDotId === TAB_REVIEW) {
        if (this.previewActivity.previewInQuestionEnd) {
          if (this.previewActivity.previewInQuestionEnd.isDummy) {
            this.previewActivity.previewInQuestionEnd = null;
          } else {
            this.previewActivity.previewInQuestionEnd.show = true;
          }
          if (this.previewActivity.previewInQuestionEnd) {
            this.previewActivity.previewInQuestionEnd.show = false;
          }
        }
        this.previewActivity.previewBasics.final = true;
      }

      if (cDotId === TAB_CUSTOMISE || cDotId === TAB_DEFAULTS || cDotId === TAB_REWARD) {
        this.processPreviewSlotValues();
      }

      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.timeoutHandler = null;
      }
      this.timeoutHandler = setTimeout(() => {
        if (this.refActivityView) {
          this.refActivityView.reloadPreview(this.previewActivity);
        }
        this.timeoutHandler = null;
      }, 400);
    }
  }

  processPreviewActivityShowHideSubView() {
    const {isXS} = this.props;
    const {subTabs, selectedDotIndex} = this.state;
    const cDotId = subTabs[selectedDotIndex].id;

    if (this.previewActivity) {
      this.previewActivity.previewCta1.show = false;
      if (cDotId === TAB_CTA1 || cDotId === TAB_CTA) {
        this.previewActivity.previewCta1.show = true;
      }

      this.previewActivity.previewCta2.show = false;
      if (cDotId === TAB_CTA2) {
        this.previewActivity.previewCta2.show = true;
      }

      this.previewActivity.previewBgAudio.play = false;
      if (cDotId === TAB_PREVIEW || cDotId === TAB_LIBRARY
        || cDotId === TAB_CUSTOMISE || cDotId === TAB_REVIEW) {
        this.previewActivity.previewBgAudio.play = !isXS || this.state.showPreview;
      }

      if (this.previewActivity.previewInQuestionEnd) {
        this.previewActivity.previewInQuestionEnd.show = false;
      }
      if (cDotId === TAB_IN_QUESTION) {
        if (!this.previewActivity.previewInQuestionEnd) {
          this.previewActivity.previewInQuestionEnd = this.getDummyInternalQuestion();
        }
        this.previewActivity.previewInQuestionEnd.show = true;
      }

      this.previewActivity.previewBasics.start = false;
      if (cDotId === TAB_PREDICTION || cDotId === TAB_IDENTIFY_LOCATION || cDotId === TAB_OPINION
        || cDotId === TAB_QUESTION || cDotId === TAB_QUESTIONS || cDotId === TAB_REEL_FRONT) {
        this.previewActivity.previewBasics.start = true;
      }

      this.previewActivity.previewBasics.final = false;
      if (cDotId === TAB_REVIEW) {
        this.previewActivity.previewBasics.final = true;

        if (this.previewActivity.previewInQuestionEnd) {
          if (this.previewActivity.previewInQuestionEnd.isDummy) {
            this.previewActivity.previewInQuestionEnd = null;
          } else {
            this.previewActivity.previewInQuestionEnd.show = true;
          }
          if (this.previewActivity.previewInQuestionEnd) {
            this.previewActivity.previewInQuestionEnd.show = false;
          }
        }
      }

      this.previewActivity.previewBasics.showReward = false;
      if (cDotId === TAB_REWARD) {
        this.previewActivity.previewBasics.showReward = this.state.showPreview;
      }
      this.previewActivity.previewBasics.reelInFocus = false;
      if (this.previewActivity.type === constants.activity.types.CHALLENGE && !this.state.isBlockedLoading) {
        if (isXS) {
          this.previewActivity.previewBasics.reelInFocus = this.state.showPreview || cDotId === TAB_REVIEW;
        } else {
          this.previewActivity.previewBasics.reelInFocus = cDotId === TAB_LIBRARY || cDotId === TAB_PREVIEW || cDotId === TAB_IN_QUESTION
            || cDotId === TAB_REEL_FRONT || cDotId === TAB_REVIEW;
        }
      }

      this.previewActivity.previewGamePlay.showCards = 0;
      this.previewActivity.previewGamePlay.showKeyCards = 0;
      if (cDotId === TAB_CUSTOMISE) {
        if (this.activityData.type === constants.activity.types.GAME_POKER) {
          this.previewActivity.previewGamePlay.showCards = 4;
          this.previewActivity.previewGamePlay.showKeyCards = 1;
        } else if (this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
          this.previewActivity.previewGamePlay.showCards = 6;
        } else if (this.activityData.type === constants.activity.types.GAME_FLIP_CARD) {
          this.previewActivity.previewGamePlay.showCards = 4;
        } else if (this.activityData.type === constants.activity.types.GAME_MATCH_PAIR) {
          this.previewActivity.previewGamePlay.showCards = 10;
        }
      } else if (cDotId === TAB_DEFAULTS) {
        if (this.activityData.type === constants.activity.types.GAME_POKER) {
          this.previewActivity.previewGamePlay.showCards = 5;
          this.previewActivity.previewGamePlay.showKeyCards = 0;
        }
      }

      if (this.refActivityView) {
        this.refActivityView.reloadPreview(this.previewActivity);
      }
    }
  }

  getDummyInternalQuestion = () => {
    return {
      id: -1,
      type: constants.activity.types.QUESTION,
      title: locStringA(this.context.intl, 'activity.questionHere'),
      qTitle: locStringA(this.context.intl, 'activity.questionHere'),
      qOptions: [
        {id: -1, name: locStringA(this.context.intl, 'activity.option1Here')},
        {id: -2, name: locStringA(this.context.intl, 'activity.option2Here')},
        {id: -3, name: locStringA(this.context.intl, 'activity.option3Here')},
        {id: -4, name: locStringA(this.context.intl, 'activity.option4Here')}
      ],
      isDummy: true
    };
  };

  assignNewData(data) {
    this.activityData = Object.assign(this.activityData, data);

    this.processPreviewActivity();
  }

  processTabs(onProcessed = null) {
    let {selectedDotIndex, subTabs} = this.state;
    const newSubTabs = this.getSubTabs();
    // TODO: added to test faster
    // selectedDotIndex = 8;

    if (newSubTabs.length <= selectedDotIndex) {
      selectedDotIndex = newSubTabs.length - 1;
    }
    if (this.loadChargeIndexInitially) {
      this.loadChargeIndexInitially = false;
      for (let i = 0; i < newSubTabs.length; i++) {
        if (newSubTabs[i].id === TAB_PRICE) {
          selectedDotIndex = i;
          break;
        }
      }
    }
    if (this.showSuccess) {
      this.showSuccess = false;
      this.activityData.isSuccess = true;
      selectedDotIndex = 0;
    }
    this.setState({subTabs: newSubTabs, selectedDotIndex: selectedDotIndex, isSuccess: this.activityData.isSuccess}, onProcessed);
  }

  getSubTabs() {
    const {isXS, user} = this.props;
    const type = this.activityData.type;
    const isVoucher = this.activityData.isVoucher;

    const typeNonOffers = type !== constants.activity.types.OFFER
      && type !== constants.activity.types.DISCOUNT
      && type !== constants.activity.types.VOUCHER;

    let subTabs = [];
    if (!this.isEditing()) {
      if (!this.usageType) {
        if (typeNonOffers) {
          subTabs.push({id: TAB_USAGE, labelId: 'campaign.tabCampaignGoal', hideNext: true});
        }
      }

      const labelId2 = type === constants.activity.types.OFFER
      || type === constants.activity.types.DISCOUNT
      || type === constants.activity.types.VOUCHER ? 'campaign.tabRewardLibrary' : 'campaign.tabFunActivityLibrary';
      subTabs.push({id: TAB_LIBRARY, labelId: labelId2, nextActionTextId: 'manage.chooseNStart'});

      // if (typeNonOffers) {
      //   subTabs.push({id: TAB_PREVIEW, labelId: 'campaign.tabPreview'});
      // }
    }

    if (this.manageType === 0) {
      if (!typeNonOffers) {
        subTabs.push({id: TAB_DETAIL, labelId: 'reward.tabDetails'});
      }

      if (type === constants.activity.types.PREDICTION) {
        subTabs.push({id: TAB_PREDICTION, labelId: 'campaign.tabPredict'});
      }
      else if (type === constants.activity.types.IDENTIFY_LOCATION) {
        subTabs.push({id: TAB_IDENTIFY_LOCATION, labelId: 'campaign.tabIdentifyLocation'});
      }
      else if (type === constants.activity.types.VISITOR_OPINION) {
        subTabs.push({id: TAB_OPINION, labelId: 'campaign.tabIdentifyLocation'});
      }
      else if (type === constants.activity.types.QUESTION
        || type === constants.activity.types.GUESS) {
        subTabs.push({id: TAB_QUESTION, labelId: 'campaign.tabQuestionOptions'});
      }
      else if (type === constants.activity.types.QUESTIONNAIRE || type === constants.activity.types.SURVEY) {
        subTabs.push({id: TAB_QUESTIONS, labelId: 'activity.tabQuestions'});
      }
      else if (this.activityData.type === constants.activity.types.SLIDES || this.activityData.type === constants.activity.types.SHOWCASE_MENU) {
        subTabs.push({id: TAB_SLIDES, labelId: 'campaign.tabSlides'});
      }
      if (isVoucher) {
        subTabs.push({id: TAB_VOUCHERS, labelId: 'campaign.tabVouchers'});
      }
      if (type !== constants.activity.types.CHALLENGE
        && type !== constants.activity.types.SOCIAL_CONTENT
        && type !== constants.activity.types.OFFER
        && type !== constants.activity.types.DISCOUNT
        && type !== constants.activity.types.SMART_AD) {
        subTabs.push({id: TAB_CUSTOMISE, labelId: 'campaign.tabCustomization'});
      }
    }

    if (typeNonOffers) {
      const hasPlans = this.activityData.adInfo
        && this.activityData.adInfo.canAd
        && this.activityData.adInfo.plans
        && this.activityData.adInfo.plans.length > 0;
      const oldPlanType = this.activityData.ad ? this.activityData.ad.planType : 0;

      const showCharges = hasPlans && (oldPlanType < constants.activity.plans.FREE_PLAN
        || (this.manageType === 1 && oldPlanType < constants.activity.plans.PAID_PLAN)
        || this.showPlanNCharge
      );
      // const isPaidPlan = ((this.activityData.ad && this.activityData.ad.planType === PLAN_TYPE_PAID) || this.activityData.planType === PLAN_TYPE_PAID);
      const isPaidPlan = this.activityData.adInfo != null;
      if (isPaidPlan) {
        if (this.manageType === 0 || this.manageType === 1) {
          // if (this.activityData.activityConfigs.slotTotalImages - this.activityData.activityConfigs.slotMaxImages > 0 || ActivityHelper.hasReverseImage(this.activityData.type)) {
          //   subTabs.push({id: TAB_DEFAULTS, labelId: 'campaign.tabDefaults'});
          // }
          // const showTabPlayTries = type === constants.activity.types.JACKPOT
          //   || type === constants.activity.types.GAME_ROULETTE
          //   || type === constants.activity.types.GAME_GREEDY_SPIN
          //   || type === constants.activity.types.GAME_BETTING_PIC
          //   || type === constants.activity.types.GAME_SPIN_N_DISCOVER
          //   || type === constants.activity.types.GAME_BRAND_RACE
          //   || type === constants.activity.types.GAME_POKER
          //   || type === constants.activity.types.GAME_TIC_TAC_TOE
          //   || type === constants.activity.types.GAME_FLIP_CARD
          //   || type === constants.activity.types.GAME_WHAC_A_MOLE
          //   || type === constants.activity.types.GAME_MATCH_PAIR
          //   || type === constants.activity.types.GAME_MATCH_THREE
          //   || type === constants.activity.types.GAME_PUZZLE
          //   || type === constants.activity.types.GAME_PUZZLE_SLIDE
          //   || type === constants.activity.types.QUESTION
          //   || type === constants.activity.types.QUESTIONNAIRE;
          // if (showTabPlayTries) {
          //   subTabs.push({id: TAB_GAME_ELEMENTS, labelId: 'campaign.tabPlayTries'});
          // }

          if (this.activityData.type === constants.activity.types.CHALLENGE || this.activityData.type === constants.activity.types.SOCIAL_CONTENT) {
            subTabs.push({id: TAB_REEL_FRONT, labelId: 'campaign.tabReelFront'});
          }
          if (this.activityData.type === constants.activity.types.CHALLENGE) {
            subTabs.push({id: TAB_REEL_SUB_POSTS, labelId: 'campaign.tabReelSubPosts'});
          }

          const showTabRewards = type !== constants.activity.types.OFFER
            && type !== constants.activity.types.VOUCHER
            && type !== constants.activity.types.DISCOUNT
            && type !== constants.activity.types.SMART_AD
            && type !== constants.activity.types.SLIDES
            && type !== constants.activity.types.SHOWCASE_MENU;
          if (showTabRewards) {
            subTabs.push({id: TAB_REWARD, labelId: 'campaign.tabReward'});
          }

          // const showWinLimit = showTabRewards && this.activityData.rewardState === constants.activity.state.ACTIVE;
          // let showResetGameDays = null;
          // if (!showWinLimit) {
          //   showResetGameDays = (this.activityData.usageType === constants.activity.usageTypes.MARKETING || this.activityData.usageType === constants.activity.usageTypes.LOYALTY)
          //     && (this.activityData.type === constants.activity.types.JACKPOT
          //       || this.activityData.type === constants.activity.types.GAME_GREEDY_SPIN
          //       || this.activityData.type === constants.activity.types.GAME_BETTING_PIC
          //       || this.activityData.type === constants.activity.types.GAME_ROULETTE
          //       || this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
          //       || this.activityData.type === constants.activity.types.GAME_FLIP_CARD
          //       || this.activityData.type === constants.activity.types.GAME_FIND_HIDDEN
          //       || this.activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
          //       || this.activityData.type === constants.activity.types.GAME_POKER
          //       || this.activityData.type === constants.activity.types.GAME_MATCH_PAIR
          //       || this.activityData.type === constants.activity.types.GAME_MATCH_THREE
          //       || this.activityData.type === constants.activity.types.GAME_PUZZLE
          //       || this.activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
          //       || this.activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
          //       || this.activityData.type === constants.activity.types.GAME_BRAND_RACE);
          // }
          // if (showWinLimit || showResetGameDays) {
          //   subTabs.push({id: TAB_RECUR, labelId: showResetGameDays ? 'campaign.tabRecur' : 'campaign.tabWinLimit'});
          // }

          const showCTAs = this.activityData.type !== constants.activity.types.CHALLENGE
            && this.activityData.type !== constants.activity.types.SHOWCASE_MENU
            && this.activityData.type !== constants.activity.types.SOCIAL_CONTENT;
          // if (showCTAs) {
          //   if (this.isMobile) {
          //     subTabs.push({id: TAB_CTA1, labelId: 'campaign.tabCTA1'});
          //
          //     if (this.activityData.type !== constants.activity.types.CHALLENGE
          //       && this.activityData.type !== constants.activity.types.SOCIAL_CONTENT) {
          //       subTabs.push({id: TAB_CTA2, labelId: 'campaign.tabCTA2'});
          //     }
          //   } else {
          //     subTabs.push({id: TAB_CTA, labelId: 'campaign.tabCTA'});
          //   }
          // }
          if (showCTAs) {
            subTabs.push({id: TAB_CTA2, labelId: 'campaign.tabCTA2'});
          }

          // subTabs.push({id: TAB_TARGETING, labelId: 'campaign.tabTargeting'});

          // if (this.activityData.usageType === constants.activity.usageTypes.MARKETING
          //   || this.activityData.usageType === constants.activity.usageTypes.INFLUENCER) {
          //   if (this.activityData.type === constants.activity.types.CHALLENGE
          //     || this.activityData.type === constants.activity.types.SOCIAL_CONTENT
          //     || this.activityData.type === constants.activity.types.VISITOR_OPINION
          //     || this.activityData.type === constants.activity.types.QUESTION
          //     || this.activityData.type === constants.activity.types.QUESTIONNAIRE
          //     || this.activityData.type === constants.activity.types.SURVEY
          //     || this.activityData.type === constants.activity.types.PREDICTION
          //     || this.activityData.type === constants.activity.types.GUESS
          //     || this.activityData.type === constants.activity.types.IDENTIFY_LOCATION
          //     || this.activityData.type === constants.activity.types.LIKE_USER
          //     || this.activityData.type === constants.activity.types.COLLECT_STARS
          //     || this.activityData.type === constants.activity.types.JACKPOT
          //     || this.activityData.type === constants.activity.types.GAME_GREEDY_SPIN
          //     || this.activityData.type === constants.activity.types.GAME_BETTING_PIC
          //     || this.activityData.type === constants.activity.types.GAME_ROULETTE
          //     || this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
          //     || this.activityData.type === constants.activity.types.GAME_FLIP_CARD
          //     || this.activityData.type === constants.activity.types.GAME_FIND_HIDDEN
          //     || this.activityData.type === constants.activity.types.GAME_MATCH_PAIR
          //     || this.activityData.type === constants.activity.types.GAME_MATCH_THREE
          //     || this.activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
          //     || this.activityData.type === constants.activity.types.GAME_POKER
          //     || this.activityData.type === constants.activity.types.GAME_PUZZLE
          //     || this.activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
          //     || this.activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
          //     || this.activityData.type === constants.activity.types.GAME_BRAND_RACE) {
          //     subTabs.push({id: TAB_REFERRAL, labelId: 'campaign.tabReferral'});
          //   }
          // }

          // const canAddInQuestion = type !== constants.activity.types.QUESTION
          //   && (!this.isEditing() || this.oldActivity.inQuestion);
          const canAddInQuestion = isUserPrivileged(this.props.user)
            && type !== constants.activity.types.SLIDES
            && type !== constants.activity.types.SHOWCASE_MENU;
          if (canAddInQuestion) {
            subTabs.push({id: TAB_IN_QUESTION, labelId: 'campaign.tabQuestionOptions'});
          }

          // subTabs.push({id: TAB_DETAIL, labelId: 'campaign.tabDetails'});

          if (isUserImageDummy(this.props.user.imageUrl) || !this.props.user.name) {
            subTabs.push({id: TAB_USER_INFO, labelId: 'campaign.tabUserInfo'});
          }

          subTabs.push({id: TAB_REVIEW, labelId: 'campaign.tabReview'});
        }

        if (showCharges || this.showCharge || this.manageType === 2) {
          this.shouldMoveToPlanAfterSave = true;
          if (subTabs.length === 0) {
            this.shouldMoveToPlanAfterSave = false;
            subTabs.push({id: TAB_PRICE, labelId: this.manageType === 2 ? 'campaign.tabRecharge' : 'campaign.tabCharge', hideNext: !isXS, nextActionTextId: this.activityData.planPay > 0 ? 'activity.payNPublish' : 'activity.publishNow'});
            if (user.registerType) {
              subTabs.push({id: TAB_PAYMENT, labelId: 'campaign.tabPayment', hideNext: true});
            }
          }
        }
      }
    }

    return subTabs;
  }

  isEditing() {
    return this.isInEdit;
  }

  isReward() {
    return this.activityData.type === constants.activity.types.OFFER
      || this.activityData.type === constants.activity.types.DISCOUNT
      || this.activityData.type === constants.activity.types.VOUCHER;
  }

  isShowingRewards() {
    const {history} = this.props;
    const path = get(history, 'location.pathname');
    return path.startsWith('/rewards');
  }

  getCampaignUsageType() {
    if (this.activityData && this.activityData.usageType > 0) {
      return this.activityData.usageType;
    }
    // const {history} = this.props;
    // const path = get(history, 'location.pathname');
    // if (path.startsWith('/marketingCampaigns')) {
    //   return constants.activity.usageTypes.MARKETING;
    // }
    // if (path.startsWith('/loyaltyCampaigns')) {
    //   return constants.activity.usageTypes.LOYALTY;
    // }
    // if (path.startsWith('/educationCampaigns')) {
    //   return constants.activity.usageTypes.EDUCATION;
    // }
    // if (path.startsWith('/trainingCampaigns')) {
    //   return constants.activity.usageTypes.TRAINING;
    // }
    // if (path.startsWith('/socialCampaigns')) {
    //   return constants.activity.usageTypes.SOCIAL;
    // }
    // if (path.startsWith('/influencerCampaigns')) {
    //   return constants.activity.usageTypes.INFLUENCER;
    // }
    return this.usageType;
  }

  render() {
    const {classes, isLoading, activities, app, isDrawerHidden, isXS} = this.props;
    const title = this.getHeaderTitle();

    if (!this.activityData) {
      return (
        <div className={classes.flexColumn}>
          <HeaderTitleView isLTR={app.isLTR} isXS={isXS} title={null} />
          {this.getErrorViewNoActivity()}
        </div>
      );
    }

    const {subTabs, selectedDotIndex} = this.state;
    const isSuccess = this.activityData.isSuccess;

    let labelUpdateId = 'activity.manage.updated';
    let labelAddId = 'activity.manage.created';
    if (this.activityData && (this.activityData.type === constants.activity.types.OFFER
      || this.activityData.type === constants.activity.types.DISCOUNT
      || this.activityData.type === constants.activity.types.VOUCHER)) {
      labelUpdateId = 'activity.manage.rewardUpdated';
      labelAddId = 'activity.manage.rewardAdded';
    } else if (this.activityData && (this.activityData.type === constants.activity.types.SHOWCASE_MENU)) {
      labelUpdateId = 'activity.showcaseMenuUpdated';
      labelAddId = 'activity.showcaseMenuCreated';
    }
    let successTitleTextKey = null;
    if (isSuccess) {
      if (this.isEditing()) {
        successTitleTextKey = labelUpdateId;
      } else {
        successTitleTextKey = labelAddId;
      }
    }
    const showSuccessFull = isSuccess && !this.isShowingRewards();
    const showPayment = this.activityData.planRecharge && this.activityData.planRecharge.ePlanPrice > 0;
    const showTabs = !showSuccessFull && !showPayment && !isLoading && subTabs;

    let nextButtonTextId = null;
    if (!subTabs[selectedDotIndex].hideNext) {
      if (selectedDotIndex === subTabs.length - 1) {
        if (subTabs[selectedDotIndex].id === TAB_PRICE) {
          nextButtonTextId = this.activityData.planPay > 0 ? 'activity.payNPublish' : 'activity.publishNow';
        } else {
          // nextButtonTextId = (this.isEditing() ? 'manage.save' : 'campaign.save');
          nextButtonTextId = (this.isEditing() ? 'manage.nxt' : 'manage.nxt');
        }
      } else if (subTabs[selectedDotIndex].nextActionTextId) {
        if (subTabs[selectedDotIndex].id === TAB_PRICE) {
          nextButtonTextId = this.activityData.planPay > 0 ? 'activity.payNPublish' : 'activity.publishNow';
        } else {
          nextButtonTextId = subTabs[selectedDotIndex].nextActionTextId;
        }
      } else {
        nextButtonTextId = 'manage.nxt';
      }
    }
    // if (subTabs[selectedDotIndex].id === TAB_PRICE) {
    //   nextButtonTextId = 'activity.manage.payNow';
    // }

    // const showNormal = !isCurrentPlanNoPlan(this.activityData.ad) && !isCurrentPlanEnded(this.activityData.ad)
    //                   && this.activityData.ad && this.activityData.ad.planType > 2;
    // const showDirect = !isCurrentPlanNoPlan(this.activityData.ad) && !isCurrentPlanEnded(this.activityData.ad);
    const showNormal = !isCurrentPlanNoPlan(this.activityData.ad) && !isCurrentPlanEnded(this.activityData.ad);
    const showDirect = false;

    const disableNext = this.activityData['disableNext'+ subTabs[selectedDotIndex].id];
    // const showSaveNExit = this.isEditing() && selectedDotIndex < subTabs.length - 1
    //   && subTabs[selectedDotIndex].id !== TAB_PRICE
    //   && subTabs[selectedDotIndex].id !== TAB_PAYMENT;
    const showSaveNExit = false;
    // const backNavEdit = this.blockNavToLastIndex && subTabs[selectedDotIndex].id === TAB_PRICE;
    const backNavEdit = false;

    const {enableAction, isBlockedLoading, loaderMessage, loadingProgress} = this.state;
    const disableAction = !enableAction || isBlockedLoading;
    const disableNextAction = disableAction;
    const toolbarHeight = isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT;
    const subTabId = subTabs[selectedDotIndex].id;
    return (
      <div className={classes.container}>
        {!isDrawerHidden && !this.activityData.planRecharge ?
          <HeaderTitleView isLTR={app.isLTR} isDrawerHidden={isDrawerHidden} isXS={isXS} title={title}/>
          : null
        }

        {showSuccessFull ?
          <Paper elevation={0} className={classes.formManageActivityDone}>
            <div className={classes.viewColumnFullWidth} style={{minHeight: 200, justifyContent: 'center', paddingLeft: isXS ? 0 : 16, paddingRight: isXS ? 0 : 16, position: 'relative', marginTop: isXS ? -16 : 0}}>
              {/*<Space horizontal={isDrawerHidden ? FIELD_SPACE : 2 * FIELD_SPACE} />*/}
              <Typography variant={'h5'} align={'center'} className={classes.typoBold} style={{color: ColorTitle}}>{<FormattedHTMLMessage id={successTitleTextKey} />}</Typography>
              {/*<Space horizontal={FIELD_SPACE} />*/}
              {/*<Typography variant={'subtitle1'} className={classes.typoMedium} color={'textSecondary'} align={'center'}>{<FormattedHTMLMessage id={'campaign.maximizeQRBenefit'} />}</Typography>*/}
              <Space horizontalSpace={2} />

              {this.activityData && this.activityData.type !== constants.activity.types.SHOWCASE_MENU ?
                <div className={classes.viewRowFullWidthNoCenter} style={{flexWrap: 'wrap', justifyContent: 'center'}}>
                  {this.getSubscriptionPlanView()}

                  {showNormal ?
                    <div className={classes.planCard}>
                      <div className={classes.flexColumn}>
                        <TextView variant="subtitle1" color={ColorSubTitle} align={'center'}>{<FormattedHTMLMessage id={'campaign.maximizeQRBenefit'} />}</TextView>
                        <Space horizontalSpace={1.5}/>
                        {/*<Typography variant={'body1'} color={'textSecondary'} align={'center'}>{<FormattedMessage id={'activity.manage.normalLinkDetail'} />}</Typography>*/}
                        <Space horizontal={FIELD_SPACE} />
                        <div style={{height: "auto", maxWidth: 240, width: "100%"}}>
                          <QRCode
                            id={'QRCodeShare'}
                            size={240}
                            style={{height: "auto", maxWidth: "100%", width: "100%"}}
                            value={`${this.activityData.shUrl}`}
                            viewBox={`0 0 240 240`}
                            level={'M'}
                          />
                        </div>
                        <Space horizontal={FIELD_SPACE} />
                        <div className={classes.viewFullWidthWrapCenter}>
                          <Button
                            size={'small'}
                            variant={'outlined'}
                            color={"secondary"}
                            onClick={() => {
                              this.downloadQRCode('QRCodeShare');
                              // this.setState({snackbarMessageId: 'activity.manage.promoteToDownloadQR', snackbarType: 'error'})
                            }}
                            className={classes.buttonCamelCase}>
                            {<FormattedMessage id='activity.manage.downloadQR' />}
                          </Button>
                          <Space vertical={FIELD_SPACE/2} />
                          <Button
                            size={'small'}
                            variant={'outlined'}
                            color={"secondary"}
                            onClick={() => {
                              navigator.clipboard.writeText(this.activityData.shUrl);
                              this.setState({snackbarMessageId: 'activity.manage.shareLinkCopied'})
                              // const fallback = () => {
                              //   this.setState({snackbarMessageId: 'activity.manage.shareLinkCopied'})
                              // };
                              // AppUtils.shareActivity(this.activityData, this.context.intl, this.activityData.shUrl, fallback);
                            }}
                            className={classes.buttonCamelCase}>
                            {<FormattedMessage id='activity.manage.copyLink' />}
                          </Button>
                          <Space vertical={FIELD_SPACE/2} />
                          <Button
                            size={'small'}
                            variant={'outlined'}
                            color={"secondary"}
                            onClick={() => {
                              navigateToPlay(this.activityData, true)
                            }}
                            className={classes.buttonCamelCase}>
                            {<FormattedMessage id='activity.openLink' />}
                          </Button>
                        </div>
                      </div>
                      <Space horizontal={8} />
                    </div>
                    : null
                  }
                  {showDirect ?
                    <div className={classes.planCard}>
                      <div className={classes.flexColumn} >
                        <TextView variant="h6" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} >{<FormattedMessage id={'activity.manage.directLink'} />}</TextView>
                        <Space horizontalSpace={1.5}/>
                        <Typography variant={'body1'} color={'textSecondary'} align={'center'}>{<FormattedMessage id={this.activityData.ad && this.activityData.ad.planType > 2 ? 'activity.manage.directLinkDetail' : 'activity.manage.directLinkDetailFree'} />}</Typography>
                        <Space horizontal={FIELD_SPACE} />
                        <div style={{height: "auto", maxWidth: 240, width: "100%"}}>
                          <QRCode
                            id={'QRCodeDirectAccess'}
                            size={240}
                            style={{height: "auto", maxWidth: "100%", width: "100%"}}
                            value={`${APP_URI}${getPathForActivity(this.activityData)}/${this.activityData.sId}`}
                            viewBox={`0 0 240 240`}
                            level={'M'}
                          />
                        </div>
                        <Space horizontal={FIELD_SPACE} />
                        <div className={classes.viewRow}>
                          <Button
                            size={'small'}
                            variant={'outlined'}
                            color={"primary"}
                            onClick={() => {
                              this.downloadQRCode('QRCodeDirectAccess');
                              this.setState({snackbarMessageId: 'activity.manage.directQRCopied'})
                            }}
                            className={classes.buttonCamelCase}>
                            {<FormattedMessage id='activity.manage.downloadQR' />}
                          </Button>
                          <Space vertical={FIELD_SPACE/2} />
                          <Button
                            size={'small'}
                            variant={'outlined'}
                            color={"primary"}
                            onClick={() => {
                              navigator.clipboard.writeText(`${APP_URI}${getPathForActivity(this.activityData)}/${this.activityData.sId}`);
                              this.setState({snackbarMessageId: 'activity.manage.directLinkCopied'})
                            }}
                            className={classes.buttonCamelCase}>
                            {<FormattedMessage id='activity.manage.copyLink' />}
                          </Button>
                        </div>
                      </div>
                      <Space horizontal={8} />
                    </div>
                    : null
                  }
                </div>
                : null
              }
              <FieldSpace multiplier={2} />
              <Button
                disableElevation={true}
                size={isXS ? 'medium' : 'large'}
                variant={'contained'}
                color={"primary"}
                onClick={this.onBackClicked}>
                {<FormattedMessage id={'back'} />}
              </Button>
              <FieldSpace />
            </div>
          </Paper>
          : null
        }
        {showPayment ? this.getPaymentView() : null}
        {showTabs && (
          <div className={classes.viewManageActivity}>
            <AppBar
              elevation={0}
              className={classes.appBarContainer}
              position="fixed"
              color="default">
              <div className={classes.viewTabBar} style={{paddingLeft: !isDrawerHidden && app.isLTR ? DRAWER_WIDTH+1 : 0, paddingRight: !isDrawerHidden && !app.isLTR ? DRAWER_WIDTH+1 : 0}}>
                {isDrawerHidden ?
                  <div className={classes.viewBarTopManage} style={{pointerEvents: 'auto'}}>
                    {!isXS ?
                      <React.Fragment>
                        <Space vertical={12}/>
                        <Button
                          disableElevation={true}
                          size={isXS ? 'small' : 'medium'}
                          variant={backNavEdit ? 'contained' : 'outlined'}
                          color={"secondary"}
                          style={{minWidth: isXS ? 48 : 60}}
                          onClick={this.onEditPreviousClicked}>
                          {<FormattedHTMLMessage id={backNavEdit ? 'generic.edit' : selectedDotIndex === 0 || this.showCharge ? 'generic.back' : isXS ? 'activity.actionPrevious' : 'activity.actionPreviousC'} />}
                        </Button>
                      </React.Fragment>
                      : null
                    }
                    <TextView fontSizeN={isXS ? 14 : 0} numberOfLines={2} textAlign={'center'} variant={"h6"} text={isXS ? <FormattedMessage id={this.getTopHintLabelId()} /> : title} color={ColorNav} fontWeight={FontWeightMedium} style={{flex: 1, marginLeft: 12, marginRight: 12}} />
                    <React.Fragment>
                      {showSaveNExit ?
                        <React.Fragment>
                          <Button
                            disableElevation={true}
                            size={isXS ? 'small' : 'medium'}
                            variant={'outlined'}
                            color={"primary"}
                            onClick={this.onClickSaveNExit}
                            disabled={disableNextAction || disableNext}
                            style={{minWidth: isXS ? 48 : 110}}>
                            {<FormattedHTMLMessage id={isXS ? 'activity.actionUpdate' : 'activity.saveNExit'} />}
                          </Button>
                          <Space vertical={12}/>
                        </React.Fragment>
                        : null
                      }
                      {!isXS ?
                        <React.Fragment>
                          <Button
                            disableElevation={true}
                            size={isXS ? 'small' : 'medium'}
                            variant={'contained'}
                            color={"primary"}
                            onClick={this.onClickNext}
                            disabled={!nextButtonTextId}
                            style={{opacity: nextButtonTextId ? 1 : 0, minWidth: isXS ? 48 : 110}}>
                            {nextButtonTextId ? <FormattedMessage id={nextButtonTextId} /> : null}
                          </Button>
                          <Space vertical={12}/>
                        </React.Fragment>
                        : null
                      }
                    </React.Fragment>
                  </div>
                  : null
                }
                <div className={classes.viewBarContainer}>
                  {!isDrawerHidden ?
                    <Button
                      disableElevation={true}
                      size={isXS ? 'medium' : 'large'}
                      variant={backNavEdit ? 'contained' : 'outlined'}
                      color={"secondary"}
                      style={{marginLeft: app.isLTR ? 0 : 16, marginRight: !app.isLTR ? 0 : 16, pointerEvents: 'auto'}}
                      onClick={this.onEditPreviousClicked}>
                      {<FormattedHTMLMessage id={backNavEdit ? 'generic.edit' : selectedDotIndex === 0 || this.showCharge ? 'generic.back' : isXS ? 'activity.actionPrevious' : 'activity.actionPreviousC'} />}
                    </Button>
                    : null
                  }
                  {!isXS ?
                    <div className={classes.appBarText} >
                      <Typography color={"textPrimary"} variant={isXS ? "body2" : "body1"} className={isXS ? classes.typoBold : classes.typoMedium} style={{paddingLeft: 2, paddingRight: 2}}>
                        <FormattedMessage id={this.getTopHintLabelId()} />
                      </Typography>
                      {/*<FormattedMessage id={subTabs[selectedDotIndex].subLabelId} />*/}
                    </div>
                    : null
                  }
                  {!isDrawerHidden && nextButtonTextId ?
                    <div className={classes.buttonActionContainer}>
                      {showSaveNExit ?
                        <React.Fragment>
                          <Button
                            disableElevation={true}
                            size={isXS ? 'medium' : 'large'}
                            variant={'outlined'}
                            color={"primary"}
                            onClick={this.onClickSaveNExit}
                            disabled={disableNextAction || disableNext}
                            style={{minWidth: 130}}>
                            {<FormattedMessage id={'activity.saveNExit'} />}
                          </Button>
                          <Space vertical={16}/>
                        </React.Fragment>
                        : null
                      }
                      <Button
                        disableElevation={true}
                        size={isXS ? 'medium' : 'large'}
                        variant={'contained'}
                        color={"primary"}
                        onClick={this.onClickNext}
                        disabled={disableNextAction || disableNext}
                        style={{minWidth: 130}}>
                        {<FormattedMessage id={nextButtonTextId} />}
                      </Button>
                    </div>
                    : null
                  }
                </div>
              </div>
            </AppBar>
            {this.getErrorView()}

            <Paper elevation={isXS ? 0 : 0} className={subTabId === TAB_USAGE ? classes.formManageActivityUsage : (subTabId === TAB_REVIEW && this.activityData.type === constants.activity.types.SHOWCASE_MENU ? classes.formManageActivityShowcaseMenuReview : classes.formManageActivity)}>
              {this.getActivityView()}
            </Paper>

            {isXS ?
              <div style={{paddingTop: BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY + 12}}>
                <AppBar style={{position: 'fixed', zIndex: zIndex.drawer + 1, top: 'auto', bottom: 0, left: 0, right: 0, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', backgroundColor: ColorWhite, height: BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY}}>
                  <div className={classes.viewRowFullWidth} style={{justifyContent: 'center', padding: 0, paddingTop: 0, paddingBottom: 0}}>
                    <Paper className={classes.flexRow} style={{minHeight: BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY, borderRadius: 0, borderStyle: 'solid', borderWidth: 0, borderTopWidth: 0, borderBottomWidth: 0, borderColor: ColorDividerDark}}>
                      <Space vertical={12}/>
                      <Button
                        disabled={this.state.showPreview}
                        disableElevation={true}
                        variant={backNavEdit ? 'contained' : 'outlined'}
                        color={"secondary"}
                        // size={'large'}
                        style={{minWidth: isXS ? 48 : 60}}
                        onClick={this.onEditPreviousClicked}>
                        {<FormattedHTMLMessage id={backNavEdit ? 'generic.edit' : selectedDotIndex === 0 || this.showCharge ? 'generic.back' : isXS ? 'activity.actionPrevious' : 'activity.actionPreviousC'} />}
                      </Button>
                      <div className={classes.flex1}/>

                      <Button
                        disableElevation={true}
                        variant={'contained'}
                        color={"primary"}
                        // size={'large'}
                        onClick={this.onClickNext}
                        disabled={!nextButtonTextId || this.state.showPreview || !this.activityData.type}
                        style={{opacity: nextButtonTextId && subTabs[selectedDotIndex].id !== TAB_LIBRARY ? 1 : 0, minWidth: isXS ? 48 : 110}}>
                        {nextButtonTextId ? <FormattedMessage id={nextButtonTextId} /> : null}
                      </Button>
                      <Space vertical={12}/>
                    </Paper>
                  </div>
                </AppBar>
              </div>
              : null
            }
          </div>
        )}
        {isBlockedLoading && <ProgressLoaderBig progress={loadingProgress} title={loaderMessage} />}
        {this.getDialogView()}
        {this.renderSnackBar()}
      </div>
    );
  }

  getDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    return (
      <DialogView
        classes={classes}
        show={showDialog}
        {...dialogInfo}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      changeNavColor(ColorStatusDialog);
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog = () => {
    changeNavColor(this.props.isXS ? ColorBackgroundXS : ColorBackground);
    this.setState({showDialog: false, dialogInfo: null});
  }

  onJoinRab7Done = (result) => {
    this.hideDialog();
    if (result === 1) {
      this.oldPlan = {
        planType: this.activityData.planType,
        planDuration: this.activityData.planDuration,
        planViews: this.activityData.planViews,
        planDailyViews: this.activityData.planDailyViews,
        planPrice: this.activityData.planPrice,
        planPayCurrency: this.activityData.planPayCurrency,
        planPayCurrencyCode: this.activityData.planPayCurrencyCode,
        planPay: this.activityData.planPay,
        planPayPoints: this.activityData.planPayPoints,
        planPayPointsValue: this.activityData.planPayPointsValue,
        planPaySuccess: this.activityData.planPaySuccess,
      }
      this.fetchData();
    } else if (result === -1) {
      this.stopHistoryListeners();
    }
  }

  onPickPlanClicked = () => {
    this.activityData.isSuccess = false;
    this.manageType = 2;
    this.showCharge = true;
    this.loadChargeIndexInitially = true;
    this.blockNavToLastIndex = true;
    this.processTabs();
  };

  onMoveToJoinRab7 = () => {
    this.stopHistoryListeners();
    this.props.history.replace({
      pathname: PathJoin,
      search: getRedirectSearch({
        pathname: `${PathCampaignManage}/${this.activityData.id}`,
        search: '?p=2',
      }),
    });
  }

  onSaveOkClicked = () => {
    this.hideDialog();
    this.saveActivityData();
  }

  renderButtonClose() {
    const {classes} = this.props;
    return (
      <Button
        disableElevation
        variant={'contained'}
        color="primary"
        size={'small'}
        className={classes.buttonCamelCase}
        onClick={this.navBackToList}>
        <FormattedMessage id={'activity.manage.close'} />
      </Button>
    );
  }

  renderSnackBar() {
    const {snackbarMessageId, snackbarMessage, snackbarType} = this.state;
    const onClose = () => {
      this.setState({snackbarMessageId: null, snackbarMessage: null, snackbarType: null});
    };
    return (
      <Snackbar open={snackbarMessageId || snackbarMessage} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
        <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
          {snackbarMessageId ? <FormattedMessage id={snackbarMessageId} /> : snackbarMessage}
        </MuiAlert>
      </Snackbar>
    );
  }

  getNavButtonsView(nextButtonTextId) {
    const {app, classes} = this.props;
    const {enableAction, isBlockedLoading, subTabs, selectedDotIndex} = this.state;
    const disableAction = !enableAction || isBlockedLoading;
    const disableNext = this.activityData['disableNext'+ subTabs[selectedDotIndex].id];
    return (
      <div className={classes.flexRow} style={{BackgroundColor: ColorWhite, zIndex: zIndex.appBar, marginTop: 6, paddingLeft: 8, paddingRight: 8}}>
        <Button
          size={'small'}
          variant={'outlined'}
          color={"primary"}
          startIcon={app.isLTR ? <BackIcon fontSize={'small'} /> : <NextIcon fontSize={'small'} />}
          onClick={(event) => this.onClickPrevious(event)} disabled={disableAction || selectedDotIndex === 0} className={classes.buttonCamelCase} style={{opacity: selectedDotIndex === 0 ? 0 : 1}}>
          {<FormattedMessage id='manage.prev' />}
        </Button>
        <div className={classes.flexColumn}>
          <Typography color={"primary"} variant={"subtitle1"} className={classes.typoBold}>
            <FormattedMessage id={subTabs[selectedDotIndex].labelId} />
          </Typography>
        </div>
        <Button
          size={'small'}
          variant={'contained'}
          color={"primary"}
          endIcon={app.isLTR ? <NextIcon fontSize={'small'} /> : <BackIcon fontSize={'small'} />}
          onClick={(event) => this.onClickNext(event)}
          disabled={disableAction || disableNext}
          className={classes.buttonCamelCase}>
          {<FormattedMessage id={nextButtonTextId} />}
        </Button>
      </div>
    );
  }

  getTopHintLabelId() {
    const {isXS} = this.props;
    const {selectedDotIndex, subTabs} = this.state;
    const cDotId = subTabs[selectedDotIndex].id;

    if (isXS) {
      if (cDotId === TAB_USAGE) {
        return 'activity.tabUsage';
      }
      if (cDotId === TAB_LIBRARY) {
        return 'activity.tabType';
      }
      if (cDotId === TAB_CUSTOMISE) {
        if (this.activityData.activityConfigs.slotMaxImages > 0) {
          return 'activity.tabCustomizeGame';
        }
        return 'activity.tabCustomize';
      }
      if (cDotId === TAB_REEL_FRONT) {
        return 'activity.tabReelFront';
      }
      if (cDotId === TAB_REEL_SUB_POSTS) {
        return 'activity.tabReelSubPosts';
      }
      if (cDotId === TAB_SLIDES) {
        return 'campaign.tabSlides';
      }
      if (cDotId === TAB_DETAIL) {
        return 'activity.tabDetails';
      }
      if (cDotId === TAB_CTA) {
        return 'activity.tabCTA';
      }
      if (cDotId === TAB_CTA1) {
        return 'activity.tabCTA1';
      }
      if (cDotId === TAB_CTA2) {
        return 'activity.tabCTA2';
      }
      if (cDotId === TAB_REFERRAL) {
        return 'activity.tabReferral';
      }
      if (cDotId === TAB_TARGETING) {
        return 'activity.tabTargeting';
      }
      if (cDotId === TAB_REVIEW) {
        return 'activity.finalPreview';
      }
      if (cDotId === TAB_USER_INFO) {
        return 'campaign.tabUserInfo';
      }
      if (cDotId === TAB_PRICE) {
        return 'activity.tabPrice';
      }
      if (cDotId === TAB_PAYMENT) {
        return 'campaign.tabPayment';
      }
      if (cDotId === TAB_QUESTIONS) {
        return 'activity.tabQuestions';
      }
      if (cDotId === TAB_QUESTION) {
        if (this.activityData.type === constants.activity.types.GUESS) {
          return 'activity.tabGuess';
        }
        return 'activity.tabQuestion';
      }
      if (cDotId === TAB_IN_QUESTION) {
        return 'activity.tabQuestion';
      }
      if (cDotId === TAB_PREDICTION) {
        return 'activity.tabPrediction';
      }
      if (cDotId === TAB_IDENTIFY_LOCATION) {
        return 'activity.tabIdentifyLocation';
      }
      if (cDotId === TAB_OPINION) {
        return 'activity.tabOpinion';
      }
      if (cDotId === TAB_REWARD) {
        return 'activity.tabReward';
      }
      if (cDotId === TAB_VOUCHERS) {
        return 'activity.tabVoucher';
      }
      return 'activity.empty';
    }

    let topHintLabelId = null;
    if (cDotId === TAB_USAGE) {
      topHintLabelId = 'activity.tabUsageHint';
    } else if (cDotId === TAB_LIBRARY) {
      topHintLabelId = 'activity.tabTypeHint';
    } else if (cDotId === TAB_RECUR) {
      const showWinLimit = this.activityData.rewardState === constants.activity.state.ACTIVE;
      let showResetGameDays = null;
      if (!showWinLimit) {
        showResetGameDays = (this.activityData.usageType === constants.activity.usageTypes.MARKETING || this.activityData.usageType === constants.activity.usageTypes.LOYALTY)
          && (this.activityData.type === constants.activity.types.JACKPOT
            || this.activityData.type === constants.activity.types.GAME_GREEDY_SPIN
            || this.activityData.type === constants.activity.types.GAME_BETTING_PIC
            || this.activityData.type === constants.activity.types.GAME_ROULETTE
            || this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
            || this.activityData.type === constants.activity.types.GAME_FLIP_CARD
            || this.activityData.type === constants.activity.types.GAME_FIND_HIDDEN
            || this.activityData.type === constants.activity.types.GAME_MATCH_THREE
            || this.activityData.type === constants.activity.types.GAME_MATCH_PAIR
            || this.activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
            || this.activityData.type === constants.activity.types.GAME_POKER
            || this.activityData.type === constants.activity.types.GAME_PUZZLE
            || this.activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
            || this.activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
            || this.activityData.type === constants.activity.types.GAME_BRAND_RACE
            || this.activityData.type === constants.activity.types.QUESTIONNAIRE
            || this.activityData.type === constants.activity.types.SURVEY
            || this.activityData.type === constants.activity.types.EXTERNAL_GAMES);
      }
      topHintLabelId = showResetGameDays ? 'activity.tabRecurHint' : 'activity.tabWinHint';
    } else if (cDotId === TAB_PLAN) {
      topHintLabelId = 'activity.tabPlanHint';
    } else if (cDotId === TAB_CUSTOMISE) {
      topHintLabelId = 'activity.tabCustomizeFunHint';
      if (this.activityData.activityConfigs.slotMaxImages > 0) {
        topHintLabelId = 'activity.tabCustomizeHint';
      }
    } else if (cDotId === TAB_REEL_FRONT) {
      topHintLabelId = 'activity.tabReelFrontHint';
    } else if (cDotId === TAB_REEL_SUB_POSTS) {
      topHintLabelId = 'campaign.tabReelSubPostsHint';
    } else if (cDotId === TAB_SLIDES) {
      topHintLabelId = 'campaign.tabSlidesHint';
    } else if (cDotId === TAB_DEFAULTS) {
      topHintLabelId = 'activity.tabDefaultHint';
    } else if (cDotId === TAB_GAME_ELEMENTS) {
      if (this.activityData.type === constants.activity.types.QUESTION) {
        topHintLabelId = 'activity.tabGamePlayQuestionHint';
      } else if (this.activityData.type === constants.activity.types.QUESTIONNAIRE) {
        topHintLabelId = 'activity.tabGamePlayQuestionnaireHint';
      } else if (this.activityData.type === constants.activity.types.GAME_FLIP_CARD) {
        topHintLabelId = 'activity.tabFlipTriesHint';
      } else {
        topHintLabelId = 'activity.tabPlayTriesHint';
      }
    } else if (cDotId === TAB_DETAIL) {
      topHintLabelId = 'activity.tabDetailsHint';
    } else if (cDotId === TAB_CTA) {
      topHintLabelId = 'activity.tabCTAHint';
    } else if (cDotId === TAB_CTA1) {
      topHintLabelId = 'activity.tabCTA1Hint';
    } else if (cDotId === TAB_CTA2) {
      topHintLabelId = 'activity.tabCTA2Hint';
    } else if (cDotId === TAB_REFERRAL) {
      topHintLabelId = 'activity.tabReferralHint';
    } else if (cDotId === TAB_TARGETING) {
      topHintLabelId = 'activity.tabTargetingHint';
    } else if (cDotId === TAB_REVIEW) {
      topHintLabelId = 'activity.finalPreview';
    } else if (cDotId === TAB_USER_INFO) {
      topHintLabelId = 'campaign.tabUserInfo';
    } else if (cDotId === TAB_PRICE) {
      topHintLabelId = 'activity.tabPriceHint';
    } else if (cDotId === TAB_PAYMENT) {
      topHintLabelId = 'campaign.tabPaymentL';
    } else if (cDotId === TAB_QUESTIONS) {
      topHintLabelId = 'activity.tabQuestionsHint';
    } else if (cDotId === TAB_QUESTION) {
      if (this.activityData.type === constants.activity.types.GUESS) {
        topHintLabelId = 'activity.tabGuessHint';
      } else {
        topHintLabelId = 'activity.tabQuestionHint';
      }
    } else if (cDotId === TAB_IN_QUESTION) {
      topHintLabelId = 'activity.tabInQuestionHint';
    } else if (cDotId === TAB_PREDICTION) {
      topHintLabelId = 'activity.tabPredictionHint';
    } else if (cDotId === TAB_IDENTIFY_LOCATION) {
      topHintLabelId = 'activity.tabIdentifyLocationHint';
    } else if (cDotId === TAB_OPINION) {
      topHintLabelId = 'activity.tabOpinionHint';
    } else if (cDotId === TAB_REWARD) {
      topHintLabelId = 'activity.tabRewardHint';
    } else if (cDotId === TAB_VOUCHERS) {
      topHintLabelId = 'activity.tabVoucherHint';
    } else {
      topHintLabelId = 'activity.empty';
    }
    return topHintLabelId;
  }

  getPaymentView() {
    const {classes, isXS, isDrawerHidden} = this.props;
    if (this.activityData.planRecharge && this.activityData.planRecharge.paymentInfo && this.activityData.planRecharge.paymentInfo.transactionUrl) {
      return this.getPaymentProcessingView();
    }
    return this.getPaymentDoneView();
  }

  getPaymentDoneView() {
    const {classes, isXS, isDrawerHidden} = this.props;
    let paymentDoneMessageId = 'payment.success';
    let paymentDoneSubMessage = null;
    let positiveTextId = null;
    let onPositiveClicked = null;
    let negativeTextId = null;
    let onNegativeClicked = null;
    if (this.activityData.planRecharge.state === STATE_ENABLED) {
      paymentDoneMessageId = 'payment.success';
      positiveTextId = 'continue';
      negativeTextId = 'payment.downloadInvoice';
      onPositiveClicked = this.onPaymentDoneClicked;
      onNegativeClicked = this.downloadInvoice;
    } else if (this.activityData.planRecharge.state === STATE_ORDER_CREATED) {
      paymentDoneMessageId = 'payment.processingMsg';
      paymentDoneSubMessage = <FormattedHTMLMessage id={'payment.processingMsgDetail'}/>;
      positiveTextId = 'payment.checkStatus';
      negativeTextId = 'generic.back';
      onPositiveClicked = this.onPaymentCheckStatus;
      onNegativeClicked = this.onBackClicked;
    } else if (this.activityData.planRecharge.state === STATE_ORDER_PAYMENT_CANCELLED
      || this.activityData.planRecharge.state === STATE_ORDER_PAYMENT_FAILED) {
      paymentDoneMessageId = this.activityData.planRecharge.state === STATE_ORDER_PAYMENT_CANCELLED ? 'payment.cancelled' : 'payment.failed';
      paymentDoneSubMessage = <FormattedHTMLMessage id={'payment.failedMsgDetail'} values={{value: this.activityData.planRecharge.id}}/>;
      positiveTextId = 'payment.retryPayment';
      negativeTextId = 'generic.later';
      onPositiveClicked = this.onPaymentRetryClicked;
      onNegativeClicked = this.onPaymentDoneClicked;
    }
    return (
      <Paper elevation={0} className={classes.formManageActivityDone}>
        <div className={classes.viewColumnFullWidth} style={{minHeight: 200, justifyContent: 'center', paddingLeft: isXS ? 0 : 16, paddingRight: isXS ? 0 : 16, position: 'relative', marginTop: isXS ? -16 : 0}}>
          {/*<Space horizontal={isDrawerHidden ? FIELD_SPACE : 2 * FIELD_SPACE} />*/}
          <Typography variant={'h5'} className={classes.typoBold} style={{color: ColorTitle, marginLeft: 16, marginRight: 16}}>{<FormattedMessage id={paymentDoneMessageId}/>}</Typography>
          <FieldSpace horizontalSpace={1} />
          {paymentDoneSubMessage ? <Typography align={'center'} style={{color: ColorSubTitle, marginLeft: 16, marginRight: 16}}>{paymentDoneSubMessage}</Typography> : null}
          <FieldSpace />

          {this.getPaymentInvoiceView()}

          <FieldSpace multiplier={2} />
          <div className={classes.viewRow}>
            {negativeTextId ?
              <Button
                disableElevation={true}
                size={isXS ? 'medium' : 'large'}
                variant={'outlined'}
                color={"secondary"}
                onClick={onNegativeClicked}>
                {<FormattedMessage id={negativeTextId} />}
              </Button>
              : null
            }
            {positiveTextId ?
              <React.Fragment>
                {negativeTextId ? <Space verticalSpace={2} /> : null}
                <Button
                  disableElevation={true}
                  size={isXS ? 'medium' : 'large'}
                  variant={'contained'}
                  color={"primary"}
                  onClick={onPositiveClicked}>
                  {<FormattedMessage id={positiveTextId} />}
                </Button>
              </React.Fragment>
              : null
            }
          </div>
          <FieldSpace />
        </div>
      </Paper>
    );
  }

  getPaymentInvoiceView() {
    if (this.activityData.planRecharge && this.activityData.planRecharge.state === STATE_ENABLED) {
      const invoiceDate = DateTimeHelper.getDisplayDateInvoice(this.activityData.planRecharge.updatedAt);
      const totalValue = this.activityData.planRecharge.ePlanPrice;
      const taxRate = this.activityData.planRecharge.taxRate;
      const itemValue = (totalValue/(1+taxRate/100)).toFixed(2);
      const taxValue = (totalValue - itemValue).toFixed(2);
      const currency = this.activityData.planRecharge.planCurrency;
      const data = {
        isLTR: this.props.app.isLTR,
        totalText: this.context.intl.formatMessage({id: 'payment.totalWithValue'}, {value: taxRate}),
        invoiceText: this.context.intl.formatMessage({id: 'payment.invoice'}),
        billToText: this.context.intl.formatMessage({id: 'payment.billTo'}),
        priceText: this.context.intl.formatMessage({id: 'payment.price'}),
        unitText: this.context.intl.formatMessage({id: 'payment.unit'}),
        vatText: this.context.intl.formatMessage({id: 'payment.vat'}),
        itemTotalText: this.context.intl.formatMessage({id: 'payment.itemTotal'}),
        itemText: this.context.intl.formatMessage({id: 'payment.item'}),
        storeName: 'RAB7.COM',
        storeLink: 'rab7.com',
        businessName: this.context.intl.formatMessage({id: 'payment.businessNameWithValue'}),
        businessPlace: this.context.intl.formatMessage({id: 'payment.businessPlace'}),
        businessTIN: this.context.intl.formatMessage({id: 'payment.businessTINWithValue'}),
        businessCommercialNo: this.context.intl.formatMessage({id: 'payment.businessCommercialRecordWithValue'}),
        invoiceNo: this.activityData.planRecharge.id,
        invoiceDate: this.context.intl.formatMessage({id: 'payment.dateWithValue'}, {value: invoiceDate}),
        userName: this.activityData.planRecharge.userName,
        userCityName: this.activityData.planRecharge.userCityName,
        userEmail: this.activityData.planRecharge.userEmail ? this.context.intl.formatMessage({id: 'payment.emailWithValue'}, {value: this.activityData.planRecharge.userEmail}) : null,
        // itemName: `${this.context.intl.formatMessage({id: 'payment.campaignPlan'})} v${ValueHelper.getDisplayValue(this.activityData.planRecharge.planViewsCount, 0, true, true)}-d${this.activityData.planRecharge.planDuration}`,
        itemName: `${this.context.intl.formatMessage({id: 'payment.campaignPlan'})}`,
        itemQuantity: 1,
        itemValue: `${itemValue}`,
        itemVATValue: `${taxValue}`,
        itemTotalValue: `${totalValue}`,
        taxName: this.context.intl.formatMessage({id: 'payment.vatWithValue'}, {value: taxRate}),
        subTotalName: this.context.intl.formatMessage({id: 'payment.subTotal'}),
        subTotalValue: `${currency} ${itemValue}`,
        taxValue: `${currency} ${taxValue}`,
        totalValue: `${currency} ${totalValue}`,
        qrCode: getQRCodeData(totalValue, taxValue, this.activityData.planRecharge.updatedAt, this.context.intl),
      }
      return <PaymentBill {...data}/>
    }
  }

  downloadInvoice = () => {
    const name = `Rab7 Invoice #${this.activityData.planRecharge.id}.png`;
    toPng(document.getElementById('idInvoice'), { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = name;
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getPaymentProcessingView() {
    // const {app, classes, isXS, isDrawerHidden} = this.props;
    // const {isRedirected} = this.state;
    // const extraHeight = isXS ? TOOLBAR_HEIGHT_XS + 44 : isDrawerHidden ? TOOLBAR_HEIGHT + 52 : TOOLBAR_HEIGHT + 66;
    // const viewHeight = window.appHeight - extraHeight;
    // return (
    //   <div className={classes.viewManageActivity}>
    //     <AppBar
    //       elevation={0}
    //       className={classes.appBarPaymentContainer}
    //       position="fixed"
    //       color="default">
    //       <div className={classes.viewTabBar} style={{paddingLeft: !isDrawerHidden && app.isLTR ? DRAWER_WIDTH+1 : 0, paddingRight: !isDrawerHidden && !app.isLTR ? DRAWER_WIDTH+1 : 0}}>
    //         {/*{isDrawerHidden ?*/}
    //         <div className={classes.viewBarTopManage} style={{pointerEvents: 'auto'}}>
    //           <Button
    //             disableElevation={true}
    //             size={isXS ? 'small' : 'medium'}
    //             variant={'contained'}
    //             color={"secondary"}
    //             style={{marginLeft: !isDrawerHidden ? 24 : 12, marginRight: !isDrawerHidden ? 24 : 12}}
    //             onClick={this.onBackClicked}>
    //             {<FormattedHTMLMessage id={'activity.manage.cancelPayment'} />}
    //           </Button>
    //           {/*<Space vertical={isXS ? 12 : 16}/>*/}
    //           {/*<TextView fontSizeN={isXS ? 14 : 0} numberOfLines={2} textAlign={'center'} variant={"h6"} text={<FormattedMessage id={'payment.processing'} />} color={ColorNav} fontWeight={FontWeightMedium} style={{flex: 1}} />*/}
    //         </div>
    //         {/*  : null*/}
    //         {/*}*/}
    //       </div>
    //     </AppBar>
    //
    //     <Paper elevation={isXS ? 0 : 0} className={classes.formManageActivityPayment}>
    //       <TextView variant={"body2"} align={'center'} color={ColorSubTitle} text={<FormattedMessage id={'payment.noBackNoReloadHint'} />} fontWeight={FontWeightMedium} style={{marginLeft: 16, marginRight: 16}} />
    //       <FieldSpace multiplier={1}/>
    //       <div className={classes.flexColumn} style={{minHeight: viewHeight}}>
    //         {this.activityData.planRecharge && this.activityData.planRecharge.paymentInfo && this.activityData.planRecharge.paymentInfo.transactionUrl && !isRedirected ?
    //           <div className={classes.flexColumn} style={{position: 'relative'}}>
    //             {/*<div style={{position: 'absolute', top: 50, left: 50, right: 50, bottom: 50, display: 'flex', flexDirection: 'column'}}>*/}
    //             {/*  <Skeleton variant={'rect'} animation={'wave'} className={classes.flexColumn} style={{borderRadius: BORDER_RADIUS}}/>*/}
    //             {/*</div>*/}
    //             <iframe
    //               id={'iframePayment'}
    //               width={'100%'}
    //               height={viewHeight}
    //
    //               src={this.activityData.planRecharge.paymentInfo.transactionUrl}
    //               onLoad={this.onPaymentPageLoad}
    //               style={{border: 'none', borderRadius: isXS ? 0 : BORDER_RADIUS, overflow: 'hidden', margin: 0}}
    //             />
    //           </div>
    //           : null
    //         }
    //       </div>
    //     </Paper>
    //   </div>
    // );
  }

  onPaymentPageLoad = () => {
    // try {
    //   const loadedHost = document.getElementById('iframePayment').contentWindow.location.hostname;
    //   if (loadedHost === window.location.hostname) {
    //     this.setState({isRedirected: true});
    //     this.rechargeId = this.activityData.planRecharge.id;
    //     this.fetchData();
    //   }
    // } catch (ex) {
    // }
  };

  onPaymentCheckStatus = () => {
    this.fetchData(true);
  };

  onPaymentCancelClicked = () => {
    this.hideDialog();
    this.setState({isBlockedLoading: true});
    this.props.deleteActivityPlanRecharge(this.activityData.planRecharge.id).then((response) => {
      this.setState({isBlockedLoading: false});
      this.activityData.planRecharge = response.data;
      this.setState({reload: !this.state.reload});
    }).catch((response) => {
      let error = null;
      if (response.data && response.data.error) {
        error = response.data.error;
      } else if (response.error === 'NETWORK_ERROR') {
        error = this.context.intl.formatMessage({id: 'generic.server_not_reachable'});
      } else {
        error = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
      }
      this.setState({isBlockedLoading: false, snackbarMessageId: error, snackbarType: 'error'});
    });
  };

  onPaymentDoneClicked = () => {
    this.activityData.planRecharge = null;
    this.replaceLocationForSuccess();
  };

  onPaymentRetryClicked = () => {
    this.activityData.planRecharge = null;
    this.stopHistoryListeners();
    this.props.history.replace({
      pathname: this.props.history.location.pathname
    });
    this.startHistoryListeners();
    this.onPickPlanClicked();
  };

  replaceLocationForSuccess = () => {
    this.showSuccess = true;
    this.activityData.isSuccess = true;
    this.stopHistoryListeners();
    this.props.history.replace({
      pathname: `${PathCampaignManage}/${this.activityData.id}`,
      search: '?p=4'
    });
    this.startHistoryListeners();
    this.processTabs();
  }

  getActivityView() {
    const {classes, isXS} = this.props;
    const {selectedDotIndex, subTabs} = this.state;

    const cDotId = subTabs[selectedDotIndex].id;
    const showPreview = this.activityData.type !== constants.activity.types.OFFER
        && this.activityData.type !== constants.activity.types.VOUCHER
      && this.activityData.type !== constants.activity.types.DISCOUNT
      && ((cDotId === TAB_LIBRARY)
        || cDotId === TAB_CUSTOMISE
        || cDotId === TAB_REEL_FRONT
        || cDotId === TAB_DEFAULTS
        || cDotId === TAB_GAME_ELEMENTS
        || cDotId === TAB_CTA1
        || cDotId === TAB_CTA2
        || cDotId === TAB_USER_INFO
        || cDotId === TAB_REVIEW
        || cDotId === TAB_QUESTIONS
        || cDotId === TAB_QUESTION
        || cDotId === TAB_IN_QUESTION
        || cDotId === TAB_PREDICTION
        || cDotId === TAB_IDENTIFY_LOCATION
        || cDotId === TAB_SLIDES
        || cDotId === TAB_OPINION
        || (cDotId === TAB_REEL_SUB_POSTS && isXS)
        || (cDotId === TAB_REWARD && isXS)
        || (cDotId === TAB_RECUR && isXS)
        || (cDotId === TAB_PLAN && isXS)
        || (cDotId === TAB_TARGETING && isXS)
        || (cDotId === TAB_REFERRAL && isXS)
      );

    let viewSeparator = null;
    if (showPreview) {
      viewSeparator = (
        isXS ?
          null
          : <React.Fragment>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: FIELD_SPACE, paddingTop: 0}}>
              <div style={{display: 'flex', flex: 1, width: 1.5, backgroundColor: ColorSeparator}} />
            </div>
          </React.Fragment>
      );
    }
    const viewStyleExtra = this.state.showPreview ? {overflow: 'hidden', maxHeight: window.appHeight - 100} : null;
    const viewFlex = cDotId === TAB_REVIEW ? 0 : showPreview ? 2 : 1;
    return (
      <div className={isXS ? classes.viewColumnFullWidthNoCenter : cDotId === TAB_REVIEW ? classes.viewColumnFullWidth : classes.viewRowFullWidthNoCenter} style={viewStyleExtra}>
        <div className={classes.flexRowNoCenter} style={{flex: viewFlex, backgroundColor: AppUtils.colorWithAlpha(ColorUIChecker2, 0)}} >
          {cDotId === TAB_USAGE ? <ManageActivityUsage activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} moveNext={this.onClickNext}/> : null}
          {cDotId === TAB_LIBRARY ? <ManageActivityType activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} moveNext={this.loadConfig} isShowingRewards={this.isShowingRewards()} typesData={this.newActivityConfigs}/> : null}
          {cDotId === TAB_PREVIEW ? <ManageActivityPreview activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_DETAIL ? <ManageActivityBasicInfo activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} previewData={this.previewActivity} /> : null}
          {cDotId === TAB_CUSTOMISE ? <ManageActivityCustomization activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} canEnableShowcase={true} canAddBgAudio={isUserPrivileged(this.props.user)} isEditing={this.isEditing()} /> : null}
          {cDotId === TAB_REEL_FRONT ? <ManageReelFront activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_REEL_SUB_POSTS ? <ManageReelSubPosts activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_SLIDES ? <ManageSlides activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_DEFAULTS ? <ManageActivityDefaults activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_GAME_ELEMENTS ? <ManageActivityElements activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_PREDICTION ? <ManageActivityPrediction activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} intl={this.context.intl} /> : null}
          {cDotId === TAB_IDENTIFY_LOCATION ? <ManageActivityIdentifyLocation activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} intl={this.context.intl} /> : null}
          {cDotId === TAB_OPINION ? <ManageActivityOpinion activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} intl={this.context.intl} /> : null}
          {cDotId === TAB_QUESTION ? <ManageActivityQuestion activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_IN_QUESTION ? <ManageActivityInternalQuestion activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} isEditing={this.isEditing()} /> : null}
          {cDotId === TAB_QUESTIONS ? <ManageActivityQuestions activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_VOUCHERS ? <ManageActivityVoucher activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_REWARD ? <ManageActivityRewards activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} onToggleNext={this.onToggleNext} /> : null}
          {cDotId === TAB_RECUR ? <ManageActivityRecur activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_PLAN ? <ManageActivityPlan activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} moveNext={this.onClickNext} tabId={TAB_PLAN} /> : null}
          {cDotId === TAB_CTA ? <ManageActivityCTA activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} previewData={this.previewActivity}/> : null}
          {cDotId === TAB_CTA1 ? <ManageActivityCTA1 activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} /> : null}
          {cDotId === TAB_CTA2 ? <ManageActivityCTA2 activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} moveNext={this.onClickNext} /> : null}
          {cDotId === TAB_TARGETING ? <ManageActivityTargeting activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} isEditing={this.isEditing()} /> : null}
          {cDotId === TAB_REFERRAL ? <ManageActivityReferralRewards activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} moveNext={this.onClickNext} /> : null}
          {cDotId === TAB_PRICE ? <ManageActivityCharge activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} moveNext={this.onClickNext} wallet={this.props.user.wallet} /> : null}
          {cDotId === TAB_USER_INFO ? <ManageActivityUserInfo activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} moveNext={this.onClickNext} /> : null}
          {cDotId === TAB_PAYMENT ? <ManageActivityPayment activityData={this.activityData} moveNextCallback={this.onMoveCallback} onDataUpdated={this.onDataUpdated} moveNext={this.onClickNext} /> : null}
        </div>

        {cDotId !== TAB_REVIEW ? viewSeparator : null}
        <Profiler id="DG-game PreviewView" onRender={this.onProfilerCallback}>
          {this.getPreviewView(showPreview)}
        </Profiler>
      </div>
    );
  }

  onProfilerCallback = (id, phase, actualDuration, baseDuration, startTime, commitTime) => {
    logInfo('Rendered: '+ id, actualDuration);
  };

  getPreviewView(showPreviewEff) {
    const {classes, app, history, user, isMD, isXS, isDrawerHidden} = this.props;
    const {selectedDotIndex, subTabs, showPreview, previewOrientation} = this.state;
    const cDotId = subTabs[selectedDotIndex].id;
    if (cDotId === TAB_USAGE) {
      return null;
    }

    let showPreviewSubtitle = true;
    let previewTitleId = 'activity.previewR';
    if (cDotId === TAB_LIBRARY) {
      showPreviewSubtitle = false;
      if (isXS) {
        previewTitleId = null;
      } else {
        previewTitleId = 'activity.preview';
      }
    } else if (cDotId === TAB_REVIEW) {
      showPreviewSubtitle = false;
      if (this.activityData.type !== constants.activity.types.SHOWCASE_MENU) {
        previewTitleId = null;
      }
      // if (isXS) {
      //   previewTitleId = null;
      // } else {
      //   previewTitleId = 'activity.finalPreview';
      // }
    }
    const showXSPreviewButton = isXS && cDotId !== TAB_REVIEW && showPreviewEff;
    if (showXSPreviewButton) {
      showPreviewEff = showPreview;
    }

    const previewView = <CampaignPreView
      classes={classes}
      isLTR={app.isLTR}
      locale={app.defaultLocale}
      history={history}
      isMD={isMD}
      isXS={isXS}
      isDrawerHidden={isDrawerHidden}
      showPreviewEff={showPreviewEff}
      activityType={this.activityData.type}
      gameInfo={this.activityData.gameInfo}
      showGameInfo={cDotId === TAB_LIBRARY && this.activityData.type}
      previewActivity={this.previewActivity}
      refActivityView={(ref) => this.refActivityView = ref}
      userId={user.id}
      userBId={user.bId}
      userRab7Number={user.rab7Number}
      userImageUrl={user.imageUrl}
      showPreviewSubtitle={showPreviewSubtitle}
      previewTitleId={previewTitleId}
      noSpacing={cDotId === TAB_REVIEW && !isXS}
      isFinal={cDotId === TAB_REVIEW}
      isFirst={cDotId === TAB_LIBRARY}
      previewOrientation={previewOrientation}
      onPreviewOrientationToggle={this.onPreviewOrientationToggle}
    />

    if (showXSPreviewButton) {
      return (
        <div style={{pointerEvents: showPreviewEff ? 'auto' : 'none', position: 'fixed', zIndex: zIndex.drawer + 2, top: showPreviewEff ? 0 : 'auto', bottom: 0, left: 0, right: 0, backgroundColor: showPreviewEff ? ColorWhite : ColorClear, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
          <div style={{backgroundColor: showPreviewEff ? ColorWhite : ColorClear}}>
            <ScrollView style={{maxHeight: window.appHeight - BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY}}>
              <div className={classes.viewColumnFullWidthNoCenter1}>
                {showPreviewEff ? <div style={{height: 6, backgroundColor: ColorWhite}}/> : null}
                {previewView}
              </div>
            </ScrollView>
            <div className={classes.viewRowFullWidth} style={{position: 'relative', justifyContent: 'center', alignItems: 'center', minHeight: BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY}}>
              {cDotId === TAB_LIBRARY && showPreview ?
                <React.Fragment>
                  <IconButton
                    // disableElevation={true}
                    variant={'outlined'}
                    color={"secondary"}
                    // size={'large'}
                    // style={{pointerEvents: 'auto', minWidth: isXS ? 48 : 60}}
                    style={{pointerEvents: 'auto'}}
                    onClick={this.resetCreateActivity}>
                    <AppIcon icon={IconCrossCircle} color={ColorSecondary} style={{width: 36, height: 36}} />
                  </IconButton>
                </React.Fragment>
                : null
              }
              <div className={classes.flex1}/>

              <div style={{position: 'absolute', top: 0, bottom: 0, left: 'auto', right: 'auto', display: 'flex', alignItems: 'center'}}>
                {cDotId === TAB_LIBRARY && showPreview ?
                  <React.Fragment>
                    <Button
                      disableElevation={true}
                      variant={'contained'}
                      color={"primary"}
                      // size={'large'}
                      onClick={this.hidePreviewAndMoveAhead}
                      style={{pointerEvents: 'auto', minWidth: isXS ? 48 : 110}}>
                      <FormattedMessage id={'manage.customizeNow'} />
                    </Button>
                  </React.Fragment>
                  : <TouchableOpacity
                    onClick={this.toggleShowPreview}
                    disabled={cDotId === TAB_LIBRARY}
                    style={{pointerEvents: 'auto', width: BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY-4, height: BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY-4, borderRadius: (BOTTOM_TAB_HEIGHT_MANAGE_ACTIVITY-4)/2, opacity: cDotId === TAB_LIBRARY ? 0 : 1}}>
                    <AppIcon icon={showPreviewEff ? IconHide : IconShow} color={ColorTheme} style={{width: 40, height: 40}} />
                  </TouchableOpacity>
                }
              </div>
            </div>
          </div>
        </div>
      );
    }
    return previewView;
  }

  onPreviewOrientationToggle = (orientation) => {
    this.setState({previewOrientation: orientation});
  }

  hidePreview = () => {
    this.toggleShowPreview(2);
  }

  toggleShowPreview = (type = 0) => {
    const {showPreview} = this.state;
    let newState = !showPreview;
    if (type === 1) {
      newState = true;
    } else if (type === 2) {
      newState = false;
    }
    changeNavColor(newState ? ColorWhite : ColorBackgroundXS);
    this.setState({showPreview: newState}, () => {
      this.processPreviewActivity();
    });
  }

  hidePreviewAndMoveAhead = (event) => {
    this.hidePreview();
    this.onClickNext(event);
  };

  getSubscriptionPlanView() {
    const {classes} = this.props;
    const {planId} = this.state;
    const plan = this.activityData.ad;
    if (!plan || !plan.planId) {
      return (
        <div className={classes.planCard}>
          <div className={classes.flexColumnNoCenter} style={{padding: 4, paddingTop: 0, paddingBottom: 0}}>
            <div className={classes.viewRowFullWidth} style={{justifyContent: 'center'}}>
              <TextView textId={'activity.plan.campaignPlan'} variant="h6" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
              {/*<Space verticalSpace={1} />*/}
              {/*<TextView text={plan.planName} variant="h6" color={ColorTheme} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
            </div>
            <FieldSpace />

            <div className={classes.viewColumnFullWidthNoCenter} style={{minWidth: 250, marginTop: 8, borderRadius: BORDER_RADIUS, border: '1px solid '+ ColorTableBorder}}>
              <div className={classes.viewColumnFullWidth}>
                <React.Fragment>
                  <div className={classes.viewColumnFullWidth} style={{padding: 12}}>
                    <TextView align={'center'} textId={'activity.noPlanSet'} variant="body2" color={ColorNegative} textAlign={'center'}/>
                    <TextView align={'center'} textId={'activity.manage.manageSuccessMessageNoPlan'} variant="body2" color={ColorNegative} />
                  </div>
                </React.Fragment>
                {/*<Space horizontalSpace={5} />*/}
                {/*<Typography variant={'body1'} className={classes.typoMedium} color={'textSecondary'} align={'center'}>{<FormattedMessage id={'activity.manage.manageSuccessMessageNoPlan'} />}</Typography>*/}
              </div>
            </div>
            <div className={classes.viewColumn}>
              <Space horizontalSpace={2}/>
              <Button
                disableElevation
                variant={'contained'}
                color={"primary"}
                onClick={this.onPickPlanClicked}
                className={classes.buttonCamelCase}>
                {<FormattedMessage id='activity.manage.actionSubscribeL' />}
              </Button>
            </div>
          </div>
        </div>
      )
    }

    let totalViewsText;
    if (plan.planViewsCount >= constants.activity.VALUE_DEFAULT_MAX) {
      totalViewsText = <FormattedMessage id={'activity.plan.unlimited'} />
    } else {
      totalViewsText = ValueHelper.getDisplayValue(plan.planViewsCount);
    }
    let totalDailyViewsText;
    if (plan.planDailyViewsCount >= constants.activity.VALUE_DEFAULT_MAX) {
      totalDailyViewsText = <FormattedMessage id={'activity.plan.unlimited'} />
    } else {
      totalDailyViewsText = ValueHelper.getDisplayValue(plan.planDailyViewsCount);
    }
    const availableViews = Math.max(0, plan.planViewsCount - plan.feedDisplayedCount);
    let availableViewsText;
    if (availableViews >= 10000000) {
      availableViewsText = <FormattedMessage id={'activity.plan.unlimited'} />
    } else {
      availableViewsText = ValueHelper.getDisplayValue(availableViews);
    }

    let isPlanEnded = false;
    let isPlanViewsEnded = false;
    let endAtLabelText = '';
    let endAtText = '';
    let endAtDateText = null;
    let startAtText = '';
    let startAtDateText = null;
    let startDateColor = ColorTitle;
    let endDateColor = ColorTitle;
    const planEndAt = plan.planEndAt;
    const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(this.activityData.startAt);
    const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(planEndAt);
    if (startDateDiff <= 0) {
      startAtText = DateTimeHelper.getSince(this.activityData.startAt, 'time.since');
      if (endDateDiff > 0) {
        startDateColor = ColorGreen;
      }
    } else {
      startAtText = DateTimeHelper.getValidityInTime(this.activityData.startAt);
    }
    startAtDateText = DateTimeHelper.getInputDateTimeString(this.activityData.startAt);
    endAtDateText = DateTimeHelper.getInputDateTimeString(planEndAt);
    if (endDateDiff > 0) {
      endAtText = DateTimeHelper.getValidityInTime(planEndAt);
      if (startDateDiff <= 0) {
        endDateColor = ColorGreen;
      }
    }
    if (endDateDiff <= 0) {
      endDateColor = ColorNegative;
      endAtText = <FormattedMessage id='generic.ended' />;
      isPlanEnded = true;
    } else {
      isPlanViewsEnded = availableViews === 0;
    }

    return (
      <div className={classes.planCard}>
        <div className={classes.flexColumnNoCenter} style={{padding: 4, paddingTop: 0, paddingBottom: 0}}>
          <div className={classes.viewRowFullWidth} style={{justifyContent: 'center'}}>
            <TextView textId={'activity.plan.campaignPlan'} variant="h6" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
            {/*<Space verticalSpace={1} />*/}
            {/*<TextView text={plan.planName} variant="h6" color={ColorTheme} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
          </div>
          <FieldSpace />

          <div className={classes.viewColumnFullWidthNoCenter} style={{minWidth: 250, marginTop: 8, borderRadius: BORDER_RADIUS, border: '1px solid '+ ColorTableBorder}}>
            <div className={classes.viewRowFullWidth} style={{padding: 12}}>
              <TextView textId={'activity.plan.totalViews'} variant="subtitle1" color={ColorTitle} />
              <div className={classes.flexGrow} />
              <TextView text={totalViewsText} variant="subtitle1" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
            </div>
            <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
            {/*<Space horizontalSpace={0.8}/>*/}
            {/*<div className={classes.viewRowFullWidth} style={{padding: 12}}>*/}
            {/*  <TextView textId={'activity.plan.dailyViews'} variant="subtitle1" color={ColorTitle} />*/}
            {/*  <div className={classes.flexGrow} />*/}
            {/*  <TextView text={totalDailyViewsText} variant="subtitle1" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
            {/*</div>*/}
            {/*<Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />*/}
            {!isPlanEnded ?
              <React.Fragment>
                <div className={classes.viewRowFullWidth} style={{padding: 12}}>
                  <TextView textId={'activity.plan.availableViews'} variant="subtitle1" color={ColorTitle} />
                  <div className={classes.flexGrow} />
                  <TextView text={availableViewsText} variant="subtitle1" color={isPlanViewsEnded ? ColorOrange : ColorGreen} fontWeight={FONT_WEIGHT_MEDIUM} />
                </div>
                <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
              </React.Fragment>
              : null
            }
            <div className={classes.viewRowFullWidth} style={{padding: 12}}>
              <TextView textId={'activity.planStart'} variant="subtitle1" color={ColorTitle} />
              <div className={classes.flexGrow} />
              {/*<div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>*/}
              {/*  <TextView text={startAtText} variant="subtitle1" color={startDateColor} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
              {/*</div>*/}
              <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>
                <TextView text={startAtDateText} variant="body1" color={startDateColor} />
              </div>
            </div>
            {/*{startAtDateText != null ?*/}
            {/*  <div className={classes.viewRowFullWidth} style={{padding: 12, paddingTop: 0, marginTop: -8}}>*/}
            {/*    <div className={classes.flexGrow} />*/}
            {/*    <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>*/}
            {/*      <TextView text={startAtDateText} variant="body2" color={startDateColor} />*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}
            <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
            <div className={classes.viewRowFullWidth} style={{padding: 12}}>
              <TextView textId={'activity.planEnd'} variant="subtitle1" color={ColorTitle} />
              <div className={classes.flexGrow} />
              {/*<div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>*/}
              {/*  <TextView text={endAtText} variant="subtitle1" color={endDateColor} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
              {/*</div>*/}
              <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>
                <TextView text={endAtDateText} variant="body1" color={endDateColor} />
              </div>
            </div>
            {/*<div className={classes.viewRowFullWidth} style={{padding: 12, paddingTop: 0, marginTop: -8}}>*/}
            {/*  <div className={classes.flexGrow} />*/}
            {/*  <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>*/}
            {/*    <TextView text={endAtDateText} variant="body2" color={endDateColor} />*/}
            {/*  </div>*/}
            {/*</div>*/}
            {isPlanViewsEnded ?
              <React.Fragment>
                <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
                <div className={classes.viewColumnFullWidth} style={{padding: 12}}>
                  <TextView textId={'activity.manage.viewLimitOver'} variant="body2" color={ColorOrange} />
                  <TextView textId={isCurrentPlanPaid(plan) ? 'activity.manage.expandToIncreaseViews' : 'activity.manage.upgradeToIncreaseViews'} variant="body2" color={ColorOrange} />
                </div>
              </React.Fragment>
              : null
            }
            {isPlanEnded ?
              <React.Fragment>
                <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
                <div className={classes.viewColumnFullWidth} style={{padding: 12}}>
                  <TextView align={'center'} textId={'activity.plan.ended'} variant="body2" color={ColorNegative} textAlign={'center'}/>
                  <TextView align={'center'} textId={'activity.manage.renewToIncreaseViews'} variant="body2" color={ColorNegative} />
                </div>
              </React.Fragment>
              : null
            }
          </div>
          {isPlanEnded || isPlanViewsEnded ?
            <div className={classes.viewColumn}>
              <Space horizontalSpace={2}/>
              <Button
                disableElevation
                variant={'contained'}
                color={"primary"}
                onClick={this.onPickPlanClicked}
                className={classes.buttonCamelCase}>
                {<FormattedMessage id={isPlanEnded ? 'activity.manage.actionRenewL' : isCurrentPlanPaid(plan) ? 'activity.manage.actionExtendL' : 'activity.manage.actionUpgradeL'} />}
              </Button>
            </div>
            : null
          }

          {!this.activityData.ad || this.activityData.ad.planType <= constants.activity.plans.NO_PLAN ?
              <div className={classes.viewColumnFullWidth}>
                <Space horizontalSpace={5} />
                <Typography variant={'body1'} className={classes.typoMedium} color={'textSecondary'} align={'center'}>{<FormattedMessage id={'activity.manage.manageSuccessMessageNoPlan'} />}</Typography>
                <Space horizontal={FIELD_SPACE} />
                <Button
                    disableElevation
                    variant={'contained'}
                    color={"primary"}
                    onClick={this.onPickPlanClicked}
                    className={classes.buttonCamelCase}>
                  {<FormattedMessage id='activity.manage.actionSubscribeL' />}
                </Button>
              </div>
              : null
          }
          {this.activityData.ad && this.activityData.ad.planType === constants.activity.plans.FREE_PLAN && !isCurrentPlanEnded(this.activityData.ad) ?
              <div className={classes.viewColumnFullWidth}>
                <Space horizontalSpace={5} />
                <Typography variant={'body1'} className={classes.typoMedium} color={'textSecondary'} align={'center'}>{<FormattedMessage id={'activity.manage.manageSuccessMessage'} />}</Typography>
                <Space horizontal={FIELD_SPACE} />
                <Button
                    disableElevation
                    variant={'contained'}
                    color={"primary"}
                    onClick={this.onPickPlanClicked}
                    className={classes.buttonCamelCase}>
                  {<FormattedMessage id='activity.manage.switchToPaidPlan' />}
                </Button>
              </div>
              : null
          }
          <div style={{flex: 1}}/>
        </div>
      </div>
    );
  }

  // onRetryClicked = () => {
  //   this.fetchConfigCounter = 0;
  //   this.fetchConfigs(this.fetchConfigsForType, true);
  // }

  getHeaderTitle() {
    if (this.props.isXS) {
      if (this.isShowingRewards()) {
        return this.context.intl.formatMessage({id: this.isEditing() ? 'generic.manageOffer' : 'generic.addOffer'});
      }
      return this.context.intl.formatMessage({id: this.isEditing() ? 'generic.manageCampaign' : 'generic.addCampaign'});
    }

    if (this.isShowingRewards()) {
      let titleId = null;
      if (this.activityData && this.activityData.usageType === constants.activity.usageTypes.LOYALTY) {
        titleId = this.isEditing() ? 'activity.manageLoyaltyOffer' : 'activity.addLoyaltyOffer';
      } else {
        titleId = this.isEditing() ? 'generic.manageOffer' : 'generic.addOffer';
      }
      return this.context.intl.formatMessage({id: titleId});
    }

    let titleId = null;
    // if (this.getCampaignUsageType() === constants.activity.usageTypes.MARKETING) {
    //   titleId = this.isEditing() ? 'generic.manageMarketingCampaign' : 'generic.addMarketingCampaign';
    // } else if (this.getCampaignUsageType() === constants.activity.usageTypes.LOYALTY) {
    //   titleId = this.isEditing() ? 'generic.manageLoyaltyCampaign' : 'generic.addLoyaltyCampaign';
    // } else if (this.getCampaignUsageType() === constants.activity.usageTypes.EDUCATION) {
    //   titleId = this.isEditing() ? 'generic.manageEducationCampaign' : 'generic.addEducationCampaign';
    // } else if (this.getCampaignUsageType() === constants.activity.usageTypes.TRAINING) {
    //   titleId = this.isEditing() ? 'generic.manageTrainingCampaign' : 'generic.addTrainingCampaign';
    // } else if (this.getCampaignUsageType() === constants.activity.usageTypes.SOCIAL) {
    //   titleId = this.isEditing() ? 'generic.manageSocialCampaign' : 'generic.addSocialCampaign';
    // } else if (this.getCampaignUsageType() === constants.activity.usageTypes.INFLUENCER) {
    //   titleId = this.isEditing() ? 'generic.manageInfluencerCampaign' : 'generic.addInfluencerCampaign';
    // } else {
      titleId = this.isEditing() ? 'generic.manageCampaign' : 'generic.addCampaign';
    // }
    let title = this.context.intl.formatMessage({id: titleId});
    if (this.activityData) {
      if (this.activityData.gameInfo) {
        title += ': '+ this.activityData.gameInfo.name;
      } else if (this.activityData.type > 0) {
        title += ': '+ this.context.intl.formatMessage({id: 'activity.manage.'+ this.activityData.type +'.title'});
      }
    }
    return title;
  }

  getErrorView() {
    const {activities, classes} = this.props;

    let errMsg = null
    if (activities.activity && activities.activity.errMsg) {
      errMsg = activities.activity.errMsg;
    }
    return errMsg && (
      <div autoFocus className={classes.errorManageActivity}>
        <Typography variant={'subtitle1'} align={'center'} style={{backgroundColor: ColorNegative, color: ColorWhite, fontWeight: 'bold', padding: 6, paddingLeft: 16, paddingRight: 16, borderRadius: BORDER_RADIUS}}>
          <FormattedHTMLMessage id={errMsg} />
        </Typography>
        <Space horizontalSpace={1}/>
      </div>
    );
  }

  getErrorViewNoActivity() {
    const {activities, classes, isXS} = this.props;

    let errMsg = null
    if (activities.activity && activities.activity.errMsg) {
      errMsg = activities.activity.errMsg;
    }
    return errMsg && (
      <div autoFocus className={classes.containerError}>
        <Typography variant={'h6'} align={'center'} style={{color: ColorSubTitle, fontWeight: FONT_WEIGHT_MEDIUM}}>
          <FormattedMessage id={errMsg} />
        </Typography>
        <div className={classes.viewRow}>
          <Button
            disableElevation={true}
            style={{marginTop: FIELD_SPACE}}
            size={isXS ? 'small' : 'medium'}
            variant={'outlined'}
            color={"secondary"}
            onClick={this.onBackClicked}>
            {<FormattedMessage id={'back'} />}
          </Button>
          <Space verticalSpace={2} />
          <Button
            disableElevation={true}
            style={{marginTop: FIELD_SPACE}}
            size={isXS ? 'small' : 'medium'}
            variant={'contained'}
            color={"primary"}
            onClick={this.fetchData}>
            {<FormattedMessage id={'retry'} />}
          </Button>
        </div>
      </div>
    );
  }

  isQuestions() {
    return this.activityData && (this.activityData.type === constants.activity.types.QUESTION
      || this.activityData.type === constants.activity.types.GUESS
      || this.activityData.type === constants.activity.types.QUESTIONNAIRE
      || this.activityData.type === constants.activity.types.SURVEY);
  }

  downloadQRCode(qrCodeId) {
    const id = this.activityData.id;
    const qrCodeElement = document.getElementById(qrCodeId);
    const serializeToString = (new XMLSerializer).serializeToString(qrCodeElement);
    const canvasElement = document.createElement("canvas");
    const context = canvasElement.getContext("2d");
    const image = new Image;
    image.onload = () => {
      const padding = 20;
      canvasElement.width = 600;
      canvasElement.height = 600;
      context.fillStyle = "white";
      context.fillRect(0, 0, canvasElement.width, canvasElement.height);
      context.drawImage(image, padding, padding, canvasElement.width - 2 * padding, canvasElement.height - 2 * padding);

      const dataURL = canvasElement.toDataURL("image/png");
      const anchorElement = document.createElement("a");
      anchorElement.download = qrCodeId +'-'+ id;
      anchorElement.href = "".concat(dataURL);
      anchorElement.click();
    };
    image.src = "data:image/svg+xml;base64,".concat(btoa(serializeToString));
  }

  onMoveCallback = (callback) => {
    this.moveNextCallback = callback;
  };

  onToggleNext = (enabled) => {
    this.setState({enableAction: enabled});
  };

  onDataUpdated = (data) => {
    const {subTabs, selectedDotIndex} = this.state;
    if (data) {
      const oldRewardState = this.activityData.rewardState;
      const oldPlanPay = this.activityData.planPay;
      this.assignNewData(data);

      // if (subTabs[selectedDotIndex].id === TAB_REWARD) {
      //   const newRewardState = data.rewardState;
      //   if (oldRewardState !== newRewardState) {
      //     setTimeout(() => {
      //       this.processTabs();
      //     });
      //   }
      // }

      if ((subTabs[selectedDotIndex].id === TAB_DETAIL
        || subTabs[selectedDotIndex].id === TAB_CTA) && this.moveNextCallback) {
        this.moveNextCallback.onPreviewUpdated(this.previewActivity);
      } else if (subTabs[selectedDotIndex].id === TAB_PRICE && this.activityData.planPay !== oldPlanPay) {
        this.setState({reload: !this.state.reload});
      }
    }
  };

  processDummyValues() {
    // process slots
    const slotValues = [];
    if (this.activityData.activityConfigs) {
      const getOptionNumber = (i, isReverse) => {
        if (isReverse) {
          return -1;
        }
        return i;
      };
      const getOptionId = (optionNumber) => {
        if (optionNumber < 0) {
          return 100 * optionNumber;
        }
        if (this.activityData.type === constants.activity.types.GAME_TIC_TAC_TOE && optionNumber === 0) {
          return -10;
        }
        return -optionNumber;
      };
      const processSlotOption = (i, option, isReverse) => {
        if (!option) {
          option = {
            imageUrl: null,
            imageFiles: null,
            initialFiles: null,
            offers: [],
            points: '0',
            value1: 0,
            winLimit: '0',
            winILimit: '0',
          };
        }
        if (!option.number) {
          option.number = getOptionNumber(i, isReverse);
        }
        if (!option.id) {
          option.id = getOptionId(option.number);
        }
        if (!option.imageUrl) {
          option.imageUrl = ApiHelper.getSlotDefaultImageUrl(this.activityData, option.number);
        }
        option.value1 = ApiHelper.getSlotDefaultValue1(this.activityData, option.number);
        return option;
      };

      let totalSlots = Math.max(this.activityData.activityConfigs.slotTotalImages, this.activityData.activityConfigs.slotMinValues);
      // reverse slot
      if (this.activityData.type === constants.activity.types.GAME_BRAND_RACE
        || this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || this.activityData.type === constants.activity.types.GAME_WHAC_A_MOLE) {
        totalSlots++;
      }
      const slotNumber_valuesMap = {};
      if (this.activityData.slotValues) {
        let index = 0;
        this.activityData.slotValues.forEach((slotValue) => {
          if (!slotValue.number) {
            slotValue.number = index;
          }
          slotNumber_valuesMap[slotValue.number] = slotValue;
          index++;
        });
      }
      for (let i = 0; i < totalSlots; i++) {
        let isReverse = false;
        if (i >= this.activityData.activityConfigs.slotMinValues && i >= this.activityData.activityConfigs.slotTotalImages) {
          isReverse = true;
        }
        const slotNumber = getOptionNumber(i, isReverse);
        let option = null;
        const exSlot = slotNumber_valuesMap[slotNumber];
        if (exSlot) {
          option = cloneDeep(exSlot);
        }
        option = processSlotOption(i, option, isReverse);
        slotValues.push(option);
      }
    }
    this.activityData.slotValues = slotValues;

    // process other images
    if (this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || this.activityData.type === constants.activity.types.GAME_POKER
      || this.activityData.type === constants.activity.types.GAME_FLIP_CARD
      // || this.activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || this.activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || this.activityData.type === constants.activity.types.GAME_PUZZLE
      || this.activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
      if (!this.activityData.imageUrl1) {
        this.activityData.imageUrl1 = ApiHelper.getSlotDefaultCardImageUrl(this.activityData.type);
      }
    }
    if (this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
      if (!this.activityData.imageUrl2) {
        this.activityData.imageUrl2 = ApiHelper.getSlotDefaultCardRevealImageUrl();
      }
    }

    if (!this.isEditing()) {
      const startAtDefault = DateTimeHelper.getDateAfterMinutesFromNow(0);
      const endAtDefault = DateTimeHelper.getDateAfterDays(startAtDefault, 7); // 1 week
      this.activityData.startAt = startAtDefault;
      this.activityData.endAt = endAtDefault;
      // process question
      if (this.activityData.type === constants.activity.types.QUESTION) {
        if (!this.activityData.qTitle) {
          this.activityData.qTitle = locString('activity.dummySurvey');
          this.activityData.qOptions = [
            {id: -1, name: locString('activity.dummySurveyO1')},
            {id: -2, name: locString('activity.dummySurveyO2')},
            {id: -3, name: locString('activity.dummySurveyO3')},
            {id: -4, name: locString('activity.dummySurveyO4')},
          ];
          this.activityData.showAnswers = true;
          this.activityData.imageUrl2 = require('src/images/dummy_question.png');
        }
      }

      // dummy opinion
      if (this.activityData.type === constants.activity.types.VISITOR_OPINION) {
        if (!this.activityData.qTitle) {
          this.activityData.qTitle = locString('activity.shareFeedbackDummy');
          this.activityData.value1Placeholder = this.context.intl.formatMessage({id: 'activity.ratingMinPoor'});
          this.activityData.value2Placeholder = this.context.intl.formatMessage({id: 'activity.ratingMaxOver'});
          this.activityData.imageUrl1 = require('src/images/dummy_opinion.png');
        }
      }

      // dummy location
      if (this.activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
        if (!this.activityData.qTitle) {
          this.activityData.qTitle = locString('identifyLocationForThePlace');
          this.activityData.imageUrl1 = require('src/images/dummy_map.png');
        }
      }

      // dummy prediction
      if (this.activityData.type === constants.activity.types.PREDICTION) {
        if (!this.activityData.qTitle) {
          this.activityData.qTitle = this.context.intl.formatMessage({id: this.activityData.subType === 1 ? 'activity.dummyPredictionTitle' : 'activity.dummyPredictWinnerTitle'});
          this.activityData.value1Placeholder = this.context.intl.formatMessage({id: 'activity.dummyPredictionOption1Title'});
          this.activityData.value2Placeholder = this.context.intl.formatMessage({id: 'activity.dummyPredictionOption2Title'});
          this.activityData.imageUrl1 = require('src/images/dummy_prediction1.png');
          this.activityData.imageUrl2 = require('src/images/dummy_prediction2.png');
        }
      }

      // process guess
      if (this.activityData.type === constants.activity.types.GUESS) {
        if (!this.activityData.qTitle) {
          this.activityData.qTitle = locString('activity.dummyGuess');
          this.activityData.qOptions = [
            {id: -1, name: locString('activity.dummyGuessO1')},
            {id: -2, name: locString('activity.dummyGuessO2')},
            {id: -3, name: locString('activity.dummyGuessO3')},
            {id: -4, name: locString('activity.dummyGuessO4')},
          ];
          this.activityData.rightOption = 4;
          this.activityData.imageUrl2 = require('src/images/dummy_guess.png');
        }
      }

      // process questions
      if (this.activityData.type === constants.activity.types.QUESTIONNAIRE) {
        if (!this.activityData.questions) {
          const questions = [];
          const options1 = [
            {id: -11, name: locString('activity.dummyQuestionO1'), isRight: 1},
            {id: -12, name: locString('activity.dummyQuestionO2')},
            {id: -13, name: locString('activity.dummyQuestionO3')},
            {id: -14, name: locString('activity.dummyQuestionO4')},
          ];
          questions.push({
            id: -10,
            name: locString('activity.dummyQuestion'),
            options: options1,
            qOptions: options1,
          });
          const options2 = [
            {id: -21, name: locString('activity.dummyQuestion2O1')},
            {id: -22, name: locString('activity.dummyQuestion2O2')},
            {id: -23, name: locString('activity.dummyQuestion2O3')},
            {id: -24, name: locString('activity.dummyQuestion2O4'), isRight: 1},
          ]
          questions.push({
            id: -20,
            name: locString('activity.dummyQuestion2'),
            options: options2,
            qOptions: options2,
          });
          this.activityData.questions = questions;
          this.activityData.qTitle = locString('activity.dummyQuestionnaire');
          this.activityData.imageUrl2 = require('src/images/dummy_quiz.png');
        }
      }

      // survey
      if (this.activityData.type === constants.activity.types.SURVEY) {
        if (!this.activityData.questions) {
          const questions = [];
          const options1 = [
            {id: -11, name: locString('activity.dummySurveyO1'), isRight: 1},
            {id: -12, name: locString('activity.dummySurveyO2')},
            {id: -13, name: locString('activity.dummySurveyO3')},
            {id: -14, name: locString('activity.dummySurveyO4')},
          ];
          questions.push({
            id: -10,
            name: locString('activity.dummySurvey'),
            options: options1,
            qOptions: options1,
          });
          const options2 = [
            {id: -21, name: locString('activity.dummySurvey2O1'), isRight: 1},
            {id: -22, name: locString('activity.dummySurvey2O2')},
            {id: -23, name: locString('activity.dummySurvey2O3')},
            {id: -24, name: locString('activity.dummySurvey2O4')},
          ]
          questions.push({
            id: -20,
            name: locString('activity.dummySurvey2'),
            options: options2,
            qOptions: options2,
          });
          this.activityData.questions = questions;
          this.activityData.qTitle = locString('activity.dummySurveyTitle');
          this.activityData.imageUrl2 = require('src/images/dummy_survey.png');
        }
      }

      // subPosts reels and slides
      if (this.activityData.type === constants.activity.types.CHALLENGE) {
        this.activityData.s2ImageUrl = require('src/images/dummy_reels.jpg');
        this.activityData.description = locStringA(this.context.intl, 'activity.dummyReelCaption');
        const subPosts = [
          {id: -1, title: locStringA(this.context.intl, 'activity.dummyReelPost1Caption'), videoUrl: require('src/images/dummy_reels_sp1.mp4')},
          {id: -2, title: locStringA(this.context.intl, 'activity.dummyReelPost2Caption'), imageUrls: [require('src/images/dummy_reels_sp2.jpg')], link: 'https://rab7.com', linkText: '3'},
          {id: -3, title: locStringA(this.context.intl, 'activity.dummyReelPost3Caption'), videoUrl: require('src/images/dummy_reels_sp3.mp4')},
          {id: -4, title: locStringA(this.context.intl, 'activity.dummyReelPost4Caption'), videoUrl: require('src/images/dummy_reels_sp4.mp4'), link: 'https://rab7.com', linkText: '4'},
        ];
        this.activityData.subPosts = subPosts;
      } else if (this.activityData.type === constants.activity.types.SLIDES) {
        const subPosts = [
          {id: -1, title: locStringA(this.context.intl, 'slideshow.dummy1Text'), imageUrl: require('src/images/dummy_ads.png'), duration: 8},
        ];
        this.activityData.subPosts = subPosts;
      } else if (this.activityData.type === constants.activity.types.SHOWCASE_MENU) {
        const subPosts = [
          {id: -1, title: locStringA(this.context.intl, 'activity.dummyMenu1'), imageUrl: require('src/images/dummy_menu.png'), duration: 8},
        ];
        this.activityData.subPosts = subPosts;
      }

      if (this.activityData.type !== constants.activity.types.CHALLENGE && this.activityData.type !== constants.activity.types.SHOWCASE_MENU) {
        // process cta2
        this.activityData.s2Link = 'https://rab7.com';
        this.activityData.s2ImageUrl = require('src/images/dummy_cta2.png');
        this.activityData.videoUrl = null;
      }
    }
  }

  removeDummyValues = () => {
    const startAtDefault = DateTimeHelper.getDateAfterMinutesFromNow(1);
    const endAtDefault = DateTimeHelper.getDateAfterDays(startAtDefault, 7); // 1 week
    this.activityData.startAt = startAtDefault;
    this.activityData.endAt = endAtDefault;
    // images & title
    this.activityData.description = null;
    this.activityData.qTitle = null;
    this.activityData.subPosts = null;
    this.previewActivity.previewSubPosts = null;

    // location
    if (this.activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      this.activityData.imageUrl1 = null;
      this.previewActivity.previewLocation = {
        name: null,
        imageUrl: null,
      };
    }

    // opinion
    if (this.activityData.type === constants.activity.types.VISITOR_OPINION) {
      this.activityData.imageUrl1 = null;
      this.activityData.value1Placeholder = null;
      this.activityData.value2Placeholder = null;
      this.previewActivity.previewOpinion = {
        name: null,
        imageUrl: null,
        ratingMinTitle: null,
        ratingMaxTitle: null,
        contentTypes: this.activityData.contentTypes,
      };
    }

    // prediction
    if (this.activityData.type === constants.activity.types.PREDICTION) {
      this.activityData.imageUrl1 = null;
      this.activityData.imageUrl2 = null;
      this.activityData.value1Placeholder = null;
      this.activityData.value2Placeholder = null;
      this.activityData.rightOptionHint = null;
      this.activityData.rightOptionHintAr = null;
      this.previewActivity.previewPrediction = {
        name: null,
        option1: null,
        option2: null
      };
    }

    // question & guess
    if (this.activityData.type === constants.activity.types.QUESTION || this.activityData.type === constants.activity.types.GUESS) {
      this.activityData.imageUrl2 = null;
      this.activityData.qOptions = [];
      this.activityData.rightOption = null;
      this.previewActivity.previewQuestion = {
        name: null,
        options: [],
        imageUrl: null,
        showAnswers: true,
        correction: false,
      };
    }

    // questions
    if (this.activityData.type === constants.activity.types.QUESTIONNAIRE || this.activityData.type === constants.activity.types.SURVEY) {
      this.activityData.imageUrl2 = null;
      this.activityData.questions = null;
      this.previewActivity.previewQuestions = {
        questions: [],
        questionIds: [],
        gameTime: 0,
        correction: false,
        minCorrectAnswers: 0,
      };
      this.previewActivity.previewBasics = {
        title: this.activityData.title,
        imageUrl: this.activityData.imageUrl
      }
    }

    // cta2
    this.activityData.s2Link = null;
    this.activityData.s2ImageUrl = null
    this.activityData.videoUrl = null;
    this.previewActivity.previewCta2 = {
      linkText: null,
      link: null,
      description: null,
      imageUrl: null,
      videoUrl: null,
      show: false,
    };

    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
    this.timeoutHandler = setTimeout(() => {
      if (this.refActivityView) {
        this.refActivityView.reloadPreview(this.previewActivity);
      }
      this.timeoutHandler = null;
    }, 200);
  };

  loadConfig = (activityData) => {
    const oldFetchedConfigsForType = this.state.fetchedConfigsForType;
    const oldFetchedConfigsForSubType = this.state.fetchedConfigsForSubType;
    const type = activityData.type;
    const subType = activityData.subType;
    if (oldFetchedConfigsForType !== type || oldFetchedConfigsForSubType !== subType) {
      setTimeout(() => {
        this.resetToNewData(activityData);
        const typeId = ""+ type + (activityData.subType ? "-"+ activityData.subType : '');
        const activity = this.newActivityConfigs[typeId];

        // this.oldActivity = activity;
        this.activityData.gameInfo = activity.gameInfo;
        ApiHelper.processActivityGameInfoConfigs(this.activityData);
        this.activityData.activityConfigs = activity.activityConfigs;
        this.activityData.mediaConfigs = activity.mediaConfigs;
        this.activityData.noVCodesAllowed = activity.noVCodesAllowed;
        this.activityData.adInfo = activity.adInfo;
        this.activityData.planId = activity.adInfo.plans[0].id;
        this.activityData.planType = activity.adInfo.plans[0].type;
        this.activityData.contentTypes = activity.contentTypes;
        this.activityData.themeColor = activity.themeColor;
        this.activityData.guideMessage = activity.guideMessage;

        this.activityData.endInDay = activity.endInDay;
        this.activityData.consumeLimit = activity.consumeLimit;
        this.activityData.consumeLimitPerUser = activity.consumeLimitPerUser;
        this.activityData.gameRows = activity.gameRows;
        this.activityData.gameColumns = activity.gameColumns;
        this.activityData.gameSColumns = activity.gameSColumns;
        this.activityData.gameTime = activity.gameTime;
        this.activityData.flipsNeeded = activity.flipsNeeded;
        this.activityData.deadCount = activity.deadCount;
        this.activityData.winnersBy = activity.winnersBy;
        this.activityData.winnersByValue = activity.winnersByValue;

        this.processDummyValues();
        this.createPreviewActivity(true);
        this.processTabs();
        this.processPreviewActivityShowHideSubView();
        this.setState({fetchedConfigsForType: type, fetchedConfigsForSubType: subType});
        if (this.type) {
          this.onClickNext();
        }
      });
    }
    if (this.props.isXS && !this.fromLanding) {
      setTimeout(() => {
        this.toggleShowPreview();
      });
    }
  }

  onDialogPreviewPositiveClicked = () => {
    this.hideDialog();
    this.onClickNext();
  }

  moveToIndex = (index, highlightErrors = false) => {
    this.setState({enableAction: false, selectedDotIndex: index}, () => {
      this.processPreviewActivityShowHideSubView();
      if (highlightErrors && this.moveNextCallback && this.moveNextCallback.highlightErrors) {
        this.moveNextCallback.highlightErrors();
      }
      this.setState({enableAction: true});
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    });
  }

  onClickSaveNExit = (event) => {
    if (event) {
      event.target.blur();
    }
    const {subTabs, selectedDotIndex} = this.state;
    if (this.moveNextCallback) {
      const data = this.moveNextCallback.getData();
      if (data) {
        this.errorIndexes.delete(selectedDotIndex);
        if (data.dirty) {
          this.dirtyIndexes.add(selectedDotIndex);
        } else {
          this.dirtyIndexes.delete(selectedDotIndex);
        }
        delete data.dirty;

        if (this.errorIndexes.size > 0) {
          const [errorIndex] = this.errorIndexes;
          this.errorIndexes.delete(errorIndex);
          this.moveToIndex(errorIndex, true);
        } else if (this.showCharge && selectedDotIndex !== subTabs.length - 2) {
          this.moveToIndex(subTabs.length - 2, true);
        } else {
          this.processSave();
        }
      }
    }
    if (this.props.activities.activity.errMsg) {
      this.props.resetManageActivityErrMsg();
    }
  }

  onClickNext = (event) => {
    if (event) {
      event.target.blur();
    }
    const {subTabs, selectedDotIndex} = this.state;
    if (this.moveNextCallback) {
      const data = this.moveNextCallback.getData();
      if (data) {
        this.errorIndexes.delete(selectedDotIndex);
        if (data.dirty) {
          this.dirtyIndexes.add(selectedDotIndex);
        } else {
          this.dirtyIndexes.delete(selectedDotIndex);
        }
        delete data.dirty;
        if (subTabs[selectedDotIndex].id === TAB_PLAN) {
          this.assignNewData(data);
          this.processTabs(this.processNext.bind(this, data));
        } else {
          this.processNext(data);
        }
      } else {
        this.errorIndexes.add(selectedDotIndex);
      }
    }
    if (this.props.activities.activity.errMsg) {
      this.props.resetManageActivityErrMsg();
    }
  };

  processNext = (data) => {
    const {subTabs, selectedDotIndex} = this.state;
    let updateActivityData = true;
    if (!this.isEditing()) {
      if (subTabs[selectedDotIndex].id === TAB_USAGE) {
        const oldUType = this.activityData.usageType;
        const newUType = data.usageType;
        // if (oldUType !== newUType) {
          updateActivityData = false;
          this.state.fetchedConfigsForType = 0;
          this.state.fetchedConfigsForSubType = 0;
          this.resetToNewData(data);
        // }
      } else if (subTabs[selectedDotIndex].id === TAB_LIBRARY) {
        this.removeDummyValues();
        this.processPreviewActivity();
        this.processPreviewActivityShowHideSubView();
        const oldType = this.activityData.type;
        const oldSubType = this.activityData.subType;
        const newType = data.type;
        const newSubType = data.subType;
        if (oldType !== newType || oldSubType !== newSubType) {
          updateActivityData = false;
          this.resetToNewData(data);
          setTimeout(() => {
            this.processTabs();
          });
        }
      }
    }

    if (updateActivityData) {
      this.assignNewData(data);
    }
    // testing payment in dev mode directly
    // if (subTabs[selectedDotIndex].id === TAB_PRICE) {
    //   this.activityData.tokenId = 'tok_dXVf3241914hIzC18Gs1G973';
    //   this.activityData.saveCard = 1;
    //   this.processSave();
    //   return;
    // }
    if (selectedDotIndex === subTabs.length - 1 || (subTabs[selectedDotIndex].id === TAB_PRICE && data.planPay === 0)) {
      this.processSave();
    } else {
      this.moveToIndex(this.state.selectedDotIndex + 1);
    }
  };

  processSave = () => {
    if (this.activityData.planPay > 0 && this.props.user.registerType) {
      this.saveActivityData();
      return;
    }

    const lastTab = this.state.subTabs[this.state.subTabs.length-1].id;
    let titleId = this.isEditing() ? 'admin.activity.updateCampaignQ' : 'admin.activity.addCampaignQ';
    if (lastTab === TAB_PRICE || lastTab === TAB_PAYMENT) {
      titleId = 'campaign.publishCampaign';
    }
    let messageId = null;
    let okTextId = 'generic.proceed';
    let moveToJoinRab7 = false;
    if (this.shouldMoveToPlanAfterSave) {
      titleId = null;
      messageId = null;
    } else if (this.activityData.id && !this.props.user.registerType) {
      moveToJoinRab7 = true;
      okTextId = 'login.joinRab7Short';
      messageId = 'activity.prepareCampaignAfterJoin';
    }
    if (this.activityData && (this.activityData.type === constants.activity.types.OFFER
      || this.activityData.type === constants.activity.types.DISCOUNT
      || this.activityData.type === constants.activity.types.VOUCHER)) {
      titleId = this.isEditing() ? 'admin.activity.updateRewardQ' : 'admin.activity.addRewardQ';
      messageId = null;
    }
    if (this.activityData.planPay > 0) {
      // if (isCurrentPlanEnded(this.activityData.ad)) {
      //   titleId = 'activity.manage.proceedPaymentRenewQ';
      //   messageId = 'activity.manage.proceedPaymentRenewMessage';
      //   okTextId = 'activity.manage.payNow';
      // } else if (isCurrentPlanPaid(this.activityData.ad)) {
      //   titleId = 'activity.manage.proceedPaymentExtendQ';
      //   messageId = 'activity.manage.proceedPaymentExtendMessage';
      // } else {
      //   titleId = 'activity.manage.proceedPaymentQ';
      //   messageId = 'activity.manage.proceedPaymentMessage';
      // }
    }
    if (titleId) {
      let renderContent = null;
      if (moveToJoinRab7) {
        renderContent = () => {
          return <JoinNow
            history={this.props.history}
            uiConfigs={{
              overlayTitleColor: ColorTitle,
              overlaySubTitleColor: ColorSecondary,
              overlayBgColor: ColorWhite,
              actionBgColor: ColorTheme,
              actionTitleColor: ColorWhite
            }}
            onDone={this.onJoinRab7Done}
            isLTR={this.props.app.isLTR}
            maxWidth={window.appWidth - 40}
            title={locString('login.joinRab7Short')}
            subTitle={locString('activity.prepareCampaignAfterJoin')}
            showNegativeAction={true}
          />
        }
      }
      this.showDialog({
        title: !moveToJoinRab7 ? <FormattedMessage id={titleId}/> : null,
        message: messageId && !moveToJoinRab7 ? <FormattedHTMLMessage id={messageId}/> : null,
        positiveText: !moveToJoinRab7 ? <FormattedMessage id={okTextId}/> : null,
        neutralText: !moveToJoinRab7 ? <FormattedMessage id={'generic.cancel'}/> : null,
        onPositiveClicked: this.onSaveOkClicked,
        onNeutralClicked: this.hideDialog,
        renderContent: renderContent,
        fullScreen: moveToJoinRab7 && this.props.isXS,
        marginTop: moveToJoinRab7 && this.props.isXS ? window.appHeight - 600 : 0
      });
    } else {
      // if (moveToJoinRab7) {
      //   this.onMoveToJoinRab7();
      // } else {
        this.onSaveOkClicked();
      // }
    }
  }

  onEditPreviousClicked = (event) => {
    // this.blockNavToLastIndex = false;
    if (this.blockNavToLastIndex) {
      this.onBackClicked();
      return;
    }
    this.onClickPrevious(event);
  };

  onClickPrevious = (event) => {
    if (event) {
      event.target.blur();
    }
    const {selectedDotIndex, subTabs} = this.state;

    if (this.moveNextCallback) {
      const data = this.moveNextCallback.getData();
      if (data) {
        this.errorIndexes.delete(selectedDotIndex);
        if (data.dirty) {
          this.dirtyIndexes.add(selectedDotIndex);
        } else {
          this.dirtyIndexes.delete(selectedDotIndex);
        }
        delete data.dirty;
      } else {
        this.errorIndexes.add(selectedDotIndex);
      }
    }

    if (selectedDotIndex === 0) {
      this.onBackClicked();
    } else if (!this.isEditing() && selectedDotIndex === 1) {
      this.showLeaveDialog(true);
    } else {
      this.moveToIndex(this.state.selectedDotIndex - 1);

      if (this.props.activities.activity.errMsg) {
        this.props.resetManageActivityErrMsg();
      }
    }
  };

  saveActivityData() {
    const lastTabId = this.state.subTabs[this.state.subTabs.length-1].id;
    const message = lastTabId === TAB_PRICE || lastTabId === TAB_PAYMENT ? 'activity.preparingCampaign' : 'activity.savingCampaign';
    this.setState({isBlockedLoading: true, loaderMessage: locString(message), loadingProgress: 0}, () => {
      this.processPreviewActivityShowHideSubView();
    });

    const activityData = cloneDeep(this.activityData);
    let data = {
      type: activityData.type,
      subType: activityData.subType,
      usageType: activityData.usageType,
      startAt: activityData.startAt.toJSON(),
      endAt: activityData.endAt.toJSON(),
      title: activityData.title,
      endInDay: activityData.endInDay ? activityData.endInDay : 0,
    };
    if (activityData.themeColor) {
      data.themeColor = activityData.themeColor;
    }
    if (activityData.showcase) {
      data.showcase = 1;
    }
    // if (!data.title) {
    //   if (activityData.type === constants.activity.types.QUESTION) {
    //     data.title = data.qTitle;
    //   }
    //   else {
        const businessName = activityData.userName || activityData.business.name;
        const rewardTitle = activityData.slotValues && activityData.slotValues.length > 0
        && activityData.slotValues[0].offers && activityData.slotValues[0].offers.length > 0 ? activityData.slotValues[0].offers[0].title : null;
        data.title = rewardTitle || ApiHelper.getActivityDefaultTitle(businessName, activityData.type, activityData.gameInfo, this.context.intl);
    //   }
    // }
    if (activityData.planId) {
      data.planId = activityData.planId;
      data.planType = activityData.planType;
      if (activityData.planType === constants.activity.plans.PAID_PLAN) {
        if (activityData.planViews) {
          data.planViews = activityData.planViews;
          data.planDailyViews = activityData.planDailyViews;
          data.planDuration = activityData.planDuration;
          data.planPrice = activityData.planPrice;
          data.planPay = activityData.planPay;
          if (activityData.planPayPoints > 0) {
            data.planPayPoints = activityData.planPayPoints;
            data.planPayPointsValue = activityData.planPayPointsValue;
          }
        }
        if (activityData.cardId) {
          data.cardId = activityData.cardId;
        }
        if (activityData.tokenId) {
          data.tokenId = activityData.tokenId;
          data.saveCard = activityData.saveCard ? 1 : 0;
        }
        if (activityData.billingName) {
          data.billingName = activityData.billingName;
        }
      }
    }
    if (activityData.isImageDeleted) {
      data.isImageDeleted = activityData.isImageDeleted;
    }
    if (activityData.isLinkOnly) {
      data.isLinkOnly = activityData.isLinkOnly;
    }
    data.hasTargeting = 0;
    data.questionId = 0;
    // paid stuff
    if (data.planType === PLAN_TYPE_PAID) {
      if (activityData.inQuestion && activityData.inQuestion.qTitle) {
        data.inQuestion = JSON.stringify(activityData.inQuestion);
      }
      if (activityData.inReward) {
        let inReward = cloneDeep(activityData.inReward);
        delete inReward.newVoucher;
        delete inReward.mediaUrl;
        delete inReward.mediaType;
        delete inReward.mediaTUrl;
        delete inReward.initialMediaFiles;
        delete inReward.initialFiles;
        if (inReward.type === constants.activity.types.VOUCHER) {
          inReward.type = constants.activity.types.OFFER;
          inReward.consumableAt = 10;
        } else {
          inReward.consumableAt = 0;
        }
        data.inReward = JSON.stringify(inReward);
        data.referralRewardSame = 0;
        if (activityData.referralRewardSame) {
          data.referralRewardSame = 1;
        }
      }

      if (activityData.sName) {
        data.sName = activityData.sName;
      }
      if (activityData.sLink) {
        data.sLink = activityData.sLink;
      }
      if (activityData.s2LinkText) {
        data.s2LinkText = activityData.s2LinkText;
      }
      if (activityData.s2Link) {
        data.s2Link = activityData.s2Link;
      }
      if (activityData.referralWinPoints) {
        data.referralWinPoints = activityData.referralWinPoints;
      }
      // if (activityData.referralWinFun) {
      //   data.referralWinFunId = activityData.referralWinFun.id;
      // }
      data.hasTargeting = 1;
      const userTargeting = activityData.userTargeting;
      if (userTargeting) {
        data.hasTargeting = 1;
        // data.targetingState = constants.activity.state.DELETE;
        // if (userTargeting) {
          data.targetingState = userTargeting.targetingState;
          if (userTargeting.targetingState === constants.activity.state.ACTIVE) {
            data.isUserTargeted = userTargeting.isUserTargeted;
            if (userTargeting.branchIds && userTargeting.branchIds.length > 0) {
              data.branchIds = userTargeting.branchIds;
            }
            if (userTargeting.cUserIds && userTargeting.cUserIds.length > 0) {
              data.cUserIds = userTargeting.cUserIds;
            }
            if (!userTargeting.isUserTargeted) {
              if (userTargeting.cCountryIds && userTargeting.cCountryIds.length > 0) {
                data.cCountryIds = userTargeting.cCountryIds;
              }
              if (userTargeting.cRegionIds && userTargeting.cRegionIds.length > 0) {
                data.cRegionIds = userTargeting.cRegionIds;
              }
              if (userTargeting.cLocalityIds && userTargeting.cLocalityIds.length > 0) {
                data.cLocalityIds = userTargeting.cLocalityIds;
              }
              if (userTargeting.cSubLocalityIds && userTargeting.cSubLocalityIds.length > 0) {
                data.cSubLocalityIds = userTargeting.cSubLocalityIds;
              }
              if (userTargeting.cGeofences && userTargeting.cGeofences.length > 0) {
                const effGeofences = [];
                userTargeting.cGeofences.forEach((item) => {
                  effGeofences.push(JSON.stringify(item));
                });
                data.cGeofences = effGeofences;
              }
              if (userTargeting.cGender) {
                data.cGender = userTargeting.cGender;
              }
              if (userTargeting.cAgeGroups && userTargeting.cAgeGroups.length > 0) {
                data.cAgeGroups = userTargeting.cAgeGroups;
              }
              if (userTargeting.cNationalityIds && userTargeting.cNationalityIds.length > 0) {
                data.cNationalityIds = userTargeting.cNationalityIds;
              }
              if (userTargeting.cCompanyIds && userTargeting.cCompanyIds.length > 0) {
                data.cCompanyIds = userTargeting.cCompanyIds;
              }
              if (userTargeting.cVisits && userTargeting.cVisits.length > 0) {
                const effVisits = [];
                userTargeting.cVisits.forEach((item) => {
                  effVisits.push(JSON.stringify(item));
                });
                data.cVisits = effVisits;
              }
              if (userTargeting.cSpends && userTargeting.cSpends.length > 0) {
                const effSpends = [];
                userTargeting.cSpends.forEach((item) => {
                  effSpends.push(JSON.stringify(item));
                });
                data.cSpends = effSpends;
              }
              if (userTargeting.cQuestions && userTargeting.cQuestions.length > 0) {
                const effQuestions = [];
                userTargeting.cQuestions.forEach((item) => {
                  if (item.options && item.options.length > 0) {
                    const newItem = {
                      id: item.id,
                      options: item.options
                    }
                    effQuestions.push(JSON.stringify(newItem));
                  }
                });
                data.cQuestions = effQuestions;
              }
            }
          }
        // }
      }
      if (activityData.type === constants.activity.types.QUESTION) {
        data.showAnswers = activityData.showAnswers ? 1 : 0;
      }
    }
    if (activityData.id) {
      data.id = activityData.id;
    }
    if (activityData.titleAr) {
      data.titleAr = activityData.titleAr;
    }
    if (activityData.link) {
      data.link = activityData.link;
    }
    if (activityData.linkAr) {
      data.linkAr = activityData.linkAr;
    }
    if (activityData.linkText) {
      data.linkText = activityData.linkText;
    }
    if (activityData.linkTextAr) {
      data.linkTextAr = activityData.linkTextAr;
    }
    if (activityData.description) {
      data.description = activityData.description;
    }
    if (activityData.descriptionAr) {
      data.descriptionAr = activityData.descriptionAr;
    }
    if (activityData.tnc) {
      data.tnc = activityData.tnc;
    }
    if (activityData.tncAr) {
      data.tncAr = activityData.tncAr;
    }
    if (activityData.feedbackHint) {
      data.feedbackHint = activityData.feedbackHint;
    }
    if (activityData.feedbackHintAr) {
      data.feedbackHintAr = activityData.feedbackHintAr;
    }
    if (activityData.onlyBirthday) {
      data.onlyBirthday = 1;
    }
    // loyalty rewards
    if (activityData.loyaltyRewards && activityData.loyaltyRewards.length > 0) {
      data.loyaltyRewardIds = getArrayOfIds(activityData.loyaltyRewards);
    }

    // points conditions
    if (activityData.type === constants.activity.types.OFFER
      || activityData.type === constants.activity.types.SLIDES
      || activityData.type === constants.activity.types.SHOWCASE_MENU
      || activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.SOCIAL_CONTENT
      || activityData.type === constants.activity.types.QUESTION
      || activityData.type === constants.activity.types.BUYER_OPINION
      || activityData.type === constants.activity.types.VISITOR_OPINION
      || activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GUESS
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.EVENT
      || activityData.type === constants.activity.types.EXTERNAL_GAMES) {
      if (activityData.checkRab7Points) {
        data.checkRab7Points = 1;
      }
      if (activityData.pointsNeeded) {
        data.pointsNeeded = ValueHelper.getEnglishValue(activityData.pointsNeeded);
      }
      if (activityData.fee) {
        data.fee = ValueHelper.getEnglishValue(activityData.fee);
      }
      if (activityData.consumedPoints) {
        data.consumedPoints = ValueHelper.getEnglishValue(activityData.consumedPoints);
      }
      if (activityData.rewardedOffer) {
        data.rewardedOfferId = activityData.rewardedOffer.id;
      }
    }
    // referral win
    if (activityData.type === constants.activity.types.SLIDES
      || activityData.type === constants.activity.types.SHOWCASE_MENU
      || activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.SOCIAL_CONTENT
      || activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GUESS
      || activityData.type === constants.activity.types.QUESTION
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.EXTERNAL_GAMES) {
      if (activityData.referralWinPoints) {
        data.referralWinPoints = ValueHelper.getEnglishValue(activityData.referralWinPoints);
      }
      // if (activityData.referralWinFun) {
      //   data.referralWinFunId = activityData.referralWinFun.id;
      // }
    }
    if (activityData.type === constants.activity.types.SLIDES
      || activityData.type === constants.activity.types.SHOWCASE_MENU
      || activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GUESS
      || activityData.type === constants.activity.types.QUESTION
      || activityData.type === constants.activity.types.VISITOR_OPINION
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.SOCIAL_CONTENT
      || activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.EXTERNAL_GAMES
    ) {
      const slotGameValues = [];
      // for (let i = 0; i < activityData.slotValues.length; i++) {
      //   const item = activityData.slotValues[i];
      //   if (item.id <= 0 && i >= this.activityData.activityConfigs.slotMaxValues) {
      //   }
      //
      //   const model = {
      //     'number': ValueHelper.getEnglishValue(item.number),
      //     'points': ValueHelper.getEnglishValue(item.points),
      //     'value1': ValueHelper.getEnglishValue(item.value1),
      //     'offerIds': getArrayOfIds(item.offers),
      //     'winLimit': ValueHelper.getEnglishValue(item.winLimit),
      //     'winILimit': ValueHelper.getEnglishValue(item.winILimit)
      //   };
      //   if (item.id) {
      //     model.id = item.id;
      //   }
      //   slotGameValues.push(JSON.stringify(model));
      // }

      activityData.slotValues.forEach((item) => {
        const model = {
          'id': ValueHelper.getEnglishValue(item.id),
          'number': ValueHelper.getEnglishValue(item.number),
          'points': ValueHelper.getEnglishValue(item.points),
          'value1': ValueHelper.getEnglishValue(item.value1),
          'name': ValueHelper.getEnglishValue(item.name),
          'offerIds': getArrayOfIds(item.offers),
          'winLimit': ValueHelper.getEnglishValue(item.winLimit),
          'winILimit': ValueHelper.getEnglishValue(item.winILimit)
        };
        if (item.id) {
          model.id = item.id;
        }
        slotGameValues.push(JSON.stringify(model));
      });
      data.slotGameValues = slotGameValues;
    }
    // show winners
    // if (activityData.type === constants.activity.types.JACKPOT
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_ROULETTE
    //   || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
    //   || activityData.type === constants.activity.types.GAME_FLIP_CARD
    //   || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //   || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    //   || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
    //   || activityData.type === constants.activity.types.GAME_POKER
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_PUZZLE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
    //   || activityData.type === constants.activity.types.GAME_BRAND_RACE
    //   || activityData.type === constants.activity.types.GUESS
    //   || activityData.type === constants.activity.types.QUESTION
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE
    //   || activityData.type === constants.activity.types.LIKE_USER
    //   || activityData.type === constants.activity.types.COLLECT_STARS
    //   || activityData.type === constants.activity.types.SOCIAL_CONTENT
    //   || activityData.type === constants.activity.types.CHALLENGE
    //   || activityData.type === constants.activity.types.PREDICTION
    //   || activityData.type === constants.activity.types.IDENTIFY_LOCATION
    // ) {
    //   data.showWinners = activityData.showWinners ? 1 : 0;
    // }
    data.showWinners = 1;
    if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
      data.correction = activityData.correction ? 1 : 0;
    }
    if (activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.QUESTION
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.EXTERNAL_GAMES
    ) {
      if (activityData.consumeLimit) {
        data.consumeLimit = ValueHelper.getEnglishValue(activityData.consumeLimit);
      }
      if (activityData.consumeLimitPerUser) {
        data.consumeLimitPerUser = ValueHelper.getEnglishValue(activityData.consumeLimitPerUser);
      }
      if (activityData.winLimitPerUser) {
        data.winLimitPerUser = ValueHelper.getEnglishValue(activityData.winLimitPerUser);
      }
    }
    if (activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.EXTERNAL_GAMES
    ) {
      if (activityData.consumeLimitPerDay) {
        data.consumeLimitPerDay = ValueHelper.getEnglishValue(activityData.consumeLimitPerDay);

        if (activityData.winGLimit) {
          data.winGLimit = ValueHelper.getEnglishValue(activityData.winGLimit);
        }
      }
      if (activityData.resetLimitPerUser || activityData.resetLimitPerUser === 0) {
        data.resetLimitPerUser = ValueHelper.getEnglishValue(activityData.resetLimitPerUser);
      }
    }
    if (activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
    ) {
      if (activityData.gameColumns) {
        data.gameColumns = ValueHelper.getEnglishValue(activityData.gameColumns);
      }
    }
    if (activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
    ) {
      if (activityData.gameRows) {
        data.gameRows = ValueHelper.getEnglishValue(activityData.gameRows);
      }
    }
    if (activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || this.activityData.type === constants.activity.types.GAME_BRAND_RACE) {
      if (activityData.gameSColumns) {
        data.gameSColumns = ValueHelper.getEnglishValue(activityData.gameSColumns);
      }
    }
    if (activityData.type === constants.activity.types.GAME_GREEDY_SPIN || activityData.type === constants.activity.types.GAME_BETTING_PIC) {
      if (activityData.value1Placeholder) {
        data.value1Placeholder = activityData.value1Placeholder;
      }
      if (activityData.value1PlaceholderAr) {
        data.value1PlaceholderAr = activityData.value1PlaceholderAr;
      }
    }
    if (activityData.type === constants.activity.types.EVENT || activityData.type === constants.activity.types.LIKE_USER || activityData.type === constants.activity.types.COLLECT_STARS) {
      data.winPoints = ValueHelper.getEnglishValue(activityData.winPoints);
    }
    if (activityData.type === constants.activity.types.LIKE_USER || activityData.type === constants.activity.types.COLLECT_STARS) {
      if (activityData.value1Placeholder) {
        data.value1Placeholder = activityData.value1Placeholder;
      }
      if (activityData.value1PlaceholderAr) {
        data.value1PlaceholderAr = activityData.value1PlaceholderAr;
      }
      data.topLikedCount = ValueHelper.getEnglishValue(activityData.topLikedCount);
      data.winLimit = ValueHelper.getEnglishValue(activityData.winLimit);
      data.winILimit = ValueHelper.getEnglishValue(activityData.winILimit);
      if (activityData.offer) {
        data.offerId = activityData.offer.id;
      }
      if (activityData.type === constants.activity.types.LIKE_USER) {
        data.winLimitPerUser = ValueHelper.getEnglishValue(activityData.winLimitPerUser);
      }
      if (activityData.type === constants.activity.types.COLLECT_STARS) {
        if (activityData.flipsNeeded) {
          data.flipsNeeded = ValueHelper.getEnglishValue(activityData.flipsNeeded);
        }
      }
    }
    if (activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.SOCIAL_CONTENT
      || activityData.type === constants.activity.types.VISITOR_OPINION) {
      if (activityData.contentTypes && activityData.contentTypes.length > 0) {
        data.contentTypes = activityData.contentTypes;
      }
    }
    if (activityData.type === constants.activity.types.SLIDES || activityData.type === constants.activity.types.SHOWCASE_MENU) {
      if (activityData.subPosts && activityData.subPosts.length > 0) {
        const subPosts = [];
        activityData.subPosts.forEach((subPost) => {
          const subPostL = AppUtils.clone(subPost);
          subPostL.isVideoDeleted = subPostL.isVideoDeleted ? 1 : 0;
          subPostL.isAudioDeleted = subPostL.isAudioDeleted ? 1 : 0;
          subPostL.isImageDeleted = subPostL.isImageDeleted ? 1 : 0;
          Object.keys(subPostL).forEach((key) => {
            if (key !== 'id' && key !== 'number' && key !== 'title' && key !== 'duration'
              && key !== 'isImageDeleted' && key !== 'isAudioDeleted' && key !== 'isVideoDeleted') {
              delete subPostL[key];
            }
          });
          // delete subPostL.videoUrl;
          // delete subPostL.videoFiles;
          // delete subPostL.audioUrl;
          // delete subPostL.audioFiles;
          // delete subPostL.imageUrl;
          // delete subPostL.imageFiles;
          // delete subPostL.mediaUrl;
          // delete subPostL.mediaFiles;
          subPosts.push(JSON.stringify(subPostL));
        });
        data.subPosts = subPosts;
      }
      if (activityData.deletesubPostIds && activityData.deletesubPostIds.length > 0) {
        data.deletesubPostIds = activityData.deletesubPostIds;
      }
    }
    if (activityData.type === constants.activity.types.SHOWCASE_MENU) {
      if (activityData.hourStartAt) {
        data.hourStartAt = activityData.hourStartAt.toJSON();
      }
      if (activityData.hourEndAt) {
        data.hourEndAt = activityData.hourEndAt.toJSON();
      }
      if (activityData.consumableWDays) {
        data.consumableWDays = activityData.consumableWDays;
      }
    }
    if (activityData.type === constants.activity.types.CHALLENGE || activityData.type === constants.activity.types.SOCIAL_CONTENT) {
      data.consumableAt = activityData.videoFromGallery ? 1 : 0;

      if (activityData.subPosts && activityData.subPosts.length > 0) {
        const subPosts = [];
        activityData.subPosts.forEach((subPost) => {
          const subPostL = AppUtils.clone(subPost);
          Object.keys(subPostL).forEach((key) => {
            if (key !== 'id' && key !== 'number' && key !== 'title' && key !== 'link' && key !== 'linkText'
              && key !== 'isImageDeleted' && key !== 'isAudioDeleted' && key !== 'isVideoDeleted') {
              delete subPostL[key];
            }
          });
          // delete subPostL.videoUrl;
          // delete subPostL.videoFiles;
          // delete subPostL.audioUrl;
          // delete subPostL.audioFiles;
          // delete subPostL.imageUrl;
          // delete subPostL.imageFiles;
          // delete subPostL.mediaUrl;
          // delete subPostL.mediaFiles;
          subPosts.push(JSON.stringify(subPostL));
        });
        data.subPosts = subPosts;
      }
      if (activityData.deletesubPostIds && activityData.deletesubPostIds.length > 0) {
        data.deletesubPostIds = activityData.deletesubPostIds;
      }
    } else if (activityData.type === constants.activity.types.OFFER) {
      data.consumableAt = activityData.consumableAt;
    }
    if (activityData.type === constants.activity.types.SLIDES
      || activityData.type === constants.activity.types.SHOWCASE_MENU
      || activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.QUESTION
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.EXTERNAL_GAMES
    ) {
      data.winnersBy = activityData.winnersBy;
    }
    if (activityData.winnersBy !== 0 && (activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.EXTERNAL_GAMES)
    ) {
      data.winnersByValue = activityData.winnersByValue;
    }
    if (activityData.type === constants.activity.types.SMART_AD) {
      if (activityData.displayLimitPerUser) {
        data.displayLimitPerUser = ValueHelper.getEnglishValue(activityData.displayLimitPerUser);
      }
    }
    if (activityData.type === constants.activity.types.EVENT) {
      if (activityData.clickLimit) {
        data.clickLimit = ValueHelper.getEnglishValue(activityData.clickLimit);
      }
      if (activityData.offer) {
        data.offerId = activityData.offer.id;
      }
    }
    if (activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.VISITOR_OPINION) {
      if (activityData.qTitle) {
        data.qTitle = activityData.qTitle;
      }
      if (activityData.value1Placeholder) {
        data.value1Placeholder = activityData.value1Placeholder;
      }
      if (activityData.value2Placeholder) {
        data.value2Placeholder = activityData.value2Placeholder;
      }
    }
    if (activityData.type === constants.activity.types.PREDICTION || activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      if (activityData.qTitleAr) {
        data.qTitleAr = activityData.qTitleAr;
      }
      if (activityData.rightOptionHint) {
        data.rightOptionHint = activityData.rightOptionHint;
      }
      if (activityData.rightOptionHintAr) {
        data.rightOptionHintAr = activityData.rightOptionHintAr;
      }
      if (activityData.actionMessage) {
        data.actionMessage = activityData.actionMessage;
      }
    }
    if (activityData.type === constants.activity.types.PREDICTION) {
      if (activityData.endAtA) {
        data.endAtA = activityData.endAtA.toJSON();
      }
    }
    if (activityData.type === constants.activity.types.GUESS) {
      if (activityData.rightOption) {
        data.rightOption = ValueHelper.getEnglishValue(activityData.rightOption);
      }
      if (activityData.correction) {
        data.correction = activityData.correction ? 1 : 0;
      }
      if (activityData.qTitle) {
        data.qTitle = activityData.qTitle;
      }
      if (activityData.qTitleAr) {
        data.qTitleAr = activityData.qTitleAr;
      }
      if (activityData.qOptions && activityData.qOptions.length > 0) {
        const qOptions = [];
        activityData.qOptions.forEach((qOption) => {
          qOptions.push(JSON.stringify(qOption));
        });
        data.qOptions = qOptions;
      }
    }
    if (activityData.type === constants.activity.types.QUESTIONNAIRE || activityData.type === constants.activity.types.SURVEY) {
      data.inChallenge = activityData.inChallenge ? 1 : 0;
      data.inTraining = activityData.inTraining ? 1 : 0;
      if (activityData.qTitle) {
        data.qTitle = activityData.qTitle;
      }
      if (activityData.gameTime) {
        data.gameTime = ValueHelper.getEnglishValue(activityData.gameTime);
      }
      if (activityData.adsFrequency) {
        data.adsFrequency = ValueHelper.getEnglishValue(activityData.adsFrequency);
      }
      if (activityData.adsActivities && activityData.adsActivities.length > 0) {
        data.adsActivityIds = getArrayOfIds(activityData.adsActivities);
      }

      if (activityData.questions && activityData.questions.length > 0) {
        const questions = [];
        activityData.questions.forEach((question) => {
          questions.push(JSON.stringify(question));
        });
        data.questions = questions;
      }
      if (activityData.deleteQuestionIds && activityData.deleteQuestionIds.length > 0) {
        data.deleteQuestionIds = activityData.deleteQuestionIds;
      }
    }
    if (activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
      if (activityData.flipsNeeded) {
        data.flipsNeeded = ValueHelper.getEnglishValue(activityData.flipsNeeded);
      }
      if (activityData.deadCount) {
        data.deadCount = ValueHelper.getEnglishValue(activityData.deadCount);
      }
      if (activityData.gameTime) {
        data.gameTime = ValueHelper.getEnglishValue(activityData.gameTime);
      }
    }
    if (activityData.type === constants.activity.types.GAME_MATCH_THREE || activityData.type === constants.activity.types.GAME_BRAND_RACE) {
      if (activityData.value1Placeholder) {
        data.value1Placeholder = activityData.value1Placeholder;
      }
      if (activityData.value1PlaceholderAr) {
        data.value1PlaceholderAr = activityData.value1PlaceholderAr;
      }
    }
    if (activityData.type === constants.activity.types.QUESTION) {
      if (activityData.qTitle) {
        data.qTitle = activityData.qTitle;
      }
      if (activityData.qTitleAr) {
        data.qTitleAr = activityData.qTitleAr;
      }
      if (activityData.qOptions && activityData.qOptions.length > 0) {
        const qOptions = [];
        activityData.qOptions.forEach((qOption) => {
          qOptions.push(JSON.stringify(qOption));
        });
        data.qOptions = qOptions;
      }
    }
    if (activityData.type === constants.activity.types.DISCOUNT || activityData.type === constants.activity.types.OFFER) {
      if (activityData.consumeLimit) {
        data.consumeLimit = ValueHelper.getEnglishValue(activityData.consumeLimit);
      }
      if (activityData.consumeLimitPerUser) {
        data.consumeLimitPerUser = ValueHelper.getEnglishValue(activityData.consumeLimitPerUser);
      }
      if (activityData.consumeLimitPerDay) {
        data.consumeLimitPerDay = ValueHelper.getEnglishValue(activityData.consumeLimitPerDay);
      }
      if (activityData.isTransferable) {
        data.isTransferable = activityData.isTransferable;
      }
      if (activityData.hourStartAt) {
        data.hourStartAt = activityData.hourStartAt.toJSON();
      }
      if (activityData.hourEndAt) {
        data.hourEndAt = activityData.hourEndAt.toJSON();
      }
      if (activityData.consumableWDays) {
        data.consumableWDays = activityData.consumableWDays;
      }
      if (activityData.type === constants.activity.types.OFFER) {
        if (activityData.isCodeNeeded) {
          data.isCodeNeeded = activityData.isCodeNeeded;
        }
      }
    }
    if (activityData.type === constants.activity.types.OFFER && activityData.isVoucher) {
      if (activityData.vouchers && activityData.vouchers.length > 0) {
        const vouchers = [];
        activityData.vouchers.forEach((voucher) => {
          if (voucher.id < 0) {
            const voucherL = {
              code: voucher.code,
              quantity: voucher.quantity
            }
            vouchers.push(JSON.stringify(voucherL));
          }
        });
        data.vouchers = vouchers;
      }
      if (activityData.deleteVoucherIds && activityData.deleteVoucherIds.length > 0) {
        data.deleteVoucherIds = activityData.deleteVoucherIds;
      }
    }

    // process selected images
    let files = [];
    if (activityData.bgAudioFiles && activityData.bgAudioFiles.length > 0) {
      files.push({'id': 'bgAudioFile', 'file': activityData.bgAudioFiles[0].file});
    }
    if (activityData.isBgAudioDeleted) {
      data.isBgAudioDeleted = 1;
    }
    if (activityData.imageFiles1 && activityData.imageFiles1.length > 0) {
      files.push({'id': 'imageFile1', 'file': activityData.imageFiles1[0].file});
    }
    if (activityData.isImageDeleted1) {
      data.isImage1Deleted = 1;
    }
    if (activityData.imageFiles2 && activityData.imageFiles2.length > 0) {
      files.push({'id': 'imageFile2', 'file': activityData.imageFiles2[0].file});
    }
    if (activityData.isImageDeleted2) {
      data.isImage2Deleted = 1;
    }
    if (activityData.imageActionFiles && activityData.imageActionFiles.length > 0) {
      files.push({'id': 'imageActionFile', 'file': activityData.imageActionFiles[0].file});
    }
    if (activityData.isImageActionDeleted) {
      data.isImageActionDeleted = 1;
    }
    if (activityData.gamePlayAudioFiles && activityData.gamePlayAudioFiles.length > 0) {
      files.push({'id': 'gamePlayAudioFile', 'file': activityData.gamePlayAudioFiles[0].file});
    }
    if (activityData.isGamePlayAudioDeleted) {
      data.isGamePlayAudioDeleted = 1;
    }
    if (activityData.qExcelFiles && activityData.qExcelFiles.length > 0) {
      files.push({'id': 'qFile', 'file': activityData.qExcelFiles[0].file});
    }
    if (activityData.qMediaZipFiles && activityData.qMediaZipFiles.length > 0) {
      files.push({'id': 'qMediaFile', 'file': activityData.qMediaZipFiles[0].file});
    }
    if (activityData.slotValues && activityData.slotValues.length > 0) {
      activityData.slotValues.forEach((slotValue) => {
        if (slotValue.imageFiles && slotValue.imageFiles.length > 0) {
          files.push({'id': 'slotGameImageFile' + slotValue.number, 'file': slotValue.imageFiles[0].file});
        }
        if (slotValue.isImageDeleted) {
          if (!data.slotGameImagesDeleted) {
            data.slotGameImagesDeleted = [];
          }
          data.slotGameImagesDeleted.push(slotValue.number);
        }
      });
    }
    if (activityData.subPosts && activityData.subPosts.length > 0) {
      activityData.subPosts.forEach((subPost) => {
        if (subPost.videoFiles && subPost.videoFiles.length > 0) {
          files.push({'id': 'subPostVideoFile' + subPost.number, 'file': subPost.videoFiles[0].file});
        } else if (subPost.audioFiles && subPost.audioFiles.length > 0) {
          files.push({'id': 'subPostAudioFile' + subPost.number, 'file': subPost.audioFiles[0].file});
        } else if (subPost.imageFiles && subPost.imageFiles.length > 0) {
          files.push({'id': 'subPostImageFile' + subPost.number, 'file': subPost.imageFiles[0].file});
        }
      });
    }

    if (data.planType === PLAN_TYPE_PAID
      || activityData.type === constants.activity.types.OFFER
      || activityData.type === constants.activity.types.DISCOUNT
      || activityData.type === constants.activity.types.VOUCHER) {
      if (activityData.imageFiles && activityData.imageFiles.length > 0) {
        files.push({'id': 'imageFile', 'file': activityData.imageFiles[0].file});
      }
    }
    if (data.planType === PLAN_TYPE_PAID) {
      if (activityData.videoFiles && activityData.videoFiles.length > 0) {
        files.push({'id': 'videoFile', 'file': activityData.videoFiles[0].file});
      }
      if (activityData.sImageFiles && activityData.sImageFiles.length > 0) {
        files.push({'id': 'sImageFile', 'file': activityData.sImageFiles[0].file});
      }
      if (activityData.s2ImageFiles && activityData.s2ImageFiles.length > 0) {
        files.push({'id': 's2ImageFile', 'file': activityData.s2ImageFiles[0].file});
      }
      if (activityData.inQuestion) {
        if (activityData.inQuestion.imageFiles2 && activityData.inQuestion.imageFiles2.length > 0) {
          files.push({'id': 'inQuestionImageFile2', 'file': activityData.inQuestion.imageFiles2[0].file});
        }
      }
      if (activityData.inReward) {
        if (activityData.inReward.videoFiles && activityData.inReward.videoFiles.length > 0) {
          files.push({'id': 'inRewardVideoFile', 'file': activityData.inReward.videoFiles[0].file});
        } else if (activityData.inReward.imageFiles && activityData.inReward.imageFiles.length > 0) {
          files.push({'id': 'inRewardImageFile', 'file': activityData.inReward.imageFiles[0].file});
        }
      }
    }
    if (activityData.isVideoDeleted) {
      data.isVideoDeleted = 1;
    }
    if (activityData.isSImageDeleted) {
      data.isSImageDeleted = 1;
    }
    if (activityData.isS2ImageDeleted) {
      data.isS2ImageDeleted = 1;
    }

    if (isUserImageDummy(this.props.user.imageUrl) || !this.props.user.name) {
      if (activityData.userName) {
        data.userName = activityData.userName;
      }
      if (activityData.userImageFiles && activityData.userImageFiles.length > 0) {
        files.push({'id': 'userImageFile', 'file': activityData.userImageFiles[0].file});
      }
    }

    let hasFiles = false;
    if (files && files.length > 0) {
      hasFiles = true;
      files.forEach((file) => {
        data[file.id] = file.file;
      });
    }
    this.uploadData(data, hasFiles);
  }

  uploadData(data, hasFiles = false) {
    const {user, history} = this.props;
    this.props.manageActivity(data.id, data, (progressEvent) => {
      if (hasFiles) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (this.state.loadingProgress !== percentCompleted) {
          this.setState({loadingProgress: percentCompleted});
        }
      }
    }).then((response) => {
      // setTimeout(() => {
        if (response.data) {
          if (response.data.userWallet) {
            this.props.updateUserWallet(response.data.userWallet);
          }
          if (response.data.userName || response.data.userImageUrl) {
            this.props.updateUserInfo(response.data.userName, response.data.userImageUrl);
          }
        }
      // }, 500);

      const planId = this.activityData.planId;
      const planType = this.activityData.planType;
      const planDuration = this.activityData.planDuration;
      const planViews = this.activityData.planViews;
      const planDailyViews = this.activityData.planDailyViews;
      const planPrice = this.activityData.planPrice;
      const planPayCurrency = this.activityData.planPayCurrency;
      const planPay = this.activityData.planPay;
      const planPayPoints = this.activityData.planPayPoints;
      const planPayPointsValue = this.activityData.planPayPointsValue;

      if (this.shouldMoveToPlanAfterSave && this.activityData.type !== constants.activity.types.SHOWCASE_MENU) {
        this.shouldMoveToPlanAfterSave = false;
        this.isInEdit = true;
        this.manageType = 2;
        this.showCharge = true;
        this.loadChargeIndexInitially = true;
        this.blockNavToLastIndex = true;
        this.stopHistoryListeners();
        this.props.history.replace({
          pathname: `${PathCampaignManage}/${response.data.id}`,
          search: '?p=2'
        });

        this.processActivityData(response.data);
        this.id = this.activityData.id;
        this.setState({isBlockedLoading: false, loaderMessage: null}, () => {
          this.startHistoryListeners();
        });

        return;
      }

      this.processActivityData(response.data);

      this.id = this.activityData.id;
      this.activityData.planId = planId;
      this.activityData.planType = planType;
      this.activityData.planDuration = planDuration;
      this.activityData.planViews = planViews;
      this.activityData.planDailyViews = planDailyViews;
      this.activityData.planPrice = planPrice;
      this.activityData.planPayCurrency = planPayCurrency;
      this.activityData.planPay = planPay;
      this.activityData.planPayPoints = planPayPoints;
      this.activityData.planPayPointsValue = planPayPointsValue;

      if (!user.registerType) {
        this.stopHistoryListeners();
        this.setState({isBlockedLoading: false}, () => {
          history.replace({
            pathname: PathJoin,
            search: getRedirectSearch({
              pathname: `${PathCampaignManage}/${this.activityData.id}`,
              search: '?p=2',
            }),
          });
        });
        return;
      }

      if (this.activityData.planPay > 0 && this.activityData.planRecharge) {
        this.stopHistoryListeners();
        this.props.history.replace({
          pathname: `${PathCampaignManage}/${this.activityData.id}`,
          search: '?rId='+ this.activityData.planRecharge.id
        });
        this.setState({isBlockedLoading: false, loaderMessage: null, isRedirected: false, selectedDotIndex: 0});
        if (this.activityData.planRecharge && this.activityData.planRecharge.paymentInfo && this.activityData.planRecharge.paymentInfo.transactionUrl) {
          setTimeout(() => {
            // this.props.history.push({
            //   pathname: PathPayment,
            //   state: {
            //     transactionUrl: this.activityData.planRecharge.paymentInfo.transactionUrl
            //   }
            // });
            this.props.history.push({
              pathname: PathPaymentStart,
              search: '?pUrl='+ this.activityData.planRecharge.paymentInfo.transactionUrl,
              state: {
                fromLocation: this.props.history.location,
              }
            });
          });
        } else {
          this.startHistoryListeners();
        }
      } else {
        this.activityData.isSuccess = true;
        this.setState({isBlockedLoading: false, isSuccess: true, selectedDotIndex: ActivityHelper.isReward(this.activityData.type) ? this.state.selectedDotIndex : 0});
        if (ActivityHelper.isReward(this.activityData.type)) {
          this.showDialog({
            title: locString('activity.manage.rewardUpdated'),
            positiveText: locString('generic.ok'),
            onPositiveClicked: this.navBackToList
          });
        } else {
          this.replaceLocationForSuccess();
        }
      }
    }).catch(() => {
      this.setState({isBlockedLoading: false});
    });
  }

}

ManageActivity.propTypes = {
  classes: PropTypes.object,
  location: PropTypes.object,
  app: PropTypes.object,
  isLoading: PropTypes.bool,
  isBlockedLoading: PropTypes.bool,
  user: PropTypes.object,
  activities: PropTypes.object,
  resetManageActivityErrMsg: PropTypes.func,
  manageActivity: PropTypes.func,
  fetchActivity: PropTypes.func,
  fetchActivityConfigs: PropTypes.func,
};

ManageActivity.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  const props =  {
    app: state.app,
    isLoading: state.isLoading,
    activities: state.admin.activities,
    user: state.admin.user,
  };
  if (state.router && state.router.location && state.router.location.state) {
    props.canGoBack = state.router.location.state.canGoBack;
    props.fromLocation = state.router.location.state.fromLocation;
  }
  return props;
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserWallet: (wallet) => dispatch(updateUserWallet(wallet)),
    updateUserInfo: (userName, userImageUrl) => dispatch(updateUserInfo(userName, userImageUrl)),
    resetManageActivityErrMsg: () => dispatch(resetManageActivityErrMsg()),
    manageActivity: (id, data, onUploadProgress) => dispatch(manageActivity(id, data, onUploadProgress)),
    fetchActivity: (id, detail, rechargeId, noLoading) => dispatch(fetchActivity(id, detail, 0, rechargeId, noLoading)),
    fetchActivityConfigs: (type) => dispatch(fetchActivity('new', true, type)),
    deleteActivityPlanRecharge: (id) => dispatch(deleteActivityPlanRecharge(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivity))
);
